export default {
    VIETNAMESE: "Tiếng Việt",
    ENGLISH: "English",
    JAPANESE: "日本語",
    KOREAN: "한국어",
    CHINESE: "中文",
    LAO: "ພາສາລາວ",
    KHMER: "ភាសាខ្មែរ", //tiếng campuchia
    SYNC: "ធ្វើសមកាលកម្ម",
    PLEASE_SELECT_DATE_LESS_6_MONTH: "សូមជ្រើសរើសចន្លោះថ្ងៃមិនលើស ៦ ខែ",
    //#region chainManager
    CHAIN_DASHBOARD_INFO: "ខ្សែបណ្តាញ",
    CHAIN_DASHBOARD: "ផ្ទាំងគ្រប់គ្រងខ្សែបណ្តាញ",
    BOOKING_DASHBOARD: "ផ្ទាំងគ្រប់គ្រងការកក់",
    USE_HOTEL: "ចូលប្រើ",
    //#endregion
    //#region alert
    CANCEL_SUCCESS: "បានធ្វើបច្ចុប្បន្នភាពដោយជោគជ័យ",
    BOOKING_PAID: "បានបង់ប្រាក់រួច",
    BOOKING_CANCELED: "ការកក់មិនអាចបោះបង់បានទេ សូមពិនិត្យមើលស្ថានភាពម្តងទៀត",
    LOCATION_IS_NOT_EXIST: "ស្រុកខ័ណ្ឌមិនមានទេ",
    ROOM_AVAILS_INCORRECT: "ចំនួនបន្ទប់ទំនេរមិនអាចលើសចំនួនបន្ទប់សរុបដែលបានបញ្ចូល",
    CANCLE_FAILE: "បោះបង់មិនបានជោគជ័យ",
    DELETE_FAILE: "លុបមិនបានជោគជ័យ",
    GROUP_USED: "ក្រុមអ្នកប្រើកំពុងប្រើប្រាស់",
    PROMOTION_NULL: "ការផ្តល់ជូនមិនមានទេ",
    TRANSDATE_INCORRECT: "កាលបរិច្ឆេទបង់ប្រាក់ត្រូវស្ថិតនៅចន្លោះថ្ងៃកក់និងថ្ងៃចេញ",
    AMOUNT_INCORRECT: "ចំនួនប្រាក់បង់មិនត្រឹមត្រូវ",
    LOCATION_NOT_EXIST: "ទីតាំងមិនមានទេ",
    UPDATE_SUCCESS: "បានធ្វើបច្ចុប្បន្នភាពដោយជោគជ័យ",
    UPDATE_CUCCESS: "បានធ្វើបច្ចុប្បន្នភាពដោយជោគជ័យ",
    UPDATE_FAILED: "បច្ចុប្បន្នភាពបរាជ័យ",
    DELETE_SUCCESS: "លុបបានជោគជ័យ",
    DELETE_FAILED: "លុបមិនបានជោគជ័យ",
    CREATE_SUCCESS: "បន្ថែមថ្មីបានជោគជ័យ",
    CREATE_FAILED: "បន្ថែមថ្មីបរាជ័យ",
    UPLOAD_SUCCESS: "បានធ្វើបច្ចុប្បន្នភាពដោយជោគជ័យ",
    UPLOAD_FAILED: "ផ្ទុកឡើងបរាជ័យ",
    REGISTER_SUCCESS: "ការចុះឈ្មោះបានជោគជ័យ",
    PROMOTIONS_ARE_BEING_USED: "ការផ្តល់ជូនកំពុងប្រើប្រាស់",
    PROMOTIONS_DO_NOT_BELONG_TO_HOTELS: "ការផ្តល់ជូនមិនអាចអនុវត្តលើសណ្ឋាគារនេះបានទេ",
    COUNPON_EXIST: "កូដបញ្ចុះតម្លៃមានរួចហើយ",
    USER_IS_EXIST: "គណនីបានមានរួចហើយ",
    EMAIL_USER_IS_EXIST: "អ៊ីមែលអ្នកប្រើមានរួចហើយ",
    EMAIL_HOTEL_IS_EXIST: "អ៊ីមែលសណ្ឋាគារមានរួចហើយ",
    USER_NAME_OR_EMAIL_IS_EXISTED: "ឈ្មោះអ្នកប្រើឬអ៊ីមែលមានរួចហើយ",
    ACCOUNT_IS_TAKEN: "ឈ្មោះអ្នកប្រើមានរួចហើយ",
    CANNOT_FIND_SOURCE: "រកមិនឃើញរូបភាព",
    IMAGE_CAPACITY_NOT_BIGGER_THAN: "ទំហំរូបភាពអាចផ្ទុកឡើងបានអតិបរមា៖",
    FILE_CAPACITY_NOT_BIGGER_THAN: "ទំហំឯកសារអាចផ្ទុកឡើងបានអតិបរមា៖",
    IMAGE_SIZE_NOT_BIGGER_THAN: "ទំហំរូបភាពអប្បបរមា",
    INVALID_IMAGE_FORMAT: "ទ្រង់ទ្រាយរូបភាពមិនត្រឹមត្រូវ",
    INVALID_FILE_FORMAT: "ទ្រង់ទ្រាយឯកសារមិនត្រឹមត្រូវ",
    DELETE_FAIL: "លុបរូបភាពបរាជ័យ",
    IMAGE_MAIN_EMPTY: "រកមិនឃើញរូបភាពសំខាន់",
    ROOM_EMPTY: "រកមិនឃើញបន្ទប់",
    ROOM_IS_SELECTING: "បន្ទប់កំពុងប្រើប្រាស់",
    NOT_SELECTED_PROMOTION: "មិនបានជ្រើសរើសកញ្ចប់បញ្ចុះតម្លៃណាមួយទេ",
    MISSING_FIELD: "សូមបញ្ចូលព័ត៍មានទាំងអស់ដែលចាំបាច់",
    CONFIRM_DELETE_PHOTOS: "បញ្ជាក់ការលុបរូបភាព",
    MAIN_IMAGES_MUST_EXIST: "ត្រូវមានរូបភាពសំខាន់នៅក្នុងបញ្ជី",
    CONFIRM_DELETE_POLICY: "បញ្ជាក់លុបគោលការណ៍",
    CONFIRM_DELETE_SALE_PACKAGE: "បញ្ជាក់លុបគោលការណ៍តម្លៃនេះ",
    CONFIRM_DELETE_PROMOTION_PACKAGE: "បញ្ជាក់លុបកញ្ចប់បញ្ចុះតម្លៃនេះ",
    CONFIRM_DELETE_ROOM: "បញ្ជាក់លុបបន្ទប់",
    SETTING_GATEWAY_EMPTY: "ការកំណត់ច្រកទូទាត់មិនមានទេ",
    DEPOSIT_COMPARE_PAYMENT: "ថ្ងៃផុតកំណត់បង់ប្រាក់ការកក់មិនអាចលើសថ្ងៃបង់ប្រាក់កក់បានទេ",
    UPLOAD_EXPIRED: "ផុតកំណត់ការផ្ទុកឡើង",
    PAYMENT_METHOD_HAS_NOT_SELECTED: "មិនទាន់ជ្រើសរើសវិធីសាស្ត្រទូទាត់ទេ",
    TIP_MAIN_IMAGE: "រូបភាពតំណាងសណ្ឋាគារជារូបភាពដំបូង។ អាចអូស - ទម្លាក់ដើម្បីផ្លាស់ប្តូរទីតាំងបង្ហាញ",
    TIP_MAIN_ROOM_IMAGE: "រូបភាពតំណាងបន្ទប់ជារូបភាពដំបូង។ អាចអូស - ទម្លាក់ដើម្បីផ្លាស់ប្តូរទីតាំងបង្ហាញ",
    CUSTOMER_PACKAGE_NOT_BIGGER_THAN_ROOM: "ចំនួនភ្ញៀវសរុបក្នុងកញ្ចប់មិនអាចលើសចំនួនអតិបរមានៃបន្ទប់បានទេ",
    USER_NOT_RIGHT: "គ្មានសិទ្ធិ",
    USER_IS_EXIST: "គណនីមានរួចហើយ",
    USER_NOT_EXIST: "គណនីមិនមានទេ",
    EMAI_IS_EXIST: "អ៊ីមែលមានរួចហើយ",
    ACTIVE_SUCCESS: "ធ្វើឲ្យសកម្មដោយជោគជ័យ",
    DEACTIVE_SUCCESS: "ផ្អាកការតភ្ជាប់ដោយជោគជ័យ",
    FIELD_NUMBER_FORMAT: "អនុញ្ញាតឲ្យបញ្ចូលតែលេខ បន្ទុកទទេមិនអនុញ្ញាត",
    FIELD_POSITIVE_FORMAT: "អនុញ្ញាតតែលេខគត់វិជ្ជមាន បន្ទុកទទេមិនអនុញ្ញាត",
    FIELD_DISTANCE_FORMAT: "អនុញ្ញាតតែលេខនិងចំណុច (.) បន្ទុកទទេមិនអនុញ្ញាត",
    TODAY: "ថ្ងៃនេះ",
    YESTERDAY: "ម្សិលមិញ",
    TOMORROW: "ស្អែកนี้",
    LOGIN_FAILED: "ចូលប្រើបរាជ័យ",
    HAS_NO_DATA: "មិនមានទិន្នន័យ",
    CHAIN_NAME_EMPTY: "មិនទាន់បង្កើតខ្សែបណ្តាញ",
    USER_IS_NOT_EXIT: "អ្នកប្រើមិនមានទេ",
    USER_IS_NOT_EXIST: "អ្នកប្រើមិនមានទេ",
    HOTEL_WAS_IN_CHAIN: "សណ្ឋាគារមានរួចនៅក្នុងខ្សែបណ្តាញ",
    FEEDBACK_SUCCESS: "ដាក់មតិដោយជោគជ័យ",
    AGENT_STOP_CONNECT: "ភ្នាក់ងារបញ្ឈប់ការតភ្ជាប់",
    //#endregion

    //#region common validate
    _VALIDATE: {
        REQUIRED: "សូមបញ្ចូលព័ត៍មានទាំងអស់ដែលចាំបាច់",
        EMAIL_FORMAT: "សូមពិនិត្យទ្រង់ទ្រាយអ៊ីមែលម្តងទៀត",
        MIN_LENGTH: "តម្លៃបញ្ចូលត្រូវច្រើនជាង {minLength} តួអក្សរ",
        MAX_LENGTH: "តម្លៃបញ្ចូលត្រូវតិចជាង {maxLength} តួអក្សរ",
        REQUIRED_AT_LEAST_ONE_HOTEL_OR_CHAIN: "សូមជ្រើសរើសយ៉ាងហោចណាស់មួយខ្សែបណ្តាញឬសណ្ឋាគារសម្រាប់អ្នកប្រើ"
    },
    //#endregion

    DESCRIPTION_INFO: "ព័ត៌មានពិពណ៌នា",
    REQUIRED: "*",
    SELECT_ALL: "ជ្រើសរើសទាំងអស់",
    IMAGES: "រូបភាព",
    HOTEL_PHOTO: "រូបភាពសណ្ឋាគារ",
    LIBRARY: "បណ្ណាល័យ",
    ADD_NEW: "បន្ថែមថ្មី",
    AND: "និង",
    BACK: "ត្រលប់ក្រោយ",
    SAVE: "រក្សាទុក",
    CONFIRM: "បញ្ជាក់",
    EDIT: "កែសម្រួល",
    DELETE: "លុប",
    COPY: "ចម្លង",
    POLICY: "គោលការណ៍",
    ALWAYS: "ជានិច្ច",
    IN_PERIOD: "នៅក្នុងចន្លោះ",
    GENERAL_SETTING: "ការកំណត់ទូទៅ",
    PAYMENT_POLICY: "គោលការណ៍ទូទាត់",
    CANCELATION_POLICY: "គោលការណ៍បោះបង់ការកក់",
    PAY_GATE: "ច្រកទូទាត់",
    WARNING_METHOD: "វិធីសាស្ត្រជូនដំណឹង",
    ALERT_RECEIVING_METHOD: "វិធីសាស្ត្រទទួលការជូនដំណឹង",
    SELECT_WARNING_METHOD: "ជ្រើសរើសវិធីសាស្ត្រទទួលការជូនដំណឹង",
    WARNING_QTY_ROOM: "ជូនដំណឹងនៅពេលចំនួនបន្ទប់ឈានដល់កម្រិត",
    SETTING_WARNING_ROOM: "ផ្ញើការជូនដំណឹងនៅពេលចំនួនបន្ទប់ឈានដល់កម្រិត",
    SEND_WARNING_ANY_ROOM: "ផ្ញើការជូនដំណឹងនៅពេលបន្ទប់ទំនេរនៃប្រភេទណាមួយតិចជាងកម្រិតដែលបានកំណត់",
    SEND_WARNING_ROOM: "ផ្ញើការជូនដំណឹងនៅពេលបន្ទប់ណាមួយមានចំនួនតិចជាងកម្រិតដែលបានកំណត់",
    QTY_ROOM_LESS_THAN: "ចំនួនបន្ទប់តិចជាង",
    HOTEL_WARNING: "វិធីសាស្ត្រជូនដំណឹង",
    SETTING_AT_LEAST_1_ROOM: "សូមជ្រើសរើសយ៉ាងហោចណាស់ ១ ប្រភេទបន្ទប់ ដើម្បីកំណត់កម្រិតជូនដំណឹង",
    // HOTEL INFOMATION
    REGISTER_INFO: "ព័ត៌មានចុះឈ្មោះ",
    EXTENSION: "អត្ថប្រយោជន៍",
    NEARBY_PLACE: "ទីកន្លែងនៅជិត",
    HOTEL_CHAIN: "ខ្សែបណ្តាញសណ្ឋាគារ",
    HOTEL_REGISTER_INFO: "ព័ត៌មានចុះឈ្មោះសណ្ឋាគារ",

    //#region Register infomation
    HOTEL_CODE: "កូដសណ្ឋាគារ",
    STAR_RATING: "ចំណាត់ថ្នាក់ផ្កាយ",
    HOTEL_LOGO: "ឡូហ្គោសណ្ឋាគារ",
    CONTACT_PHONE: "លេខទំនាក់ទំនង",

    HOTEL_TYPE: "ប្រភេទអាជីវកម្ម",
    COUNTRY: "ប្រទេស",
    CITY: "ខេត្ត / រាជធានី",
    DISTRICT: "តំបន់ / កន្ទង់ទាត់ / តារាងពិន័យ",
    WARD: "តំបន់",
    HOTEL_NAME: "ឈ្មោះសណ្ឋាគារ",
    ADDRESS: "អាសយដ្ឋាន",
    MAP_LOCATION: "ទីតាំងលើផែនទី",
    LONGITUDE: "រយៈទទឹង",
    LATITUDE: "រយៈបណ្តោយ",
    //#endregion

    // LEFT MENU
    DASHBOARD: "ផ្ទាំងគ្រប់គ្រង",
    MANAGE: "គ្រប់គ្រង",
    BOOK_ROOM: "កក់បន្ទប់",
    ROOM_SALE: "លក់បន្ទប់",
    ROOM_AVAILABLE_AND_PRICE: "បន្ទប់នៅว่าง និងតម្លៃ",
    SALE_AND_PROMOTION_PACKAGES: "គោលការណ៍តម្លៃ និងការផ្តល់ជូន",
    SETTING: "ការកំណត់",
    ACCOUNT_INFO: "ព័ត៌មានគណនី",
    ACCOUNT_SETTING: "គណនីផ្ទាល់ខ្លួន",
    USER_MANAGE: "គ្រប់គ្រងអ្នកប្រើ",
    CONTRACT: "កិច្ចសន្យា",
    HOTEL_INFOMATION: "ព័ត៌មានសណ្ឋាគារ",
    GENERAL_INFO: "ព័ត៌មានទូទៅ",
    TYPE_ROOM: "ព័ត៌មានប្រភេទបន្ទប់",
    HOTEL_CONFIG: "ការកំណត់រចនាសណ្ឋាគារ",
    GALLERY_MANAGER: "គ្រប់គ្រងវិចិត្រសាល",
    TRAVEL_AGENT: "ភ្នាក់ងារធ្វើដំណើរ",
    AGENT_LIST: "បញ្ជីភ្នាក់ងារ",
    UNLINKED_LIST: "ភ្នាក់ងារបញ្ឈប់សហការ",
    ACTIVITY_DAIRY: "កំណត់ហេតុសកម្មភាព",
    ACTIVITY_DIARY_UPDATE_BULK: "កំណត់ហេតុបច្ចុប្បន្នភាពតម្លៃ",
    ACTIVITY_DIARY_UPDATE_ROOM_AVAIL: "កំណត់ហេតុបច្ចុប្បន្នភាពបន្ទប់នៅទំនេរ",
    SUPPORT: "ជំនួយ",
    INSTRUCTION_DOCUMENT: "ឯកសារណែនាំប្រើប្រាស់",
    INSTRUCTION_DOCUMENT_CONNECT_BE: "បញ្ចូលគេហទំព័រ",
    COPYED: "បានចម្លង",
    VIEW_DEMO: "មើលទំព័រកក់បន្ទប់",
    HOTLINE: "លេខទូរស័ព្ទបន្ទាន់",
    BOOKING_LIST: "បញ្ជីការកក់បន្ទប់",
    REQUEST_BOOKING_LIST: "បញ្ជីសំណើរកក់បន្ទប់",
    REVENUE_AND_EXPENDITURE_TRANSACTION: "ប្រតិបត្តិការរូបិយវត្ថុចំណូល និងចំណាយ",
    PREVIEW_ON_BE: "មើលទំព័រកក់បន្ទប់",
    PREVIEW_ON_TA: "មើលទំព័រភ្នាក់ងារ",
    SALE_CHANNEL: "ឆានែលលក់",
    CHANNEL_GROUP: "ក្រុមឆានែលលក់",
    // END LEFT MENU
    SUNDAY: "អាទិត្យ",
    MONDAY: "ច័ន្ទ",
    TUESDAY: "អង្គារ",
    WEDNESDAY: "ពុធ",
    THURSDAY: "ព្រហស្បតិ៍",
    FRIDAY: "សុក្រ",
    SATURDAY: "សៅរ៍",

    _DATE_RANGE: {
        SUNDAY: "អា",
        MONDAY: "ច",
        TUESDAY: "អ",
        WEDNESDAY: "ព",
        THURSDAY: "ព្រ",
        FRIDAY: "សុ",
        SATURDAY: "សៅ",
        JAN: "មករា",
        FEB: "កុម្ភៈ",
        MAR: "មិនា",
        APR: "មេសា",
        MAY: "ឧសភា",
        JUN: "មិថុនា",
        JUL: "កក្កដា",
        AUG: "សីហា",
        SEP: "កញ្ញា",
        OTC: "តុលា",
        NOV: "វិច្ឆិកា",
        DEC: "ធ្នូ"
    },

    // Begin Roles

    /* beautify preserve:start */
    _ROLES: {
        CHAIN: "ខ្សែសង្វាក់",
        BOOKING_CHAIN: "ការកក់ក្នុងខ្សែសង្វាក់",
        CHAIN_LIST: "បញ្ជីខ្សែសង្វាក់",
        USER_MANAGEMENT: "ការគ្រប់គ្រងអ្នកប្រើប្រាស់",
        // USER_GROUP: "USER_GROUP",
        DASHBOARD: "ផ្ទាំងគ្រប់គ្រង",
        MANAGE: "គ្រប់គ្រង",
        BOOKING_HOTEL: "ការកក់សណ្ឋាគារ",
        ROOM_SALE: "លក់បន្ទប់",
        ROOM_SALE_MANAGEMENT: "គ្រប់គ្រងការលក់បន្ទប់",
        SALE_PACKAGE_MANAGEMENT: "គ្រប់គ្រងគោលការណ៍តម្លៃ",
        OTA_MANAGEMENT: "ezCms Vela",
        SETTING: "ការកំណត់",
        ACCOUNT_INFOMATION: "ព័ត៌មានគណនី",
        PERSONAL_ACCOUNT: "ព័ត៌មានផ្ទាល់ខ្លួន",
        GENERAL_INFORMATION: "ព័ត៌មានទូទៅ",
        HOTEL_AMENITY: "គ្រប់គ្រងអត្ថប្រយោជន៍",
        HOTEL_IMAGE: "គ្រប់គ្រងរូបភាព",
        NEARBY_PLACE: "គ្រប់គ្រងទីតាំងនៅជិត",
        ROOM_TYPE: "ព័ត៌មានប្រភេទបន្ទប់",
        ROOM_INFORMATION: "គ្រប់គ្រងព័ត៌មានបន្ទប់",
        ROOM_AMENITY: "គ្រប់គ្រងអត្ថប្រយោជន៍បន្ទប់",
        ROOM_IMAGE: "គ្រប់គ្រងរូបភាពបន្ទប់",
        HOTEL_CONFIGURATION: "កំណត់រចនាសម្ព័ន្ធសណ្ឋាគារ",
        GENERAL_CONFIGURATION: "កំណត់រចនាសម្ព័ន្ធទូទៅ",
        PAYMENT_POLICY: "កំណត់គោលការណ៍បង់ប្រាក់",
        CANCELLATION_POLICY: "កំណត់គោលការណ៍លើកលែង",
        IMAGE_LIBRARY: "កំណត់បណ្ណាល័យរូបភាព",
        HISTORY_LOG: "ប្រវត្តិប្រើប្រាស់ប្រព័ន្ធ",
        PAYMENT_METHOD: "វិធីសាស្រ្តបង់ប្រាក់",
        BOOKING_ENGINE: "ប្រព័ន្ធកក់",
        BOOKING_ENGINE_CONFIG: "ការកំណត់",
        HOTEL_EMAIL: "អ៊ីមែល",
        HOTEL_BOOKING_CONFIRM: "បញ្ជាក់ការកក់",
        HOTEL_SERVICE: "សេវាកម្ម",
        HOTEL_PROMOTION: "ប្រមូសិន",
        HOTEL_INFORMATION: "ព័ត៌មានសណ្ឋាគារ",
        BOOKING_MANAGEMENT: "ការកក់",
        SYNC_MANAGEMENT: "គ្រប់គ្រងការធ្វើសមកាលកម្ម",
        HEADER_FOOTER: "ចំណងជើង និង បាត",
        SU_MANAGEMENT: "ezCms Leo",
        SU_CONNECTION: "ប៉ុស្តិ៍លក់",
        SU_MAPPING: "ផ្គូផ្គង",
        HOTEL_BOOKING_REPOST: "បង្ហោះការកក់ឡើងវិញ",
        CHAIN_SERVICE: "សេវាកម្ម",
        CHAIN_ROOM_TYPE: "ព័ត៌មានប្រភេទបន្ទប់",
        CHAIN_RATE_PLAN: "កញ្ចប់លក់បន្ទប់",
        CHAIN_TRAVEL_AGENT: "ព័ត៌មានក្រុមហ៊ុន/ភ្នាក់ងារ",
        HOTEL_TRAVEL_AGENT: "ព័ត៌មានក្រុមហ៊ុន/ភ្នាក់ងារ",
        SITEMINDER_MANAGEMENT: "ezCms SiteMinder",
        GDS_MANAGEMENT: "ezCms GDS",
        RMS_MANAGEMENT: "គ្រប់គ្រងប្រាក់ចំណូល",
        DYNAMIC_PRICING: "តម្លៃបត់បែន",
        MASTER_RATE: "តម្លៃមេ",
        BE_MANAGEMENT: "ezBe",
        PACKAGE_MANAGEMENT: "លក់កញ្ចប់",
        PACKAGE_ITEM: "សេវាកម្មក្នុងកញ្ចប់",
        PACKAGE_DEAL: "កញ្ចប់លក់",
        HOTEL_BOOKING_GROUP: "បញ្ជីការកក់ជាក្រុម",
        BOOKING_UNMAP_HOTEL: "បញ្ជីការកក់មិនទាន់ផ្គូផ្គង",
        HOTEL_DASHBOARD_IGNORE_TASK: "មិនអើពើ",
        HOTEL_DASHBOARD_REUPDATE_TASK: "ធ្វើបច្ចុប្បន្នភាពឡើងវិញ",
        HOTEL_BOOKING_UNMAP_REPOST: "បង្ហោះការកក់ឡើងវិញ",
        CHAIN_ROOM_UPDATE_QUANTITY: "បច្ចុប្បន្នភាពចំនួនបន្ទប់",
        HOTEL_DASHBOARD: "ផ្ទាំងគ្រប់គ្រង",
        ROOM_UPDATE_QUANTITY: "បច្ចុប្បន្នភាពចំនួនបន្ទប់",
        DYNAMIC_RESTRICTION: "ដាក់កម្រិតបត់បែន",
        DYNAMIC_ROOM_SALE: "លក់បន្ទប់បត់បែន",
        DYNAMIC_CONFIGURATION: "ការកំណត់បត់បែន",
        CHAIN_BOOKING_REPOST: "បង្ហោះការកក់ឡើងវិញ",
        INVENTORY: "បន្ទប់ទំនេរ",
        RATE: "តម្លៃ",
        RESTRICTION: "កម្រិត",
        STOP_SELL_LIMIT: "ដាក់កម្រិតលក់",
        CHANNEX_MANAGEMENT: "ezCms Vela+",
        CHANNEX_CONNECTION: "ប៉ុស្តិ៍លក់",
        CHANNEX_MAPPING: "ផ្គូផ្គង",
        WARNING_METHOD: "វិធីសាស្រ្តការជូនដំណឹង",
        STAAH_MANAGEMENT : "ezCms StaahMax",
        STAAH_MAPPING: "ការផ្គូផ្គង",
        STAAH_CONNECTION: "បណ្តាញលក់",
    },
    _PAYGATE: {
        PAYMENT_THROUGH: "បង់ប្រាក់តាមរយៈ",
        PAYMENT_METHOD: "វិធីសាស្រ្តបង់ប្រាក់",
        ONLINE_PAYMENT_GATEWAY: "ច្រកបង់ប្រាក់អនឡាញ",
        CONFIGURATION: "ការកំណត់",
        CONFIG_PAYMENT_GATE: "កំណត់ច្រកបង់ប្រាក់",
        HOTEL: "សណ្ឋាគារ",
        TRANSFER_PAYMENT: "ការបង់ប្រាក់តាមធនាគារ",
        ONLINE_PAYMENT: "ការបង់ប្រាក់អនឡាញ",
        PAYMENT_TYPE_EMPTY: "មិនមានប្រភេទបង់ប្រាក់ទេ",
        PAYMENT_METHOD_HAS_NOT_SELECTED: "មិនបានជ្រើសវិធីសាស្រ្តបង់ប្រាក់",
        PAYMENT_GATEWAY_IS_NOT_EXIST: "មិនមានច្រកបង់ប្រាក់អនឡាញ",
        CASH: "បង់ប្រាក់ជាសាច់ប្រាក់",
        DEBT: "បង់ប្រាក់ជំពាក់",
        PAYMENT_CARD: "កាតបង់ប្រាក់"
    },
    _SUPPORT: {
        TITLE: "សេចក្ដីណែនាំដើម្បីភ្ជាប់ម៉ាស៊ីនកក់បន្ទប់អនឡាញទៅគេហទំព័រ"
    },
    _DASHBOARD: {
        TITLE: "ផ្ទាំងគ្រប់គ្រង",
        IN_MONTH_REVENUE: "ប្រាក់ចំណូលក្នុងខែនេះ (VND)",
        SEVEN_DAY_REVENUE: "ប្រាក់ចំណូល 7ថ្ងៃចុងក្រោយ (VND)",
        COLLECTION: "ប្រាក់ត្រូវទទួល (VND)",
        ROOM_FILLING_RATE: "អត្រាបំពេញបន្ទប់ក្នុងខែ",
        BOOKING_EMPTY: "ការកក់ថ្មីៗនឹងបង្ហាញនៅទីនេះ",
        BOOKING_NOT_PAYMENT: "ការកក់មិនទាន់បង់ប្រាក់",
        BOOKING_PART_PAYMENT: "ការកក់បានបង់ប្រាក់ផ្នែកខ្លះ",
        BOOKING_CANCELED: "ការកក់បានលុបចោលដោយភ្ញៀវ",
        GO_TO_BOOKING_LIST: "មើលបញ្ជីការកក់ទាំងអស់",
        STATUS: "ស្ថានភាព",
        HOTEL_STATUS: "ព័ត៌មានសណ្ឋាគារ",
        CONTRACT: "កិច្ចសន្យា",
        DEBT: "បំណុល",
        SYNC_PMS: "ធ្វើសមកាលកម្ម PMS",
        MISSING_INFO: {
            SYNC_OTA: "ធ្វើសមកាលកម្ម OTA",
            SYNC_OTA_SUB_TITLE: "ត្រូវមានយ៉ាងហោចណាស់ 1 ឆានែល OTA",
            RESTRICTION: "ប្រកាសកម្រិត",
            RESTRICTION_SUB_TITLE: "យ៉ាងហោចណាស់ 1 កម្រិត",
            RATE_PLAN: "ប្រកាសតម្លៃ និងបន្ទប់ទំនេរ",
            RATE_PLAN_SUB_TITLE: "តម្លៃយ៉ាងហោចណាស់សម្រាប់ 1 ឆានែល និងបន្ទប់ទំនេរ",
            TITLE: "បំពេញព័ត៌មានចាំបាច់",
            HOTEL_INFO: "ព័ត៌មានសណ្ឋាគារ",
            HOTEL_INFO_SUB_TITLE: "បំពេញគ្រប់វាលចាំបាច់",
            ROOM_TYPE: "ព័ត៌មានប្រភេទបន្ទប់",
            ROOM_TYPE_SUB_TITLE: "យ៉ាងហោចណាស់ 1 ប្រភេទបន្ទប់",
            HOTEL_IMAGE: "រូបភាពសណ្ឋាគារ",
            HOTEL_IMAGE_SUB_TITLE: "ផ្ទុករូបភាពយ៉ាងហោចណាស់ 1",
            ROOM_PLAN: "គោលនយោបាយតម្លៃ",
            ROOM_PLAN_SUB_TITLE: "យ៉ាងហោចណាស់ 1 គោលនយោបាយតម្លៃ",
            HOTEL_CONFIG: "កំណត់សណ្ឋាគារ",
            HOTEL_CONFIG_SUB_TITLE: "បំពេញវាលចាំបាច់ទាំងអស់",
            BOOKING_CANCEL_POLICY: "គោលនយោបាយលុបការកក់",
            BOOKING_CANCEL_POLICY_SUB_TITLE: "យ៉ាងហោចណាស់ 1 គោលនយោបាយ",
            PAYMENT_GATE: "ច្រកបង់ប្រាក់",
            PAYMENT_GATE_SUB_TITLE: "យ៉ាងហោចណាស់ 1 វិធីសាស្រ្តបង់ប្រាក់",
            CONTRACT: "កិច្ចសន្យា",
            CONTRACT_SUB_TITLE: "បំពេញវាលចាំបាច់ទាំងអស់",
            PAYMENT_POLICY: "គោលនយោបាយបង់ប្រាក់",
            PAYMENT_POLICY_SUB_TITLE: "យ៉ាងហោចណាស់ 1 គោលនយោបាយ",
            CLOSE: "បិទ"
        },
        CONFIRM: "បញ្ជាក់",
        CONFIRM_SELL_ROOM: "ខ្ញុំយល់ព្រមថាព័ត៌មានទាំងអស់បានបញ្ចូលត្រឹមត្រូវ ហើយយល់ព្រមលក់បន្ទប់នៅលើ OneInventory",
        CONFIRM_SELL_ROOM_BUTTON: "បញ្ជាក់ការលក់បន្ទប់",
        _HOTEL_STATUS_INFO: {
            CREATE: "បង្កើត",
            WAIT_CONFIRM: "រងចាំបញ្ជាក់",
            WAIT_APPROVE: "រងចាំអនុម័ត",
            APPROVED: "បានអនុម័ត",
            SENT_BACK: "បានបញ្ជូនត្រឡប់",
            ONSITE: "នៅតំបន់",
            OFFSITE: "ក្រៅតំបន់"
        },
        _HOTEL_STATUS_CONTRACT: {
            NOT_CREATED: "មិនទាន់បង្កើត",
            CREATE: "បង្កើត",
            RELEASED: "បានចេញផ្សាយ",
            WAIT_SIGN: "រងចាំស្នើសុំ",
            COMPLETED: "បានបញ្ចប់",
            SIGNED: "បានចុះហត្ថលេខា",
            IN_DISPUTE: "ជម្លោះ",
            LIQUIDATED: "បានបញ្ចប់",
            CLOSED: "បិទ"
        },
        _HOTEL_STATUS_DEBT: {
            NOT_CONFIGURED: "មិនទាន់កំណត់",
            CONFIGURED: "បានកំណត់រួច"
        },
        _HOTEL_STATUS_SYNC_PMS: {
            SYNCHRONIZED: "បានធ្វើសមកាលកម្ម",
            UNSYNCHRONIZED: "មិនទាន់ធ្វើសមកាលកម្ម",
            RECEIVED: "បានទទួល",
            NOT_RECEIVED: "មិនទាន់ទទួល"
        }
    },
    _BOOKING: {
        TITLE: "បញ្ជីការកក់បន្ទប់",
        BOOKING: "0 ការកក់ | 1 ការកក់ | {count} ការកក់",
        BOOKING_DATE: "ថ្ងៃកក់",
        BOOKING_CODE: "លេខកូដកក់បន្ទប់",
        REQUEST_CODE: "លេខសំណើ",
        REQUEST_DATE: "ថ្ងៃស្នើសុំ",
        REQUEST_STATUS: "ស្ថានភាពសំណើ",
        AGENT_NAME: "ភ្នាក់ងារ",
        TIME_STAY: "រយៈពេលស្នាក់នៅ",
        COMBO: "កញ្ចប់សេវាកម្ម",
        COMBO_REQUEST: "សំណើកញ្ចប់",
        AMOUNT: "សរុប",
        BOOKING_STATUS: "ស្ថានភាពការកក់",
        EXPORT: "នាំចេញ Excel",
        SEARCH: "ស្វែងរក",
        RESET: "កំណត់ឡើងវិញ",
        ENTER_BOOKING_CODE: "បញ្ចូលលេខកូដការកក់",
        ENTER_BOOKING_CODE_OTA: "បញ្ចូលលេខកូដ OTA",
        ENTER_BOOKING_GROUP_CODE: "បញ្ចូលលេខកូដក្រុមការកក់",
        SEARCH_CONDITION: "ស្វែងរកដោយ",
        SEARCH_BOOKING_CODE: "បញ្ចូលលេខកូដ",
        SEARCH_DATE: "ជ្រើសរយៈពេលថ្ងៃ",
        EDIT: "សកម្មភាព",
        CONFIRM_FEEDBACK: "បញ្ជាក់សំណើទៅភ្នាក់ងារ",
        CONFIRM_FEEDBACK_REASON: "មាតិកាចម្លើយ",
        SEARCH_BY: {
            BOOKING_CODE: "លេខកូដកក់",
            REQUEST_DATE: "ថ្ងៃស្នើសុំ",
            BOOKING_DATE: "ថ្ងៃកក់",
            CHECKIN_DATE: "ថ្ងៃចូលបន្ទប់",
            CHECKOUT_DATE: "ថ្ងៃចេញពីបន្ទប់",
            STAYING_DATE: "ថ្ងៃស្នាក់នៅ"
        },
        STATUS: {
            ALL: "ទាំងអស់",
            CANCEL: "បោះបង់ដោយភ្ញៀវ",
            AWAIT_PAYMENT: "កំពុងរង់ចាំការទូទាត់",
            CLOSE: "បានបិទ",
            IN_SERVICE: "កំពុងប្រើសេវា",
            PAYMENT_FAILED: "បរាជ័យក្នុងការទូទាត់",
            CONFIRM: "បញ្ជាក់",
            AWAIT_FULLY_PAYMENT: "ទូទាត់មួយផ្នែក",
            VOID: "បោះបង់ដោយសណ្ឋាគារ",
            STATUS_WAIT_FEEDBACK: "រង់ចាំការឆ្លើយតប",
            STATUS_FEEDBACK: "បានឆ្លើយតប",
            STATUS_COMPLETE: "បានបញ្ចប់",
            STATUS_CANCEL: "បានបោះបង់"
        },
        SEARCH_PMS_STATUS: "ស្ថានភាពសម្របសម្រួល",
        SEARCH_PMS_CODE: "ប្រភេទ PMS",
        CHECKIN_STATUS: "ស្ថានភាពចូលបន្ទប់",
        AGENT: "ភ្នាក់ងារ",
        MARKET: "ផ្នែកទីផ្សារ",
        PDF: "នាំចេញ PDF",
        UNMAP_BOOKING: {
            UNMAP_BOOKING_TITLE: "Mapping status",
            ALL: "All",
            MAPPED: "Mapped",
            UNMAP_ROOM_TYPE: "Unmapped room",
            UNMAP_RATE_PLAN: "Unmapped rate",
            UNMAP_ROOMRATE: "Unmapped room_rate",
        }
    },
    _BOOKING_DETAIL: {
        TITLE: "ព័ត៌មានលម្អិតការកក់បន្ទប់",
        CONTACT: {
            TITLE: "ព័ត៌មានទំនាក់ទំនង",
            NAME: "ឈ្មោះភ្ញៀវ",
            PHONE: "លេខទូរស័ព្ទ",
            EMAIL: "អ៊ីមែល",
            GROUP_NAME_TOUR: "ឈ្មោះក្រុមភ្ញៀវ",
            AGENT_NAME: "ភ្នាក់ងារ"
        },
        BOOKING_DETAIL: {
            TITLE: "ព័ត៌មានការកក់បន្ទប់",
            CODE: "លេខកូដកក់",
            OTACODE: "លេខកូដកក់ OTA",
            STATUS: "ស្ថានភាពការកក់",
            CREATED: "ថ្ងៃកក់",
            CHECK_IN: "ថ្ងៃចូលបន្ទប់",
            CHECK_OUT: "ថ្ងៃចេញពីបន្ទប់",
            UPDATED: "ថ្ងៃធ្វើបច្ចុប្បន្នភាព",
            NOTE: "កំណត់សម្គាល់"
        },
        ROOM: {
            TITLE: "ព័ត៌មានបន្ទប់ - ",
            APPLY_DATE: "ថ្ងៃ",
            NAME: "គោលការណ៍តម្លៃ",
            UNIT_PRICE: "តម្លៃ/យប់ (៛)",
            QUANTITY: "បរិមាណបន្ទប់",
            ADULTS: "មនុស្សពេញវ័យ",
            CHILDREN: "កុមារ",
            BABY: "ទារក",
            TOTAL: "សរុប (៛)"
        },
        PROMOTION: {
            TITLE: "ព្រឹត្តិការណ៍បញ្ចុះតម្លៃ",
            NAME: "ឈ្មោះបញ្ចុះតម្លៃ",
            ROOM_PLAN_NAME: "គោលការណ៍តម្លៃ",
            ROOM_NAME: "ប្រភេទបន្ទប់",
            TOTAL: "សរុប (៛)"
        },
        PROMOTION_ONEI: {
            TITLE: "បញ្ចុះតម្លៃពី OneInventory",
            NAME: "ឈ្មោះបញ្ចុះតម្លៃ",
            COST_TYPE: "ប្រភេទចំណាយ",
            TOTAL: "សរុប (៛)"
        },
        SERVICE: {
            TITLE: "សេវាកម្ម",
            NAME: "ឈ្មោះសេវាកម្ម",
            DATE: "ថ្ងៃប្រើប្រាស់",
            COST: "តម្លៃ",
            COUNT: "បរិមាណ",
            TOTAL: "សរុប (៛)"
        },
        PAYMENT_LOG: {
            TITLE: "ប្រវត្តិនៃការទូទាត់",
            METHOD: "វិធីសាស្ត្រទូទាត់",
            AMOUNT: "ចំនួនទឹកប្រាក់",
            TRANS_NO: "លេខប្រតិបត្តិការ",
            TRANS_DATE: "ថ្ងៃធ្វើប្រតិបត្តិការ",
            RES_CODE: "លទ្ធផល",
            RES_MSG: "កំណត់សម្គាល់"
        },
        METHOD_NAME: {
            ONEPAY_DOM: "ទូទាត់ OnePay ជាតិ",
            ONEPAY_INTER: "ទូទាត់ OnePay អន្តរជាតិ",
            VNPAY: "ទូទាត់តាម VNPAY",
            TRANSFER: "បង់ប្រាក់តាមការផ្ទេរ",
            CASH: "បង់ប្រាក់ដោយសាច់ប្រាក់",
            VNPAY_QR: "ទូទាត់តាម VNPAY QR",
            VIETTELPAY_QR: "ទូទាត់តាម ViettelPay QR",
            VIETTELPAY: "ទូទាត់តាម ViettelPay"
        },
        PAYMENT_CARD_DETAIL: "ព័ត៌មានលម្អិតអំពីកាតទូទាត់",
        SUB_TOTAL: "សរុបបណ្ដោះអាសន្ន",
        TOTAL: "សរុបប្រាក់:",
        PAID: "ប្រាក់ដែលបានបង់:",
        UNPAID: "ប្រាក់មិនទាន់បង់:",
        EXPORT: "បោះពុម្ពការកក់",
        CANCEL: "បោះបង់ការកក់",
        NOTE: "កំណត់សម្គាល់",
        CONFIRM_CANCEL: "អះអាងការបោះបង់ការកក់?",
        CONFIRM_REASON: "មូលហេតុ (ត្រូវបំពេញ)",
        CONFIRM: "បញ្ជាក់",
        COMMISSION: "កម្រៃជើងសារ",
        BEFORE_COMMISSION: "ប្រាក់ដែលទទួលបាន",
        AFTER_COMMISSION: "តម្លៃរួមជាមួយកម្រៃជើងសារ",
        PAYMENT_COLLECT: "ទូទាត់ដោយ OneInventory",
        PROPERTY_COLLECT: "ទូទាត់ដោយសណ្ឋាគារ",
        OTA_CONTACT: "ទំនាក់ទំនង OTA",
        CHANNEL_COLLECT: "ទូទាត់តាមឆានែល"
    },
    _REQUEST_DETAIL: {
        TITLE: "ព័ត៌មានលម្អិតអំពីសំណើ",
        BUGET: "ថវិកាបង់ប្រាក់",
        CONTACT: {
            TITLE: "ព័ត៌មានទំនាក់ទំនងសម្រាប់ការកក់",
            NAME: "ឈ្មោះភ្នាក់ងារទេសចរណ៍",
            PHONE: "លេខទូរស័ព្ទ",
            EMAIL: "អ៊ីមែល",
            AGENT_NAME: "ភ្នាក់ងារ",
            REQUESTER_NAME: "អ្នកស្នើសុំ"
        },
        BOOKING_DETAIL: {
            TITLE: "ព័ត៌មានលម្អិតសំណើ",
            CODE: "លេខសំណើ",
            STATUS: "ស្ថានភាពការកក់",
            CREATED: "ថ្ងៃស្នើសុំ",
            CHECK_IN: "ថ្ងៃចូលបន្ទប់",
            CHECK_OUT: "ថ្ងៃចេញពីបន្ទប់",
            UPDATED: "ថ្ងៃធ្វើបច្ចុប្បន្នភាព"
        },
        ROOM: {
            TITLE: "ព័ត៌មានបន្ទប់",
            APPLY_DATE: "ថ្ងៃ",
            NAME: "គោលការណ៍តម្លៃ",
            UNIT_PRICE: "តម្លៃ/យប់ (៛)",
            QUANTITY: "បរិមាណបន្ទប់",
            ADULTS: "មនុស្សពេញវ័យ",
            CHILDREN: "កុមារ",
            TOTAL: "សរុប (៛)"
        },
        NOTE: "កំណត់សម្គាល់",
        SEND_REQUEST: "ផ្ញើការឆ្លើយតប"
    },

    _BOOKING_TRANSACTION: {
        TITLE: "ប្រតិបត្តិការទូទាត់",
        ALL: "ទាំងអស់",
        BOOKING: "ការកក់",
        BOOKING_DATE: "ថ្ងៃកក់",
        BOOKING_CODE: "លេខកូដកក់",
        AGENT_NAME: "ភ្នាក់ងារ",
        TIME_STAY: "អំឡុងពេលស្នាក់នៅ",
        AMOUNT: "សរុប",
        PAYMENT_DATE: "ថ្ងៃផុតកំណត់ទូទាត់",
        BOOKING_STATUS: "ស្ថានភាពការកក់",
        ACTION: "សកម្មភាព",
        EXPORT: "នាំចេញ Excel",
        SEARCH: "ស្វែងរក",
        CONFIRM: "បញ្ជាក់",
        TIME_STAY_TEXT: "{day} ថ្ងៃ {night} យប់",
        SEARCH_CONDITION: "ស្វែងរកតាម",
        SEARCH_BOOKING_CODE: "បញ្ចូលលេខកូដ",
        SEARCH_DATE: "ជ្រើសរយៈពេលថ្ងៃ",
        SEARCH_BY: {
            BOOKING_CODE: "លេខកូដកក់",
            BOOKING_DATE: "ថ្ងៃកក់",
            CHECKIN_DATE: "ថ្ងៃចូលបន្ទប់",
            CHECKOUT_DATE: "ថ្ងៃចេញពីបន្ទប់"
        },
        STATUS: {
            CANCEL: "បានបោះបង់ដោយភ្ញៀវ",
            AWAIT_PAYMENT: "រង់ចាំការទូទាត់",
            CLOSE: "បានបិទ",
            IN_SERVICE: "កំពុងប្រើប្រាស់",
            PAYMENT_FAILED: "ការទូទាត់បានបរាជ័យ",
            CONFIRM: "បញ្ជាក់",
            AWAIT_FULLY_PAYMENT: "បានទូទាត់ផ្នែកខ្លះ",
            VOID: "បានបោះបង់ដោយសណ្ឋាគារ"
        }
    },

    _BOOKING_TRANSACTION_DETAIL: {
        TITLE: "ព័ត៌មានលម្អិតអំពីប្រតិបត្តិការ",
        DETAIL: "ព័ត៌មានលម្អិតប្រតិបត្តិការ",
        BOOKING_CODE: "លេខកូដកក់៖ ",
        PAYMENT_METHOD: "វិធីសាស្ត្រទូទាត់",
        TRANSACTION_CODE: "លេខប្រតិបត្តិការ",
        TRANSACTION_DATE: "ថ្ងៃធ្វើប្រតិបត្តិការ",
        AMOUNT: "ចំនួនទឹកប្រាក់",
        NOTE: "កំណត់សម្គាល់",
        BANK_TRANSFER: "ផ្ទេរប្រាក់តាមធនាគារ",
        CASH: "សាច់ប្រាក់",
        DEBT: "ជំពាក់"
    },
    _ROOM_PLAN: {
        TITLE: "បន្ទប់ទំនេរ និងតម្លៃ",
        BATCH_UPDATE: "ធ្វើបច្ចុប្បន្នភាពជាបណ្ដោះអាសន្ន",
        ALL_ROOM: "បន្ទប់ទាំងអស់",
        STOP_SELL: "បញ្ឈប់ការលក់",
        MIN_STAY: "ចំនួនយប់អប្បបរមា",
        MAX_STAY: "ចំនួនយប់អតិបរមា",
        CTA: "មិនអនុញ្ញាតឱ្យចូលបន្ទប់",
        CTD: "មិនអនុញ្ញាតឱ្យចេញពីបន្ទប់",
        CURRENT_MONTH: "ខែ {month} ឆ្នាំ {year}",
        CONFIRM_CHANGE_PAGE: "តើអ្នកប្រាកដថាចង់បន្តទេ?\nទិន្នន័យដែលមិនបានរក្សាទុកនឹងបាត់បង់",
        MIN_SMALLER_THAN_ONE: "ចំនួនយប់អប្បបរមាមិនអាចតិចជាង 1",
        MAX_SMALLER_THAN_ONE: "ចំនួនយប់អតិបរមាមិនអាចតិចជាង 1",
        MIN_BIGGER_THAN_MAX: "ចំនួនយប់អប្បបរមា​ធំជាង​អតិបរមា",
        MIN_SMALLER_THAN_CONFIG: "ចំនួនយប់អប្បបរមាមិនអាចតិចជាងការកំណត់ក្នុងគោលនយោបាយតម្លៃ",
        MAX_BIGGER_THAN_CONFIG: "ចំនួនយប់អតិបរមាមិនអាចធំជាងការកំណត់ក្នុងគោលនយោបាយតម្លៃ"
    },

    _BATCH_UPDATE: {
        TITLE: "ធ្វើបច្ចុប្បន្នភាពជាបណ្ដោះអាសន្ន",
        ADD: "បន្ថែម",
        SELECT_ROOM_TYPE: "ជ្រើសប្រភេទបន្ទប់",
        SELECT_UPDATE_TYPE: "ជ្រើសប្រភេទបច្ចុប្បន្នភាព",
        ALL_ROOM: "បន្ទប់ទាំងអស់",
        AVAILABLE_ROOM: "បន្ទប់ដែលទំនេរ",
        PRICE: "តម្លៃ",
        STOP_SELL: "បញ្ឈប់ការលក់",
        CTA: "មិនអនុញ្ញាតឱ្យ check-in",
        CTD: "មិនអនុញ្ញាតឱ្យ check-out",
        MIN_NIGHT_STAY: "ចំនួនយប់អប្បបរមា",
        MAX_NIGHT_STAY: "ចំនួនយប់អតិបរមា",
        ROOM_TYPE_AND_SALE_PACKAGE: "ប្រភេទបន្ទប់ / គោលការណ៍តម្លៃ",
        FROM: "ពី",
        TO: "ដល់",
        MESSAGE: {
            OVERLAP_TIME: "រយៈពេលធ្វើបច្ចុប្បន្នភាពមិនអាចជាន់គ្នា"
        },
        APPLY: "អនុវត្ត",
        DELETE_STOP_SELL: "លុបការបញ្ឈប់លក់",
        DELETE_CTA: "លុបមិនអនុញ្ញាត check-in",
        DELETE_CTD: "លុបមិនអនុញ្ញាត check-out"
    },

    SALE_PACKAGE: "គោលនយោបាយតម្លៃ",

    _HOTEL_CHAIN: {
        CHAIN_LIST_HOTEL: "សណ្ឋាគារ",
        TITLE: "ភ្ជាប់សណ្ឋាគារជាចង្វាក់",
        CHAIN_NAME: "ឈ្មោះចង្វាក់សណ្ឋាគារ",
        CHAIN_LIST: "បញ្ជីសណ្ឋាគារ ({total})",
        HOTEL_ID: "លេខសម្គាល់សណ្ឋាគារ៖ ",
        ADD_HOTEL: "បន្ថែមសណ្ឋាគារ",
        LOGIN_TEXT: "ចូលគណនីម្ចាស់សណ្ឋាគារដើម្បីភ្ជាប់ចង្វាក់",
        LOGIN_EXISTED_TEXT: "ចូលគណនី {hotelName}៖",
        USERNAME: "ឈ្មោះអ្នកប្រើប្រាស់",
        PASSWORD: "ពាក្យសម្ងាត់",
        CONFIRM: "បញ្ជាក់",
        REMOVE_HOTEL: "តើអ្នកប្រាកដថាចង់លុបសណ្ឋាគារចេញពីចង្វាក់?",
        LOGIN: "ចូលគណនី",
        DELETE_HOTEL: "លុបចង្វាក់សណ្ឋាគារ",
        LABEL_SEARCH_CODE_NAME: "លេខកូដ / ឈ្មោះសណ្ឋាគារ",
        ENTER_HOTEL_NAME_OR_CODE: "បញ្ចូលឈ្មោះ ឬលេខសម្គាល់សណ្ឋាគារ",
        CHAIN_LIST_BOOKING: "បញ្ជីការកក់",
        STATUS: "ស្ថានភាព",
        SEARCH: "ស្វែងរក"
    },
    _ACCOUNT_SETTING: {
        TITLE: "ការកំណត់គណនីផ្ទាល់ខ្លួន",
        AVATAR: "រូបតំណាង",
        USER_INFO: "ព័ត៌មានផ្ទាល់ខ្លួន",
        CHANGE_PASSWORD: "ផ្លាស់ប្តូរពាក្យសម្ងាត់",
        USERNAME: "ឈ្មោះគណនី",
        FULLNAME: "នាម និងគោត្តនាម",
        GENDER: "ភេទ",
        GENDER_MALE: "ប្រុស",
        GENDER_FEMALE: "ស្រី",
        EMAIL: "អ៊ីមែល",
        PHONE_NUMBER: "លេខទូរស័ព្ទ",
        ADDRESS: "អាសយដ្ឋាន",
        POSITION: "មុខតំណែង",
        GROUP: "ក្រុមអ្នកប្រើប្រាស់",
        CURRENT_PASS: "ពាក្យសម្ងាត់បច្ចុប្បន្ន",
        NEW_PASS: "ពាក្យសម្ងាត់ថ្មី",
        NEW_PASS_REPEAT: "បញ្ជាក់ពាក្យសម្ងាត់ថ្មី",
        ERROR_PHONE_NUMBER_MIN: "លេខទូរស័ព្ទត្រូវមានយ៉ាងតិច 8 តួអក្សរ",
        ERROR_PASSWORD_MIN: "ពាក្យសម្ងាត់ត្រូវមានយ៉ាងតិច 8 តួអក្សរ",
        ERROR_RETYPE_PASSWORD_MIN: "ការបញ្ជាក់ពាក្យសម្ងាត់ត្រូវមានយ៉ាងតិច 8 តួអក្សរ",
        ERROR_PASSWORD_INVALID: "ពាក្យសម្ងាត់បច្ចុប្បន្នមិនត្រឹមត្រូវ",
        ERROR_PASSWORD_NOT_MATCH: "ពាក្យសម្ងាត់ថ្មីមិនផ្គូផ្គងกัน",
        MESSAGE_PASSWORD_MATCHED: "ពាក្យសម្ងាត់ផ្គូផ្គង",
        MESSAGE_PASSWORD_NOT_MATCHED: "ពាក្យសម្ងាត់មិនផ្គូផ្គង"
    },

    _LIST_USER: {
        TITLE: "គ្រប់គ្រងអ្នកប្រើប្រាស់",
        LIST_USER: "បញ្ជីអ្នកប្រើប្រាស់",
        USER: "អ្នកប្រើប្រាស់",
        SEARCH_PLACEHOLDER: "ស្វែងរកតាមឈ្មោះគណនី, ឈ្មោះពេញ ឬអ៊ីមែល",
        GROUP_NAME: "ឈ្មោះក្រុម",
        USERNAME: "ឈ្មោះគណនី",
        NAME: "ឈ្មោះពេញ",
        EMAIL: "អ៊ីមែល",
        CREATE_USER: "អ្នកបង្កើត",
        CREATE_DATE: "ថ្ងៃបង្កើត",
        STATUS: "ស្ថានភាព",
        ACTION: "សកម្មភាព",
        STATUS_ACTIVATE: "កំពុងប្រើប្រាស់",
        STATUS_DEACTIVATE: "បានផ្អាកប្រើប្រាស់",
        REMOVE: "តើអ្នកប្រាកដថាចង់លុបអ្នកប្រើប្រាស់នេះមែនទេ?",
        CANNOT_DELETE_CURRENT_USER: "មិនអាចលុបគណនីអ្នកប្រើប្រាស់បច្ចុប្បន្នបានទេ"
    },

    _LIST_GROUP: {
        TITLE: "គ្រប់គ្រងក្រុមអ្នកប្រើប្រាស់",
        LIST_GROUP: "បញ្ជីក្រុមអ្នកប្រើប្រាស់",
        GROUP: "ក្រុមអ្នកប្រើប្រាស់",
        SEARCH_PLACEHOLDER: "ស្វែងរកតាមឈ្មោះក្រុម",
        GROUP_NAME: "ឈ្មោះក្រុម",
        CREATE_USER: "អ្នកបង្កើត",
        CREATE_DATE: "ថ្ងៃបង្កើត",
        STATUS: "ស្ថានភាព",
        ACTION: "សកម្មភាព",
        STATUS_ACTIVATE: "កំពុងប្រើប្រាស់",
        STATUS_DEACTIVATE: "បានផ្អាកប្រើប្រាស់",
        DESCRIPTION: "ព័ត៌មានពិពណ៌នា",
        REMOVE: "តើអ្នកប្រាកដថាចង់លុបក្រុមនេះមែនទេ?"
    },

    _EDIT_USER: {
        TITLE: "ព័ត៌មានអ្នកប្រើប្រាស់",
        INFO: "ព័ត៌មានអ្នកប្រើប្រាស់",
        USER: "អ្នកប្រើប្រាស់",
        ROLE: "សិទ្ធិចូលប្រើ",
        USERNAME: "ឈ្មោះគណនី",
        FULLNAME: "នាម និងគោត្តនាម",
        PASSWORD: "ពាក្យសម្ងាត់",
        PASSWORD_REPEAT: "បញ្ជាក់ពាក្យសម្ងាត់",
        GENDER: "ភេទ",
        GENDER_MALE: "ប្រុស",
        GENDER_FEMALE: "ស្រី",
        EMAIL: "អ៊ីមែល",
        PHONE_NUMBER: "លេខទូរស័ព្ទ",
        ADDRESS: "អាសយដ្ឋាន",
        POSITION: "មុខតំណែង",
        GROUP: "ក្រុមអ្នកប្រើប្រាស់",
        GROUP_PLACEHOLDER: "ស្វែងរក",
        HOTEL_OWNER: "ម្ចាស់សណ្ឋាគារ",
        STATUS: "ស្ថានភាពប្រើប្រាស់ / ផ្អាកប្រើ",
        NO: "ល.រ",
        FUNCTION_CODE: "លេខកូដមុខងារ",
        FUNCTION_NAME: "ឈ្មោះមុខងារ",
        ACTION: "សកម្មភាព",
        ERROR_PHONE_NUMBER_MIN: "លេខទូរស័ព្ទត្រូវមានយ៉ាងតិច 8 តួអក្សរ",
        ERROR_PASSWORD_MIN: "ពាក្យសម្ងាត់ត្រូវមានយ៉ាងតិច 8 តួអក្សរ",
        ERROR_RETYPE_PASSWORD_MIN: "បញ្ជាក់ពាក្យសម្ងាត់ត្រូវមានយ៉ាងតិច 8 តួអក្សរ",
        ERROR_PASSWORD_NOT_MATCH: "ពាក្យសម្ងាត់មិនផ្គូផ្គង",
        CHAIN: "ចង្វាក់សណ្ឋាគារ",
        HOTEL: "សណ្ឋាគារ"
    },
    _EDIT_GROUP: {
        TITLE: "ព័ត៌មានអំពីក្រុមអ្នកប្រើប្រាស់",
        INFO: "ព័ត៌មានក្រុមអ្នកប្រើប្រាស់",
        GROUP: "ក្រុមអ្នកប្រើប្រាស់",
        ROLE: "សិទ្ធិចូលប្រើ",
        GROUP_NAME: "ឈ្មោះក្រុម",
        GROUP_CODE: "លេខកូដក្រុម",
        GROUP_ROLE: "ប្រភេទសិទ្ធិ",
        PARENT_GROUP: "ក្រុមមេ",
        TYPE: "ប្រភេទក្រុម",
        DESCRIPTION: "ព័ត៌មានពិពណ៌នា",
        STATUS: "ស្ថានភាពប្រើប្រាស់ / ផ្អាកប្រើ",
        NO: "ល.រ",
        FUNCTION_CODE: "លេខកូដមុខងារ",
        FUNCTION_NAME: "ឈ្មោះមុខងារ",
        ACTION: "សកម្មភាព",
        ERROR_MIN_ROLE_SELECTED: "សូមជ្រើសយ៉ាងហោចណាស់មុខងារមួយ"
    },

    _CONTRACT: {
        TITLE: "កិច្ចសន្យាអេឡិចត្រូនិក",
        CONTRACT_INFO: "ព័ត៌មានអតិថិជន",
        BUSINESS_NAME: "ឈ្មោះសហគ្រាស",
        BUSINESS_NAME_NOTE: " (សូមបញ្ចូលតាមអាជ្ញាបណ្ណ GPKD ដោយប្រើអក្សរធំ)",
        TAX_CODE: "លេខសម្គាល់ពន្ធ",
        TAX_CODE_NOTE: " (បញ្ចូលទាំងលេខ 0 បើមាន)",
        ADDRESS: "អាសយដ្ឋានចុះបញ្ជីអាជីវកម្ម",
        ADDRESS_NOTE: " (បញ្ចូលតាម GPKD)",
        BANK_ACCOUNT: "លេខគណនីធនាគារ",
        BANK_ACCOUNT_OWNER: "ឈ្មោះម្ចាស់គណនី",
        BANK: "ឈ្មោះធនាគារ",
        BANK_BRANCH: "សាខាធនាគារ",
        LEGAL_REPRESENTATIVE: "តំណាងច្បាប់",
        LEGAL_REPRESENTATIVE_NOTE: " (បញ្ចូលតាម GPKD)",
        PIC: "អ្នកចុះហត្ថលេខា",
        PIC_POSITION: "មុខតំណែងអ្នកចុះហត្ថលេខា",
        COMMISSION: "កម្រៃជើងសារ (%)",
        STATUS: "ស្ថានភាពកិច្ចសន្យា",
        VIEW: "មើល",
        _STATUS: {
            CREATE: "បង្កើតថ្មី",
            AM_SENT: "AM បានផ្ញើសំណើ",
            SM_ACCEPT: "SM អនុម័ត",
            SM_REJECT: "SM បដិសេធ",
            CM_ACCEPT: "CM អនុម័ត",
            CM_REJECT: "CM បដិសេធ",
            PUBLISH: "បានបោះពុម្ពផ្សាយ",
            WAIT_SIGN: "រងចាំការចុះហត្ថលេខា",
            COMPLETE: "បញ្ចប់",
            SIGNED: "បានចុះហត្ថលេខា",
            DISPUTED: "ជម្លោះ",
            LIQUIDFY: "បានលុបបំណុល",
            CLOSE: "បិទ",
            EXTEND: "បន្ដអាណត្តិ"
        }
    },

    _TRAVEL_AGENT: {
        TITLE: "បញ្ជីភ្នាក់ងារ",
        TITLE_DEACTIVE: "បញ្ជីភ្នាក់ងារដែលផ្អាកការសហការណ៍",
        AGENT: "ភ្នាក់ងារ",
        SEARCH_PLACEHOLDER: "ស្វែងរកតាមឈ្មោះភ្នាក់ងារ",
        NAME: "ឈ្មោះភ្នាក់ងារ",
        BUSINESS_TYPE: "ប្រភេទអាជីវកម្ម",
        TAX_CODE: "លេខសម្គាល់ពន្ធ",
        LEVEL: "កម្រិតភ្នាក់ងារ",
        STATUS: "ស្ថានភាព",
        DEACTIVE: "ផ្អាកការសហការណ៍",
        ACTIVE: "ចាប់ផ្តើមសហការឡើងវិញ",
        LEVEL_1: "កម្រិត 1",
        LEVEL_2: "កម្រិត 2",
        LEVEL_3: "កម្រិត 3",
        LEVEL_4: "កម្រិត 4",
        LEVEL_5: "កម្រិត 5",
        CONFIRM_CHANGE_LEVEL: "បញ្ជាក់ការផ្លាស់ប្ដូរកម្រិត?",
        CONFIRM_ACTIVE: "បញ្ជាក់ការចាប់ផ្តើមសហការជាមួយភ្នាក់ងារ?",
        CONFIRM_DEACTIVE: "បញ្ជាក់ការផ្អាកសហការជាមួយភ្នាក់ងារ?",
        CONFIRM_REASON: "មូលហេតុ (ត្រូវបំពេញ)",
        CONFIRM: "បញ្ជាក់",
        CONFIRM_CHANGE_ACTIVE: "បញ្ជាក់ការផ្លាស់ប្ដូរស្ថានភាពភ្នាក់ងារ"
    },

    // PAYGATE
    ONEPAY_INLAND: "OnePay ក្នុងស្រុក",
    ONEPAY_OVERSEA: "OnePay អន្តរជាតិ",
    VN_PAY: "VN Pay",
    NEAREST_POPULAR_LOCATION: "ទីតាំងពេញនិយមជិតបំផុត",
    MOST_POPULAR_LOCATION: "ទីតាំងពេញនិយមបំផុត",
    RESTAURANT_AND_MARKET: "ភោជនីយដ្ឋាន និងផ្សារ",
    TRAVEL_PLACE: "កន្លែងទេសចរណ៍",
    NEAREST_AIRPORT: "ព្រលានយន្តហោះជិតបំផុត",
    VIETNAMESE_NAME: "ឈ្មោះជាភាសាវៀតណាម",
    ENGLISH_NAME: "ឈ្មោះជាភាសាអង់គ្លេស",
    ADD_LOCATION: "បន្ថែមទីតាំង",
    DISTANCE: "ចម្ងាយ",

    ROOM_INFOMATION: "ព័ត៌មានបន្ទប់",
    ROOM_AMENITIES: "អំពីបរិក្ខារបន្ទប់",
    ROOM_IMAGE: "រូបភាពបន្ទប់",
    ROOM_NAME: "ឈ្មោះបន្ទប់",
    ROOM_TYPE: "ប្រភេទបន្ទប់",
    MEAL: "អាហារ",
    NAME_ROOM_TYPE: "ឈ្មោះប្រភេទបន្ទប់",
    NAME_ROOM_TYPE_DEFAULT: "ឈ្មោះប្រភេទបន្ទប់លំនាំដើម",
    TOTAL_ROOM: "ចំនួនបន្ទប់សរុប",
    MAX_CUSTOMER_COUNT: "ចំនួនភ្ញៀវអតិបរមា",
    ROOM_DIMENSION: "ទំហំបន្ទប់",
    BED_BONUS_COUNT: "ចំនួនគ្រែបន្ថែម",
    PRICE_NORMAL_DAY: "តម្លៃថ្ងៃធម្មតា",
    PRICE_WEEKEND: "តម្លៃចុងសប្ដាហ៍",
    ROOM_DIRECTION: "ទិសបន្ទប់",
    BED_TYPE: "ប្រភេទគ្រែ",
    ADULT: "មនុស្សពេញវ័យ",
    CHILDREN: "កុមារ",
    ACTION: "សកម្មភាព",
    COMMON_BED_TYPE: "ប្រភេទគ្រែធម្មតា",
    COMBINATION_BED_TYPE: "ប្រភេទគ្រែបន្សំ",
    MORE_OPTIONS: "ជម្រើសបន្ថែម",
    REMOVE_OPTIONS: "យកជម្រើសចេញ",
    ADD_TYPE_BED: "បន្ថែមប្រភេទគ្រែ",
    FREE: "ឥតគិតថ្លៃ",
    SURCHARGE: "ថ្លៃបន្ថែម",

    PACKAGE: "កញ្ចប់",
    SELLING_PACKAGE_INFO: "ព័ត៌មានអំពីគោលការណ៍តម្លៃ",
    SELLING_PACKAGE: "ឈ្មោះគោលការណ៍តម្លៃ",
    SERVICE_PACKAGE: "កញ្ចប់សេវាកម្ម",
    PROMOTION: "ការផ្សព្វផ្សាយ",
    PROMOTION_INFO: "ព័ត៌មានបញ្ចុះតម្លៃ",
    NAME_SELLING_PACKAGE: "ឈ្មោះគោលការណ៍តម្លៃ",
    PACKEAGE_APPLY_FOR: "គោលការណ៍តម្លៃអនុវត្តចំពោះ",
    MEALS_INCLUDE: "អាហារដែលរួមបញ្ចូល",
    EXTRA_BED_PRICE: "តម្លៃគ្រែបន្ថែម",
    EXTRA_ADULT_PRICE: "តម្លៃបន្ថែមសម្រាប់មនុស្សពេញវ័យ",
    EXTRA_CHILD_PRICE: "តម្លៃបន្ថែមសម្រាប់កុមារ",
    MIN_NIGHT: "ចំនួនយប់អប្បបរមា",
    MAX_NIGHT: "ចំនួនយប់អតិបរមា",
    DAYS_NOT_APPLY: "ថ្ងៃដែលមិនអនុវត្ត",
    NOT_APPLY: "មិនអនុវត្ត",
    ADD_DAYS_NOT_APPLY: "បន្ថែមថ្ងៃដែលមិនអនុវត្ត",
    TYPE_ROOM_APPLIED: "ប្រភេទបន្ទប់ដែលអនុវត្ត",
    PLAN_IS_SELECTING: "គោលនយោបាយតម្លៃបានភ្ជាប់ជាមួយ OTA",
    PLAN_NULL: "គោលការណ៍លក់បន្ទប់មិនមានទេ",
    ERROR: "សូមអភ័យទោស មានកំហុសកើតឡើង។ សូមព្យាយាមម្ដងទៀត។",
    COPY_SUCCESS: "បានចម្លងដោយជោគជ័យ",
    COPPY_SUCCESS: "បានចម្លងដោយជោគជ័យ",
    NOT_SELECTED_PLAN: "មិនមានគោលការណ៍ណាមួយបានជ្រើសរើសទេ",
    NOT_SELECTED_ROOM: "មិនមានបន្ទប់ណាមួយបានជ្រើសរើសទេ",
    MAX_STAY_NOT_SMALL_THAN_MIN_STAY: "ចំនួនយប់អតិបរមាមិនអាចតិចជាងអប្បបរមាទេ",

    PROMOTION_PACKAGE_NAME: "ឈ្មោះគោលការណ៍បញ្ចុះតម្លៃ",
    PROMOTION_TYPE: "ប្រភេទបញ្ចុះតម្លៃ",
    APPLY: "អនុវត្ត",
    APPLY_WITH: "អនុវត្តជាមួយ",
    DISCOUNT_AND_SURCHARGES: "បញ្ចុះតម្លៃ/ថ្លៃបន្ថែម",
    DAYS_APPLY: "ថ្ងៃអនុវត្ត",
    TIME_STAY: "ពេលវេលានៃការស្នាក់នៅ",
    TIME_SET: "ពេលវេលាកក់",
    TARGET_APPLY: "គោលដៅអនុវត្ត",
    ARGENT_LEVEL_APPLY: "ជ្រើសកម្រិតភ្នាក់ងារអនុវត្ត",
    ARGENT_APPLY: "ជ្រើសភ្នាក់ងារអនុវត្ត",
    PACKAGE_APPLY: "គោលការណ៍តម្លៃអនុវត្ត",
    X_DAYS: "x ថ្ងៃ",
    FROM_DATE: "ចាប់ពីថ្ងៃ",
    TO_DATE: "ដល់ថ្ងៃ",
    MIN_COUNT: "ចំនួនអប្បបរមា",
    NIGHT_STAY: "ចំនួនយប់ស្នាក់នៅ",
    ROOM_BOOK_QUANTITY: "ចំនួនបន្ទប់បានកក់",
    QUANTITY_IS_FREE: "ចំនួនដែលឥតគិតថ្លៃ (y)",
    COUPON: "កូដបញ្ចុះតម្លៃ",
    STATUS: "ស្ថានភាព",
    ACTIVE: "កំពុងដំណើរការ",
    DEACTIVE: "ផ្អាកដំណើរការ",
    STATE_ACTIVE_OR_DEACTIVE: "ស្ថានភាពដំណើរការ / ផ្អាកដំណើរការ",
    CBALERT_LB_AVAISEARCH: "សូមជ្រើសយ៉ាងហោចណាស់មួយ",
    CONTACT_BOOKING_DETAIL: "ព័ត៌មានទំនាក់ទំនងការកក់បន្ទប់",
    BOOKING_DETAIL: "ព័ត៌មានលម្អិតអំពីការកក់បន្ទប់",
    NORMAL_ROOM_DETAIL: "ព័ត៌មានបន្ទប់ធម្មតា",
    VIP_ROOM_DETAIL: "ព័ត៌មានបន្ទប់ VIP",
    SERVICES: "សេវាកម្ម",
    PAYMENT_HISTORY: "ប្រវត្តិការបង់ប្រាក់",

    FILE_NAME: "ឈ្មោះឯកសារ",
    FILE_TYPE: "ប្រភេទឯកសារ",
    UPLOAD_BY: "អាប់ឡូតដោយ",
    FILE_CAPACITY: "ទំហំឯកសារ",
    SIZE: "ទំហំ",
    UPLOAD_TIME: "ពេលវេលាអាប់ឡូត",
    CLOSE: "បិទ",
    TOTAL: "សរុប",
    OR: "ឬ",
    CHOOSE: "ជ្រើសរើស",
    NO_PHOTOS_FOUND: "រកមិនឃើញរូបភាព",

    DRAG_DROP_PHOTOS_HERE: "អូសនិងទម្លាក់រូបភាពនៅទីនេះ",
    SELECT_PHOTOS_TO_UPLOAD: "ជ្រើសរូបភាពដើម្បីអាប់ឡូត",
    MAXIMUM_CAPACITY: "ទំហំអតិបរមា",
    LOADING: "កំពុងផ្ទុក",

    EMAIL_CONFIGURATION: "ការកំណត់អ៊ីមែល",
    HOTEL_EMAIL: "អ៊ីមែលសណ្ឋាគារ",
    EMAIL_RECEIVE_BOOKING_ALERT_CC: "អ៊ីមែលទទួលការជូនដំណឹងការកក់បន្ទប់",
    EMAIL_CO_RECEIVE_BOOKING_ALERT_CC: "អ៊ីមែលចម្លងការជូនដំណឹងការកក់ (cc email)",
    EMAIL_RECEIVE_BOOKING_ALERT_BCC: "អ៊ីមែលចម្លងសម្ងាត់ការកក់ (bcc email)",
    DISPLAY_LANGUAGE_AND_WEEKEND: "ភាសាដែលបង្ហាញ និងថ្ងៃចុងសប្ដាហ៍",
    DISPLAY_LANGUAGE: "ភាសាបង្ហាញ",
    WEEKEND: "ថ្ងៃចុងសប្ដាហ៍",
    CURRENCY_AND_TAXES_FEES: "រូបិយបណ្ណ និងពន្ធ/ថ្លៃសេវា",
    CURRENCY_USED_IN_SYSTEM: "រូបិយបណ្ណប្រើនៅក្នុងប្រព័ន្ធ",
    VAT_RATE_IS_APPLIES: "អត្រាពន្ធ VAT (%) ដែលអនុវត្ត",
    SERVICE_TAX_RATE_APPLIES: "អត្រាពន្ធសេវាកម្ម (%)",
    PRICES_INCLUDE_TAXES_FEES: "តម្លៃរួមបញ្ចូលពន្ធ/ថ្លៃសេវា",
    REGULATIONS_ON_CHILD_AGE_AND_ACCOMPANING_FEE: "បទប្បញ្ញត្តិអាយុកុមារ និងថ្លៃបន្ថែម",
    YOUTH_IS_FREE_OF_CHARGE: "អាយុអតិបរមារបស់ទារក",
    AGE_CHILD_EXTRA_CHARGE: "អាយុអតិបរមារបស់កុមារ",
    OTHER_INFOMATION: "ព័ត៌មានផ្សេងៗ",
    CHECKIN_TIME: "ម៉ោងចូលបន្ទប់",
    CHECKOUT_TIME: "ម៉ោងចាកចេញ",
    YEAR_BUILT: "ឆ្នាំសាងសង់",
    TOTAL_NUMBER_OF_FLOORS: "ចំនួនជាន់សរុប",
    DISTANCE_TO_AIRPORT: "ចម្ងាយទៅព្រលានយន្តហោះ",
    DISTANCE_TO_CITY_CENTER: "ចម្ងាយទៅមជ្ឈមណ្ឌលទីក្រុង",
    TIME_TO_AIRPORT: "ពេលវេលាចូលទៅព្រលានយន្តហោះ (នាទី)",
    VOLTAGE_USED: "វ៉ុលដែលប្រើ",
    ROOM_SERVICE: "សេវាកម្មបន្ទប់",
    HOTEL_RULES: "បទប្បញ្ញត្តិសណ្ឋាគារ",

    EFFECTIVE_DATE: "ថ្ងៃមានប្រសិទ្ធិភាព",
    DEPOSIT_BEFORE_CHECKIN: "កក់លុយជាមុន x ថ្ងៃ",
    PERCENT: "ភាគរយ",
    AMOUNT_OF_MONEY: "ចំនួនទឹកប្រាក់",
    PREPAYMENT_BEFORE_CHECKIN_DATE: "បង់ប្រាក់មុនថ្ងៃចូលបន្ទប់",
    PAYMENT_BEFORE_CHECKOUT_DATE: "បង់ប្រាក់ថ្ងៃចេញបន្ទប់",
    PAYMENT_BEFORE_DAY_CHECKIN_DATE: "បង់ប្រាក់ថ្ងៃចូលបន្ទប់",
    ADD_NEW_PAYMENT_POLICY: "បន្ថែមគោលនយោបាយបង់ប្រាក់ថ្មី",
    DEPOSIT_LEVEL_APPLIES: "កម្រិតកក់ប្រាក់អនុវត្ត",
    TIME_APPLICATION: "ពេលវេលាអនុវត្ត",

    CANCEL_ROOM_IN_ROUND_X_DAY_BEFORE_CHECKIN: "លុបការកក់ក្នុងរយៈពេល x ថ្ងៃមុនថ្ងៃចូលបន្ទប់",
    FIXED_MONEY: "ចំនួនទឹកប្រាក់ថេរ",
    ADD_NEW_CANCELLATION_POLICY: "បន្ថែមគោលនយោបាយលុបការកក់ថ្មី",
    FINES_APPLY: "ពិន័យអនុវត្ត",

    PERSONAL_ACCOUNT_SETTING: "ការកំណត់គណនីផ្ទាល់ខ្លួន",
    LOG_OUT: "ចេញ",
    _LOGIN: {
        LOGIN: "ចូលគណនី",
        USERNAME: "ឈ្មោះអ្នកប្រើប្រាស់",
        PASSWORD: "ពាក្យសម្ងាត់",
        FORGOT_PASSWORD: "ភ្លេចពាក្យសម្ងាត់",
        REGISTER_NOW: "ចុះឈ្មោះឥឡូវនេះ",
        LOOKING_AGENT: "កំពុងស្វែងរកទំព័រសម្រាប់ភ្នាក់ងារ?",
        LOGIN_HERE: "ចូលទីនេះ",
        SESSION_EXPIRED: "សម័យធ្វើការរបស់អ្នកបានផុតកំណត់!",
        HAS_NO_ACCESS: "គណនីនេះមិនមានសិទ្ធិចូលប្រើទេ!",
        SESSION_EXPIRED_MESSAGE: "សម្រាប់សុវត្ថិភាព សម័យបានផុតកំណត់បន្ទាប់ពីពេលវេលាដែលគ្មានសកម្មភាព។ សូមបញ្ចូលឈ្មោះអ្នកប្រើប្រាស់ និងពាក្យសម្ងាត់របស់អ្នកដើម្បីបន្តចូលប្រើ",
        INVALID_ACCOUNT_INFO_MESSAGE: "ឈ្មោះអ្នកប្រើប្រាស់ឬពាក្យសម្ងាត់មិនត្រឹមត្រូវ!",
        ARE_YOU_FORGOT_PASSWORD: "តើអ្នកភ្លេចពាក្យសម្ងាត់របស់អ្នកឬ?",
        ENTER_EMAIL_USERNAME: "បញ្ចូលអ៊ីមែលឬឈ្មោះអ្នកប្រើប្រាស់ដើម្បីស្ដារពាក្យសម្ងាត់!",
        EMAIL_USERNAME: "អ៊ីមែល ឬឈ្មោះអ្នកប្រើប្រាស់",
        EMAILADDRESS_ERROR_REQUIRED: "សូមពិនិត្យទម្រង់អ៊ីមែលឲ្យបានត្រឹមត្រូវ!",
        EMAIL_NOT_EXIST: "អ៊ីមែលឬឈ្មោះអ្នកប្រើមិនមានទេ សូមពិនិត្យម្តងទៀត!",
        REQUEST_RESET_PASS_NOTICE: "បានស្នើសុំស្ដារពាក្យសម្ងាត់ដោយជោគជ័យ",
        SEND_NEW_PASS: "ពាក្យសម្ងាត់ថ្មីរបស់អ្នកត្រូវបានផ្ញើទៅអ៊ីមែលរបស់អ្នក",
        CANCEL: "បោះបង់",
        RESET: "បញ្ជាក់",
        HOTELID: "លេខសម្គាល់សណ្ឋាគារ",
        EZID_LOGIN: "ចូលប្រើដោយ ezID"
    },
    _RESET: {
        NOT_VALID_REQUEST: "សំណើសុំផ្លាស់ប្ដូរពាក្យសម្ងាត់នេះមិនមានសុពលភាពទេ"
    },
    _REGISTER: {
        OTA_GROUP: "ក្រុមបណ្ដាញលក់",
        OTA: "បណ្ដាញលក់",
        WELCOME: "សូមស្វាគមន៍មកកាន់ ezCrs - រចនាឡើងសម្រាប់សណ្ឋាគារដោយឯកច្ឆន្ទ",
        SOLOGAN: "ចុះឈ្មោះជាមួយយើងថ្ងៃនេះ ហើយយើងនឹងគាំទ្រអ្នកពីដើមដល់ចុង។ អ្នកអាចកក់ផលិតផលនានា និងលក់ទៅអតិថិជនរបស់អ្នក។ ចូលរួមជាមួយយើងឥឡូវនេះ!!!",
        PERSONAL_DETAIL: "ព័ត៌មានផ្ទាល់ខ្លួន",
        HOTEL_DETAIL: "ព័ត៌មានសណ្ឋាគារ",
        CREATE_ACCOUNT: "បង្កើតគណនី",
        ENTER: "បញ្ចូល",
        ENTER_TAX_CODE: "បញ្ចូលលេខកូដពន្ធ",
        ENTER_ROOM_QUANTITY: "បញ្ចូលចំនួនបន្ទប់សរុប",
        YOUR_COMPANY_NAME: "ឈ្មោះក្រុមហ៊ុន/ម៉ាករបស់អ្នក",
        YOUR_WEBSITE_LINK: "តំណភ្ជាប់វែបសាយរបស់អ្នក",
        SELECT: "ជ្រើសរើស",
        REQUIRED: "ត្រូវបំពេញ",
        FULLNAME: "នាមត្រកូល និងនាមខ្លួន",
        YOUR_FULLNAME: "នាមត្រកូល និងនាមខ្លួនរបស់អ្នក",
        PERSONAL_PHONE: "លេខទូរស័ព្ទផ្ទាល់ខ្លួន",
        MALE: "ប្រុស",
        FEMALE: "ស្រី",
        EMAIL: "អ៊ីមែល",
        YOUR_EMAIL: "អ៊ីមែលរបស់អ្នក",
        POSITION: "មុខតំណែង",
        YOUR_POSITION: "មុខតំណែងរបស់អ្នក",
        HOTEL_NAME: "ឈ្មោះសណ្ឋាគារ",
        HOTEL_TYPE: "ប្រភេទសណ្ឋាគារ",
        TAX_CODE: "លេខកូដពន្ធ",
        COUNTRY: "ប្រទេស",
        WARD: "សង្កាត់/ភូមិ",
        WEBSITE: "គេហទំព័រ",
        STAR: "ចំណាត់ថ្នាក់ផ្កាយ",
        CITY: "ខេត្ត/ក្រុង",
        ADDRESS: "អាសយដ្ឋាន",
        HOTEL_PHONE: "លេខទូរស័ព្ទសណ្ឋាគារ",
        HOTEL_EMAIL: "អ៊ីមែលសណ្ឋាគារ",
        ENTER_EMAIL: "បញ្ចូលអ៊ីមែល",
        NUMBER_OF_ROOMS: "ចំនួនបន្ទប់",
        DISTRICT: "តំបន់/កន្ទង់ទាត់/តារាងពិន័យ",
        USERNAME: "ឈ្មោះអ្នកប្រើប្រាស់",
        CREATE_NEW_ACCOUNT_NAME: "បង្កើតឈ្មោះគណនីថ្មី",
        PASSWORD: "ពាក្យសម្ងាត់",
        CREATE_PASSWORD: "បង្កើតពាក្យសម្ងាត់",
        RETYPE_PASSWORD: "បញ្ចូលពាក្យសម្ងាត់ម្ដងទៀត",
        PHONE_NUMBER_NOT_LESS_THAN: "លេខទូរស័ព្ទត្រូវមានយ៉ាងហោចណាស់ 8 តួអក្សរ",
        PASSWORD_NOT_LESS_THAN: "ពាក្យសម្ងាត់ត្រូវមានយ៉ាងហោចណាស់ 8 តួអក្សរ",
        VALID_USERNAME_MESSAGE: "សូមជ្រើសរើសឈ្មោះអ្នកប្រើដែលមានតែអក្សរ និងលេខ",
        BY_CLICKING_REGISTER: "ដោយចុចចុះឈ្មោះ អ្នកយល់ព្រមនឹង",
        TERM_AND_CONDITIONS: "លក្ខខណ្ឌ និងលក្ខន់សម្រាប់ប្រើប្រាស់",
        PRIVACY_POLICY: "គោលនយោបាយឯកជនភាព",
        AGREE_POLICY_MESSAGE: "ដើម្បីបន្ត សូមយល់ព្រមនឹងលក្ខខណ្ឌ និងគោលនយោបាយឯកជនភាពរបស់យើង",
        THANKS_FOR_REGISTER: "សូមអរគុណចំពោះការចុះឈ្មោះ!",
        WAIT_APPROVE: "គណនីរបស់អ្នកបានចុះឈ្មោះដោយជោគជ័យ ហើយកំពុងរងចាំការអនុម័ត។",
        UPLOAD_CERTIFICATE_MESSAGE: "សូមអាប់ឡូតវិញ្ញាបនបត្រចុះបញ្ជីពាណិជ្ជកម្ម ដើម្បីជួយយើងផ្ទៀងផ្ទាត់ និងបើកគណនី។ យើងនឹងអនុម័តក្នុងរយៈពេល 48 ម៉ោង។",
        REQUIRED_FIELD: "វាលត្រូវបំពេញ",
        ACCOUNT_ALREADY_EXISTS: "គណនីមានរួចហើយ",
        PASSWORD_NOT_MATCH: "ពាក្យសម្ងាត់មិនដូចគ្នា",
        REGISTER: "ចុះឈ្មោះ",
        NEXT: "បន្ទាប់",
        BACK: "ថយក្រោយ",
        UPLOAD_FILE: "អាប់ឡូតឯកសារ",
        COMPLETE_AND_LOGIN: "បញ្ចប់ និងត្រលប់ទៅទំព័រដើម"
    },
    _LEFT_MENU: {
        COPY_RIGHT: "រក្សាសិទ្ធិ © 2021 ezCloud រក្សាសិទ្ធិគ្រប់យ៉ាង"
    },
    _ACTIVITY: {
        ACTION_DATE: "កាលបរិច្ឆេទប្រតិបត្តិការ",
        ACTION_BY: "អ្នកបានប្រតិបត្តិ",
        APPLY_DATE: "កាលបរិច្ឆេទអនុវត្ត",
        CREATED_DATE: "កាលបរិច្ឆេទបង្កើត",
        ROOM_NAME: "ឈ្មោះបន្ទប់",
        RATE: "តម្លៃ",
        CREATE_DATE: "កាលបរិច្ឆេទបង្កើត",
        SEARCH_DATE: "កាលបរិច្ឆេទអនុវត្ត",
        USER_NAME: "គណនី",
        ROOM: "បន្ទប់",
        ROOM_PLAN: "ផែនការបន្ទប់",
        YES: "បាទ/ចាស",
        NO: "ទេ",
        STOPSELL: "បញ្ឈប់ការលក់",
        MINSTAY: "ចំនួនថ្ងៃស្នាក់នៅអប្បបរមា",
        CLOSEDTOARRIVE: "មិនអនុញ្ញាតឲ្យចូល",
        MAXSTAY: "ចំនួនថ្ងៃស្នាក់នៅអតិបរមា",
        CLOSEDTODEPATURE: "មិនអនុញ្ញាតឲ្យចាកចេញ",
        IPADDRESS: "អាសយដ្ឋាន IP",
        CREATEDBY: "អ្នកបង្កើត",
        PAGING: "ទំព័រ",
        DOCUMENT: "ឯកសារ",
        ROOMAVAIL: "ចំនួនបន្ទប់នៅទំនេរ",
        ALLSELECT: "ទាំងអស់",
        HOTELID: "លេខសម្គាល់សណ្ឋាគារ",
        HOTELNAME: "ឈ្មោះសណ្ឋាគារ",
        DATABEFORE: "ទិន្នន័យពីមុន",
        DATAAFTER: "ទិន្នន័យបន្ទាប់",
        ACTION: "សកម្មភាព",

        HOTEL_LOGIN: "ចូលគណនីសណ្ឋាគារ",
        HOTEL_CANCEL_BOOKING: "បោះបង់ការកក់បន្ទប់",
        HOTEL_UPDATE_PAYMENT_BOOKING: "បញ្ជាក់ការកក់បន្ទប់",
        HOTEL_REQUEST_BOOKING: "បញ្ជាក់សំណើរកក់បន្ទប់",
        HOTEL_ROOM_PLAN_CREATE: "បន្ថែមគោលនយោបាយតម្លៃថ្មី",
        HOTEL_ROOM_PLAN_UPDATE: "ធ្វើបច្ចុប្បន្នភាពគោលនយោបាយតម្លៃ",
        HOTEL_ROOM_PLAN_COPY: "ចម្លងគោលនយោបាយតម្លៃ",
        HOTEL_ROOM_PLAN_DELETE: "លុបគោលនយោបាយតម្លៃ",

        HOTEL_PROMOTION_CREATE: "បន្ថែមការផ្តល់ជូន",
        HOTEL_PROMOTION_UPDATE: "ធ្វើបច្ចុប្បន្នភាពការផ្តល់ជូន",
        HOTEL_PROMOTION_COPY: "ចម្លងការផ្តល់ជូន",
        HOTEL_PROMOTION_DELETE: "លុបការផ្តល់ជូន",

        HOTEL_PROFILE_UPDATE: "ធ្វើបច្ចុប្បន្នភាពពត៌មានផ្ទាល់ខ្លួន",
        HOTEL_AVATAR_ADD: "បន្ថែមរូបតំណាង",
        HOTEL_AVATAR_REMOVE: "លុបរូបតំណាង",
        HOTEL_CHANGE_PASSWORD_PROFILE: "ផ្លាស់ប្តូរពាក្យសម្ងាត់",

        HOTEL_USER_CREATE: "បន្ថែមអ្នកប្រើ",
        HOTEL_USER_UPDATE: "ធ្វើបច្ចុប្បន្នភាពអ្នកប្រើ",
        HOTEL_USER_UPDATE_ROLE: "ធ្វើបច្ចុប្បន្នភាពសិទ្ធិអ្នកប្រើ",
        HOTEL_USER_DELETE: "លុបអ្នកប្រើ",

        HOTEL_GROUP_CREATE: "បង្កើតក្រុមអ្នកប្រើ",
        HOTEL_GROUP_UPDATE: "ធ្វើបច្ចុប្បន្នភាពក្រុមអ្នកប្រើ",
        HOTEL_GROUP_UPDATE_ROLE: "ធ្វើបច្ចុប្បន្នភាពសិទ្ធិក្រុមអ្នកប្រើ",
        HOTEL_GROUP_DELETE: "លុបក្រុមអ្នកប្រើ",

        HOTEL_CONTRACT_UPDATE: "ធ្វើបច្ចុប្បន្នភាពព័ត៌មានកិច្ចសន្យា",
        HOTEL_INFO_UPDATE: "ធ្វើបច្ចុប្បន្នភាពព័ត៌មានសណ្ឋាគារ",
        HOTEL_UPDATE_AMENITIES: "ធ្វើបច្ចុប្បន្នភាពបរិក្ខារ",
        HOTEL_UPDATE_IMAGES: "បន្ថែមរូបភាពក្នុងវិចិត្រសាល",
        HOTEL_DELETE_IMAGES: "លុបរូបភាពក្នុងវិចិត្រសាល",

        HOTEL_AREA_CREATED: "បន្ថែមតំបន់ជិតខាង",
        HOTEL_AREA_UPDATED: "ធ្វើបច្ចុប្បន្នភាពតំបន់ជិតខាង",
        HOTEL_AREA_DELETED: "លុបតំបន់ជិតខាង",

        HOTEL_CHAIN_CREATED: "បន្ថែមខ្សែសណ្ឋាគារ",
        HOTEL_CHAIN_UPDATED: "ធ្វើបច្ចុប្បន្នភាពខ្សែសណ្ឋាគារ",

        HOTEL_ROOM_CREATED: "បន្ថែមប្រភេទបន្ទប់",
        HOTEL_ROOM_UPDATED: "ធ្វើបច្ចុប្បន្នភាពព័ត៌មានបន្ទប់",
        HOTEL_ROOM_COPY: "ចម្លងប្រភេទបន្ទប់",
        HOTEL_ROOM_DELETED: "លុបប្រភេទបន្ទប់",
        HOTEL_ROOM_AMENITY: "ធ្វើបច្ចុប្បន្នភាពបរិក្ខារបន្ទប់",
        HOTEL_ROOM_ADD_IMAGES: "បន្ថែមរូបភាពបន្ទប់",
        HOTEL_ROOM_DELETE_IMAGES: "លុបរូបភាពបន្ទប់",

        HOTEL_UPDATE_HOTEL_SETTING_INFO: "ធ្វើបច្ចុប្បន្នភាពការកំណត់សណ្ឋាគារ",

        HOTEL_PAYMENT_POLICY_CREATED: "បង្កើតគោលនយោបាយបង់ប្រាក់ថ្មី",
        HOTEL_PAYMENT_POLICY_UPDATED: "ធ្វើបច្ចុប្បន្នភាពគោលនយោបាយបង់ប្រាក់",
        HOTEL_PAYMENT_POLICY_DELETED: "លុបគោលនយោបាយបង់ប្រាក់",

        HOTEL_CANCEL_POLICY_CREATED: "បង្កើតគោលនយោបាយបោះបង់ថ្មី",
        HOTEL_CANCEL_POLICY_UPDATED: "ធ្វើបច្ចុប្បន្នភាពគោលនយោបាយបោះបង់",
        HOTEL_CANCEL_POLICY_DELETED: "លុបគោលនយោបាយបោះបង់",

        HOTEL_SETTING_PAYMENT_GATE: "កំណត់ច្រកទូទាត់",
        HOTEL_ADD_IMAGES_SLIDE: "ធ្វើបច្ចុប្បន្នភាពរូបភាពសណ្ឋាគារ",
        HOTEL_DELETE_IMAGES_SLIDE: "លុបរូបភាពសណ្ឋាគារ",

        HOTEL_REMOVE_CONNECT_AGENT: "ផ្ដាច់ការតភ្ជាប់ភ្នាក់ងារ",
        HOTEL_UPDATE_LEVEL_AGENT: "ធ្វើបច្ចុប្បន្នភាពកម្រិតភ្នាក់ងារ",
        HOTEL_RETURN_CONNECT_AGENT: "ត្រឡប់ការតភ្ជាប់ភ្នាក់ងារ",

        PMS_CONFIRM: "បញ្ជាក់ការធ្វើសមកាលកម្ម",
        RATE_CATEGORY_CREATE: "បង្កើតចំណាត់ថ្នាក់តម្លៃ",
        RATE_CATEGORY_UPDATE: "ព័ត៌មានលម្អិតអំពីចំណាត់ថ្នាក់តម្លៃ",
        ROOM_CATEGORY_CREATE: "បង្កើតចំណាត់ថ្នាក់បន្ទប់",
        ROOM_CATEGORY_UPDATE: "ព័ត៌មានលម្អិតអំពីចំណាត់ថ្នាក់បន្ទប់"
    },
    STATUS_CREATE_NEW: "បង្កើតថ្មី",
    STATUS_DELIVERED: "បានដឹកជញ្ជូន",
    STATUS_SALE_SEND_HOTEL: "ផ្ញើអោយសណ្ឋាគារអនុម័ត",
    STATUS_SALE_ADMIN_SEND_BACK: "SM បានបដិសេធ",
    STATUS_SALE_ADMIN_PASSED: "SM បានអនុម័ត",
    STATUS_QC_SENT_BACK_HOTEL: "QC បានបដិសេធ",
    STATUS_QC_PASSED_HOTEL: "QC បានអនុម័ត",
    STATUS_SALE_ADDITIONAL: "ផ្ញើអោយ TT អនុម័ត",
    STATUS_QC_SENT_BACK_INFOR: "QC បានបដិសេធ TT",
    STATUS_QC_PASSED_INFOR: "QC បានអនុម័ត TT",
    STATUS_ONSITE: "នៅសណ្ឋាគារ",
    STATUS_OFFSITE: "ខាងក្រៅសណ្ឋាគារ",
    STATUS_RELEASED: "បានចេញផ្សាយ",

    STATUS_SIGNED: "បានចុះហត្ថលេខា",
    STATUS_WAITING_SIGN: "កំពុងរងចាំចុះហត្ថលេខា",
    STATUS_CLOSED: "បានបិទ",
    STATUS_IN_DISPUTE: "មានការជម្លោះ",
    STATUS_LIQUIDATED: "បានរំលាយ",
    STATUS_COMPLETED: "បានបញ្ចប់",
    STATUS_CM_PASSED: "CM បានអនុម័ត",
    STATUS_CM_SEND_BACK: "CM បានបដិសេធ",
    STATUS_RENEWAL: "បង្កើតថ្មី",
    STATUS_CHANGED: "បានផ្លាស់ប្ដូរទៅស្ថានភាព",

    STATUS_AWAIT_PAYMENT: "កំពុងរងចាំការទូទាត់",
    STATUS_AWAIT_FULLY_PAYMENT: "កំពុងរងចាំទូទាត់ទាំងស្រុង",
    STATUS_PAYMENT_FAILED: "បរាជ័យក្នុងការទូទាត់",
    STATUS_CONFIRM: "បញ្ជាក់",

    ALL: "ទាំងអស់",
    CANCEL: "បោះបង់ដោយអតិថិជន",
    AWAIT_PAYMENT: "កំពុងរងចាំការទូទាត់",
    IN_SERVICE: "កំពុងប្រើប្រាស់",
    PAYMENT_FAILED: "ការទូទាត់បរាជ័យ",
    AWAIT_FULLY_PAYMENT: "បានទូទាត់ផ្នែកមួយ",
    VOID: "បានបោះបង់ដោយសណ្ឋាគារ",
    STATUS_WAIT_FEEDBACK: "កំពុងរងចាំមតិអនុញ្ញាត",
    STATUS_FEEDBACK: "បានផ្តល់មតិ",
    STATUS_COMPLETE: "បញ្ចប់",
    STATUS_CANCEL: "បានបោះបង់",

    BOOKING: "ការកក់បន្ទប់",
    BOOKING_STATUS: "ស្ថានភាពការកក់បន្ទប់",
    BOOKING_REQUEST_STATUS: "ស្ថានភាពសំណើការកក់",
    CONTRACT_STATUS: "ស្ថានភាពកិច្ចសន្យា",
    TA_STATUS: "ស្ថានភាពភ្នាក់ងារ",
    HOTEL_STATUS: "ស្ថានភាពសណ្ឋាគារ",
    SHOW_MORE: "បង្ហាញបន្ថែម",
    NOTIFICATION: "សេចក្តីជូនដំណឹង",
    HAS_JUST_JOINED_ONEI: "បានចូលរួម OneInventory.com",
    HAS_JUST_CREATED_ONEI: "ត្រូវបានបង្កើតថ្មីនៅលើ OneInventory.com",
    ANNEX_OF_CONTRACT: "បន្ថែមនៃកិច្ចសន្យាលេខ",
    HOTELS_CONTRACT: "កិច្ចសន្យារបស់សណ្ឋាគារ",
    YOUR_AGENT: "ភ្នាក់ងាររបស់អ្នក",
    MARK_AS_READ: "សម្គាល់ថាបានអាន",
    CONTACT_NUMBER: "លេខកិច្ចសន្យា",
    BELONG_HOTEL: "របស់សណ្ឋាគារ",
    AGENT: "ភ្នាក់ងារ",
    ADDENDUM_OF_CONTRACT: "បន្ថែមនៃកិច្ចសន្យាលេខ",
    NEW_TA: "ភ្នាក់ងារថ្មី",
    STATUS_NEW_CREATE: "បង្កើតថ្មី",
    EXTEND_CONTRACT: "បន្ថែមអាយុកិច្ចសន្យា",
    RE_RELEASE: "ចេញផ្សាយម្ដងទៀត",
    AGO: "មុន",
    MONTHS: "ខែ",
    YEARS: "ឆ្នាំ",
    SECONDS: "វិនាទី",
    MINUTES: "នាទី",
    HOURS: "ម៉ោង",
    NOW: "ថ្មីៗនេះ",
    DAYS: "ថ្ងៃ",
    REQUEST_EMPTY: "រកមិនឃើញសំណើ",
    STATUS_INCORRECT: "ស្ថានភាពមិនមែនជា 'កំពុងរងចាំការឆ្លើយតប'",
    STATUS_CONTRACT_INCORRECT: "ស្ថានភាពកិច្ចសន្យាមិនមែនជា 'បានចុះហត្ថលេខា'",
    NO_NOTIFICATION: "មិនមានការជូនដំណឹងថ្មី",
    ADDENDUM_STATUS: "ស្ថានភាពបន្ថែមនៃកិច្ចសន្យា",
    OVER_CHARACTER: "អ្នកបានលើសអតិបរមា តួអក្សរដែលអាចបញ្ចូល",

    HOTEL_LOG_bookingCode: "លេខកូដការកក់",
    HOTEL_LOG_agentName: "ឈ្មោះភ្នាក់ងារ",
    HOTEL_LOG_customer: "អតិថិជន",
    HOTEL_LOG_createdDate: "ថ្ងៃបង្កើត",
    HOTEL_LOG_checkinDate: "ថ្ងៃចូលស្នាក់នៅ",
    HOTEL_LOG_checkoutDate: "ថ្ងៃចាកចេញ",
    HOTEL_LOG_totalCost: "ចំនួនសរុប",
    HOTEL_LOG_payableAmount: "ចំនួនទឹកប្រាក់ដែលបានបង់",
    HOTEL_LOG_bookingStatus: "ស្ថានភាពការកក់",
    HOTEL_LOG_active: "សកម្ម",
    HOTEL_LOG_amount: "ចំនួនទឹកប្រាក់ / ភាគរយ",
    HOTEL_LOG_cancellationDay: "ចំនួនថ្ងៃមុនការបោះបង់",
    HOTEL_LOG_cancellationType: "ប្រភេទនៃការបោះបង់",
    HOTEL_LOG_startDate: "ថ្ងៃចាប់ផ្តើម",
    HOTEL_LOG_endDate: "ថ្ងៃបញ្ចប់",
    HOTEL_LOG_hotelId: "លេខសម្គាល់សណ្ឋាគារ",
    HOTEL_LOG_type: "រយៈពេលអនុវត្ត",
    HOTEL_LOG_notifyToEmail: "អ៊ីមែលសម្រាប់ទទួលការជូនដំណឹង",
    HOTEL_LOG_notifyCCEmail: "អ៊ីមែល CC សម្រាប់ការជូនដំណឹង",
    HOTEL_LOG_notifyBCCEmail: "អ៊ីមែល BCC សម្រាប់ការជូនដំណឹង",
    HOTEL_LOG_includeTaxesInPrice: "តម្លៃរួមបញ្ចូលពន្ធនិងថ្លៃសេវា",
    HOTEL_LOG_language: "ភាសា",
    HOTEL_LOG_weekend: "ចុងសប្ដាហ៍",
    HOTEL_LOG_email: "អ៊ីមែល",
    HOTEL_LOG_checkinAfterHour: "ម៉ោងចូលបន្ទប់",
    HOTEL_LOG_checkoutBeforeHour: "ម៉ោងចាកចេញ",
    HOTEL_LOG_roomServices: "សេវាកម្មបន្ទប់",
    HOTEL_LOG_hotelPolicyVi: "គោលការណ៍សណ្ឋាគារ (វៀតណាម)",
    HOTEL_LOG_hotelPolicyEn: "គោលការណ៍សណ្ឋាគារ (អង់គ្លេស)",
    HOTEL_LOG_yearOfBuild: "ឆ្នាំសាងសង់",
    HOTEL_LOG_numberOfFloors: "ចំនួនជាន់សរុប",
    HOTEL_LOG_numberOfRooms: "ចំនួនបន្ទប់សរុប",
    HOTEL_LOG_minutesToAirport: "រយៈពេលទៅព្រលានយន្តហោះ (នាទី)",
    HOTEL_LOG_babyAgeDetermine: "អាយុកូនក្មេងដែលត្រូវបានលើកលែង",
    HOTEL_LOG_childAgeDetermine: "អាយុកូនក្មេងដែលត្រូវបង់ថ្លៃបន្ថែម",
    HOTEL_LOG_electronicVoltage: "វ៉ុលអគ្គិសនីប្រើប្រាស់",
    HOTEL_LOG_distanceToAirport: "ចម្ងាយទៅព្រលានយន្តហោះ",
    HOTEL_LOG_serviceTaxPercent: "ភាគរយពន្ធសេវាកម្ម",
    HOTEL_LOG_valueAddedTaxPercent: "ភាគរយពន្ធ VAT",
    HOTEL_LOG_distanceToCenter: "ចម្ងាយទៅកណ្តាលទីក្រុង",
    HOTEL_LOG_lat: "រយៈទទឹង",
    HOTEL_LOG_lng: "រយៈបណ្តោយ",
    HOTEL_LOG_phoneNum: "លេខទូរសព្ទ័ទំនាក់ទំនង",
    HOTEL_LOG_hotLine: "លេខទូរសព្ទ័បន្ទាន់",
    HOTEL_LOG_starRanking: "ចំណាត់ថ្នាក់ផ្កាយ",
    HOTEL_LOG_website: "គេហទំព័រ",
    HOTEL_LOG_addressVi: "អាសយដ្ឋាន (វៀតណាម)",
    HOTEL_LOG_addressEn: "អាសយដ្ឋាន (អង់គ្លេស)",
    HOTEL_LOG_hotelNameVi: "ឈ្មោះសណ្ឋាគារ (វៀតណាម)",
    HOTEL_LOG_hotelNameEn: "ឈ្មោះសណ្ឋាគារ (អង់គ្លេស)",
    HOTEL_LOG_hotelTypeVi: "ប្រភេទសណ្ឋាគារ (វៀតណាម)",
    HOTEL_LOG_hotelTypeEn: "ប្រភេទសណ្ឋាគារ (អង់គ្លេស)",
    HOTEL_LOG_cityVi: "ទីក្រុង/ខេត្ត (វៀតណាម)",
    HOTEL_LOG_countryVi: "ប្រទេស (វៀតណាម)",
    HOTEL_LOG_locationVi: "ស្រុក/ខណ្ឌ (វៀតណាម)",
    HOTEL_LOG_cityEn: "ទីក្រុង/ខេត្ត (អង់គ្លេស)",
    HOTEL_LOG_areaVi: "តំបន់ (វៀតណាម)",
    HOTEL_LOG_countryEn: "ប្រទេស (អង់គ្លេស)",
    HOTEL_LOG_locationEn: "ស្រុក/ខណ្ឌ (អង់គ្លេស)",
    HOTEL_LOG_areaEn: "តំបន់ (អង់គ្លេស)",
    HOTEL_LOG_descriptionVi: "សេចក្ដីពិពណ៌នា (វៀតណាម)",
    HOTEL_LOG_descriptionEn: "សេចក្ដីពិពណ៌នា (អង់គ្លេស)",
    HOTEL_LOG_depositType: "ប្រភេទប្រាក់កក់",
    HOTEL_LOG_cutOfDate: "កក់មុនថ្ងៃ",
    HOTEL_LOG_paymentDay: "ទូទាត់មុនចំនួនថ្ងៃ",
    HOTEL_LOG_proNameVi: "ឈ្មោះបញ្ចុះតម្លៃ (វៀតណាម)",
    HOTEL_LOG_proNameEn: "ឈ្មោះបញ្ចុះតម្លៃ (អង់គ្លេស)",
    HOTEL_LOG_promoType: "ប្រភេទ",
    HOTEL_LOG_sessionType: "រយៈពេលស្នាក់នៅ",
    HOTEL_LOG_discountOrSurcharge: "ការបញ្ចុះតម្លៃ / បន្ថែមថ្លៃ",
    HOTEL_LOG_orderType: "អនុវត្តចំពោះ",
    HOTEL_LOG_notApplyDates: "ថ្ងៃដែលមិនអនុវត្ត",
    HOTEL_LOG_applyPlans: "ផែនការដែលអនុវត្ត",
    HOTEL_LOG_applyAgents: "ភ្នាក់ងារដែលអនុវត្ត",
    HOTEL_LOG_applyLevels: "កម្រិតភ្នាក់ងារអនុវត្ត",
    HOTEL_LOG_applyDays: "ថ្ងៃអនុវត្ត",
    HOTEL_LOG_bookType: "រយៈពេលការកក់",
    HOTEL_LOG_fromDays: "ចាប់ពីថ្ងៃ",
    HOTEL_LOG_toDays: "ដល់ថ្ងៃ",
    HOTEL_LOG_minOrder: "បរិមាណអប្បបរមា",
    HOTEL_LOG_freeForMinOrder: "បរិមាណដែលត្រូវបានលើកលែង",
    HOTEL_LOG_percentOrFixed: "ប្រភេទការបញ្ចុះតម្លៃ",
    HOTEL_LOG_startBook: "ចាប់ពីថ្ងៃ",
    HOTEL_LOG_endBook: "ដល់ថ្ងៃ",
    HOTEL_LOG_objectType: "វត្ថុប្រើប្រាស់",
    HOTEL_LOG_delete: "លុប",
    HOTEL_LOG_promotionNameVi: "ឈ្មោះបញ្ចុះតម្លៃ (វៀតណាម)",
    HOTEL_LOG_promotionNameEn: "ឈ្មោះបញ្ចុះតម្លៃ (អង់គ្លេស)",
    HOTEL_LOG_promotionDesVi: "សេចក្ដីពិពណ៌នា (វៀតណាម)",
    HOTEL_LOG_promotionDesEn: "សេចក្ដីពិពណ៌នា (អង់គ្លេស)",
    HOTEL_LOG_code: "លេខសំណើ",
    HOTEL_LOG_note: "ចំណាំ",
    HOTEL_LOG_requestStatus: "ស្ថានភាពសំណើ",
    HOTEL_LOG_fullName: "ឈ្មោះពេញ",
    HOTEL_LOG_gender: "ភេទ",
    HOTEL_LOG_phoneNumber: "លេខទូរសព្ទ័",
    HOTEL_LOG_position: "មុខងារ",
    HOTEL_LOG_address: "អាសយដ្ឋាន",
    HOTEL_LOG_maxChildren: "កុមារ",
    HOTEL_LOG_maxAdults: "មនុស្សពេញវ័យ",
    HOTEL_LOG_totalRoom: "ចំនួនបន្ទប់សរុប",
    HOTEL_LOG_defaultPrice: "តម្លៃថ្ងៃធម្មតា",
    HOTEL_LOG_weekendPrice: "តម្លៃចុងសប្ដាហ៍",
    HOTEL_LOG_roomSize: "ទំហំបន្ទប់",
    HOTEL_LOG_numberOfExtraBeds: "ចំនួនគ្រែបន្ថែម",
    HOTEL_LOG_bedTypeTitleVi: "ឈ្មោះបន្ទប់ (វៀតណាម)",
    HOTEL_LOG_bedTypeTitleEn: "ឈ្មោះបន្ទប់ (អង់គ្លេស)",
    HOTEL_LOG_viewVi: "ទេសភាព (វៀតណាម)",
    HOTEL_LOG_viewEn: "ទេសភាព (អង់គ្លេស)",
    HOTEL_LOG_bedTypeVi: "ប្រភេទគ្រែ (វៀតណាម)",
    HOTEL_LOG_bedTypeEn: "ប្រភេទគ្រែ (អង់គ្លេស)",
    HOTEL_LOG_sellAllotment: "ការបែងចែកបន្ទប់",
    HOTEL_LOG_roomName: "ឈ្មោះបន្ទប់",
    HOTEL_LOG_amenityName: "គ្រឿងបរិក្ខារ",
    HOTEL_LOG_id: "លេខសម្គាល់",
    HOTEL_LOG_nameVi: "ឈ្មោះ (វៀតណាម)",
    HOTEL_LOG_nameEn: "ឈ្មោះ (អង់គ្លេស)",
    HOTEL_LOG_adultsIncluded: "ចំនួនមនុស្សពេញវ័យ",
    HOTEL_LOG_exAdult: "តម្លៃបន្ថែមសម្រាប់មនុស្សពេញវ័យ",
    HOTEL_LOG_aexType: "ប្រភេទមនុស្សពេញវ័យ",
    HOTEL_LOG_childrenInclued: "ចំនួនកុមារ",
    HOTEL_LOG_exChild: "តម្លៃបន្ថែមសម្រាប់កុមារ",
    HOTEL_LOG_cexType: "ប្រភេទកុមារ",
    HOTEL_LOG_start: "ចាប់ពីថ្ងៃ",
    HOTEL_LOG_end: "ដល់ថ្ងៃ",
    HOTEL_LOG_sesType: "រយៈពេលស្នាក់នៅ",
    HOTEL_LOG_minStay: "ចំនួនយប់អប្បបរមា",
    HOTEL_LOG_maxStay: "ចំនួនយប់អតិបរមា",
    HOTEL_LOG_extraBedPrice: "តម្លៃគ្រែបន្ថែម",
    HOTEL_LOG_rooms: "ឈ្មោះបន្ទប់",
    HOTEL_LOG_meals: "អាហាររួមបញ្ចូល",
    HOTEL_LOG_plans: "ឈ្មោះផែនការ",
    HOTEL_LOG_promotions: "ឈ្មោះបញ្ចុះតម្លៃ",
    HOTEL_LOG_avatar: "ឈ្មោះរូបតំណាង",
    HOTEL_LOG_userName: "ឈ្មោះចូលប្រើប្រាស់",
    HOTEL_LOG_userGroup: "ក្រុមអ្នកប្រើ",
    HOTEL_LOG_owner: "ម្ចាស់",
    HOTEL_LOG_name: "ឈ្មោះ",
    HOTEL_LOG_functions: "មុខងារ",
    HOTEL_LOG_users: "ឈ្មោះអ្នកប្រើប្រាស់",
    HOTEL_LOG_description: "សេចក្ដីពិពណ៌នា",
    HOTEL_LOG_enterpriseName: "ឈ្មោះសហគ្រាស",
    HOTEL_LOG_registeredAddress: "អាសយដ្ឋានចុះបញ្ជីពាណិជ្ជកម្ម",
    HOTEL_LOG_taxCode: "លេខកូដពន្ធ",
    HOTEL_LOG_bankAccountNumber: "លេខគណនីធនាគារ",
    HOTEL_LOG_bankAccountName: "ឈ្មោះម្ចាស់គណនី",
    HOTEL_LOG_bankName: "ឈ្មោះធនាគារ",
    HOTEL_LOG_bankBranch: "សាខាធនាគារ",
    HOTEL_LOG_representative: "តំណាងច្បាប់",
    HOTEL_LOG_signer: "អ្នកចុះហត្ថលេខា",
    HOTEL_LOG_area: "តំបន់",
    HOTEL_LOG_location: "ស្រុក/ខណ្ឌ",
    HOTEL_LOG_city: "ទីក្រុង",
    HOTEL_LOG_country: "ប្រទេស",
    HOTEL_LOG_hotline: "លេខទូរសព្ទ័បន្ទាន់",
    HOTEL_LOG_images: "ឈ្មោះរូបភាព",
    HOTEL_LOG_amenities: "ឈ្មោះគ្រឿងបរិក្ខារ",
    HOTEL_LOG_landmark: "ក្រុមទីតាំង",
    HOTEL_LOG_distance: "ចម្ងាយ",
    HOTEL_LOG_unit: "ឯកតាវាស់",
    HOTEL_LOG_hotelChains: "សង្វាក់សណ្ឋាគារ",
    HOTEL_LOG_roomId: "លេខសម្គាល់បន្ទប់",
    HOTEL_LOG_views: "ទេសភាព",
    HOTEL_LOG_agentId: "លេខសម្គាល់ភ្នាក់ងារ",
    HOTEL_LOG_areas: "ឈ្មោះតំបន់ជិតខាង",
    HOTEL_LOG_level: "កម្រិតភ្នាក់ងារ",
    HOTEL_LOG_userGroups: "ឈ្មោះក្រុមអ្នកប្រើប្រាស់",
    HOTEL_LOG_hotelType: "ប្រភេទសណ្ឋាគារ",
    HOTEL_LOG_logo: "និមិត្តសញ្ញាសណ្ឋាគារ",
    HOTEL_LOG_currency: "រូបិយបណ្ណ",
    HOTEL_LOG_pmsConfirm: "PMS",
    HOTEL_LOG_restriction: "កំហិត",
    OTHER_POLICY: "គោលនយោបាយផ្សេងទៀត",
    IF_CANCELED: "បោះបង់ការកក់ក្នុងរយៈពេល",
    DAYS_PRIOR_TO_ARRIVAL_DATE: "ថ្ងៃមុនថ្ងៃមកដល់",
    OF_THE_BOOKING_VALUE_WILL_CHARGED: "តម្លៃការកក់នឹងត្រូវគិតបន្ថែម",
    WILL_BE_CHARGED: "នឹងត្រូវគិតបន្ថែម",
    WILL_BE_CHARGED_POCUP: "នឹងត្រូវគិតបន្ថែម",
    RESERVATIONS: "ការកក់",
    REQUIES_A_DEPOSIT: "ត្រូវការការដាក់ប្រាក់ដើម",
    OF_THE_BOOKING_VALUE: "តម្លៃការកក់",
    THE_REMAINING_AMOUNT: "ចំនួនទុននៅសល់ត្រូវបង់មុន",
    THE_REMAINING_DAYS: "ចំនួនទុននៅសល់ត្រូវបង់មុនពេលមកដល់",
    PAYMENT_WHEN_CHECKIN: "បង់ប្រាក់ទាំងមូលមុនពេលមកដល់ (ឥតគិតប្រាក់ដាក់ប្រាក់ដើម)",
    PAYMENT_WHEN_CHECKOUT: "បង់ប្រាក់ទាំងមូលមុនពេលបញ្ចប់ការស្នាក់នៅ (ឥតគិតប្រាក់ដាក់ប្រាក់ដើម)",
    VIEWDETAIL_PHOTO: "មើលរូបភាពបន្ថែម",
    PAYMENT_100: "បង់ប្រាក់ 100% នៃតម្លៃការកក់",
    CANCEL_100: "បោះបង់ការកក់នឹងត្រូវគិតបន្ថែម 100% នៃតម្លៃការកក់",
    FREE_DEPOSIT: "ឥតគិតប្រាក់ដាក់ប្រាក់ដើម",
    ARRIVAL_DATE: "ថ្ងៃមកដល់",
    LEAVING_DATE: "ថ្ងៃចាកចេញ",
    CHIlDRENTS: "កុមារ",
    CHIlDRENT: "កុមារ",
    ADULTS: "មនុស្សពេញវ័យ",
    FREE_CANCEL: "បោះបង់ឥតគិតប្រាក់",
    CHARGE: "ត្រូវគិតប្រាក់បន្ថែម",
    CHARGE_AS_ADULTS: "ត្រូវគិតប្រាក់ដូចជាមនុស្សពេញវ័យ",
    CHILDREN_BELOW: "កុមារតិចជាង",
    CHILDREN_OVER: "កុមារខ្ពស់ជាង",
    CHILDREN_FROM: "កុមារពី",
    AGES: "អាយុ",
    DISCOUNT: "ការបញ្ចុះតម្លៃ",
    READ_MORE: "អានបន្ថែម",
    READ_LESS: "អានតិច",
    PICTURE_FACILITIES: "រូបភាព និង សេវាកម្ម",
    CAPACITY: "សមត្ថភាព",
    OPTIONS: "គោលនយោបាយតម្លៃ",
    ALL_CAPACITY: "មើលសេវាកម្មទាំងអស់",
    UN_ALL_CAPACITY: "បង្ហាញតិច",
    PAYMENT_BEFORE: "បង់ប្រាក់មុន",
    NO_PAYMENT_BEFORE: "មិនត្រូវការបង់ប្រាក់មុន",
    BOOK_WITHIN: "កក់ក្នុងរយៈពេល",
    PAYMENT_100_NOW: "បង់ប្រាក់ 100% នៃតម្លៃការកក់ឥឡូវនេះ",
    CANCEL_FREE_FROM: "បោះបង់ដោយឥតគិតប្រាក់ពី",
    TO_H: "ដល់មុន",
    CANCEL_FREE_BEFORE: "បោះបង់ដោយឥតគិតប្រាក់មុន",
    FROM: "ពី",
    UNTIL: "រហូតដល់",
    EARLY_CONFIRM: "បញ្ជាក់បន្ទាន់!",
    SEND_REQUEST_BOOKING: "ផ្ញើសំណើការកក់",
    SEND_REQUEST_CART: "បន្ថែមសំណើ",
    SEND_REQUEST_NOW: "ផ្ញើសំណើឥឡូវនេះ",
    AREA_INFO: "ព័ត៌មានតំបន់",
    CANCELLATION_POLICY: "គោលនយោបាយបោះបង់",
    CHILD_AND_BED: "គោលនយោបាយកុមារនិងគ្រែ",
    IF_CANCELED_BEFORE: "បោះបង់ការកក់មុន",
    THERE_ARE: "មាន",
    ROOM_TYPES_WITH: "ប្រភេទបន្ទប់ដែលមាន",
    OPTIONS_DETAIL: "គោលនយោបាយតម្លៃ",
    SPECIAL_OFFER: "ការផ្តល់ជូនពិសេស",
    HOTEL_POLICY: "គោលនយោបាយសណ្ឋាគារ",
    CHECK_AVAILABILITY: "ស្វែងរកបន្ទប់",
    PRICE_FOR: "តម្លៃសម្រាប់",
    ONLY: "តែមួយ",
    NIGHT: "យប់",
    ROOM_LEFT: "បន្ទប់នៅសល់",
    THE_PRICE_DOES_NOT_INCLUDE_VAT: "តម្លៃមិនរួមបញ្ចូលពន្ធ VAT",
    SERVICE_CHARGE: "កំរិតសេវាកម្ម",
    THE_PRICE_DOES_INCLUDE_VAT: "រួមបញ្ចូលពន្ធ VAT",
    THE_PRICE_DOES_NOT_INCLUDE_VAT_NOT_TOOL: "តម្លៃមិនរួមបញ្ចូលពន្ធ",
    SERVICE_CHARGE_NOT_TOOL: "សេវាកម្ម",
    THE_PRICE_DOES_INCLUDE_VAT_NOT_TOOL: "រួមបញ្ចូលពន្ធ",
    ADD_ROOM: "បន្ថែមបន្ទប់",
    BOOK_NOW: "កក់ឥឡូវនេះ",
    AND_SERVICE_CHARGE: "និងការបញ្ចូលសេវាកម្ម",
    AND_SERVICE_CHARGE_NOT_TOOL: "និងសេវាកម្ម",
    NO_CHARGE: "ឥតគិតប្រាក់",
    ADULTS_BTN_RESULTSEARCH: "មនុស្សពេញវ័យ",
    ABOVE_12_YEARS: "អាយុច្រើនជាង 12 ឆ្នាំ",
    CHILDRENS_BTN_RESULTSEARCH: "កុមារ",
    BELLOW_12_YEARS: "អាយុទាបជាង 12 ឆ្នាំ",
    ROOM: "បន្ទប់",
    HOW_OLD_ARE_THE_CHILDRENT: "ជ្រើសអាយុរបស់កុមារ",
    CHECKIN: "ថ្ងៃមកដល់",
    CHECKOUT: "ថ្ងៃចាកចេញ",
    T2: "ច",
    T3: "អ",
    T4: "ព",
    T5: "ព្រ",
    T6: "សុ",
    T7: "សៅ",
    T8: "អា",
    TH1: "មករា",
    TH10: "តុលា",
    TH11: "វិច្ឆិកា",
    TH12: "ធ្នូ",
    TH2: "កុម្ភៈ",
    TH3: "មីនា",
    TH4: "មេសា",
    TH5: "ឧសភា",
    TH6: "មិថុនា",
    TH7: "កក្កដា",
    TH8: "សីហា",
    TH9: "កញ្ញា",
    MOST_POPULAR: "សេវាកម្មពេញនិយម",
    EVERY_OPTION: "សេវាកម្មផ្សេងៗ",
    GIFT_CODE: "កូដការបញ្ចុះតម្លៃ",
    COPY_THIS_CODE: "ចម្លងកូដនេះ ហើយបញ្ចូលក្នុងទំព័របង់ប្រាក់",
    ENDOW: "ការបញ្ចុះតម្លៃ",
    APPLY_FOR_MIN_ORDER_FROM: "សម្រាប់ការបញ្ជាទិញទាបជាងពី",
    APPLY_ON_TOTAL_ROOM_RATE: "អនុវត្តលើតម្លៃសរុបបន្ទប់",
    APPLY_ON_TOTAL_BOOKING: "អនុវត្តលើតម្លៃសរុបការកក់",
    APPLY_ON_TOTAL_SERVICE: "អនុវត្តលើតម្លៃសរុបសេវាកម្ម",
    APPLY_ALL_ORDER: "សម្រាប់ការបញ្ជាទិញទាំងអស់",
    NO_ROOM_LEFT: "គ្មានបន្ទប់នៅសល់",
    QUIT_FAVORITE: "បានបន្ថែមក្នុងការពេញចិត្ត",
    SUM_PROMOTION: "ការបញ្ចុះតម្លៃសរុប",
    PRIORITY_PROMOTION: "ការបញ្ចុះតម្លៃអាទិភាព",
    BEST_PROMOTION: "ការបញ្ចុះតម្លៃល្អបំផុត",
    TYPE_PROMOTION: "ការកំណត់ប្រភេទការបញ្ចុះតម្លៃ",
    INDEX: "លំដាប់",
    PMS_SUCCESS: "សូមអបអរសាទរ សណ្ឋាគារបានបញ្ចប់ការលក់បន្ទប់នៅលើ ezCrs",
    COMPLETE_INFOMATION: "បញ្ចប់ព័ត៌មាន",
    SERVICE: {
        CONFIRM_DELETE_SERVICE: "តើអ្នកប្រាកដឬទេក្នុងការលុប?",
        CONFIRM_DEACTIVE_SERVICE: "តើអ្នកប្រាកដឬទេក្នុងការបិទប្រើ?",
        SPECIAL_PRICE: "តម្លៃប្រចាំថ្ងៃ",
        SPECIAL_PRICE_TITLE: "ថ្ងៃ",
        SPECIAL_PRICE_VALUE: "តម្លៃ",
        ADD_SPECIAL_PRICE: "បន្ថែមតម្លៃថ្ងៃពិសេស",
        HAS_EXITS: "មានការចូលប្រើ",
        LINK: "បញ្ជីតំណភ្ជាប់",
        STATUS_SYNC: "ស្ថានភាពសម្រប",
        ORDER: "ការបញ្ជាទិញ",
        THUMBNAIL: "រូបភាព",
        STATUS: "ស្ថានភាព",
        DEACTIVE: "មិនប្រើ",
        ACTIVE: "ប្រើ",
        SYNC_PMS: "សម្របពី PMS",
        LIST: "បញ្ជីសេវាកម្ម",
        INFO: "ព័ត៌មានសេវាកម្ម",
        NAME: "ចំណងជើង",
        DESCRIPTION_INFO: "ការពិពណ៌នា",
        DESCRIPTION_INFO_DEFAULT: "ការពិពណ៌នា",
        CODE: "កូដសេវាកម្ម",
        TIME_APPLY: "ការកំណត់ពេលវេលា",
        DAY_APPLY: "ថ្ងៃក្នុងសប្ដាហ៍",
        DAYS_NOT_APPLY: "ថ្ងៃមិនអនុវត្ត",
        ADD_DAYS_NOT_APPLY: "បន្ថែមថ្ងៃមិនអនុវត្ត",
        TIME_BOOK: "ថ្ងៃបញ្ជាទិញ",
        TIME_USE: "ថ្ងៃស្នាក់នៅ",
        FREE: "សេវាកម្មដោយឥតគិតថ្លៃ",
        PREMIUM: "សេវាកម្មដែលគិតថ្លៃ",
        PRICE: "តម្លៃ",
        PRICE_STATUS: "តម្លៃសេវាកម្ម",
        INCLUDE_TAX: "រួមបញ្ចូលពន្ធ",
        CURRENCY: "រូបិយប័ណ្ណ",
        COPPY: "ចម្លង",
        UNIT: "ឯកតា",
        PER_BOOKING: "ប្រើសម្រាប់ការកក់",
        PER_PERSON_PER_NIGHT: "ប្រើសម្រាប់មនុស្សម្នាក់ក្នុងមួយយប់",
        PER_ROOM: "ប្រើសម្រាប់បន្ទប់មួយ",
        PER_ROOM_PER_NIGHT: "ប្រើសម្រាប់បន្ទប់មួយក្នុងមួយយប់",
        PER_PERSON: "ប្រើសម្រាប់មនុស្សម្នាក់",
        TAX_LABEL: "ពន្ធ",
        MAXBOOK: "ការបញ្ជាទិញអតិបរមា",
        PACKAGE_SELL: "កញ្ចប់តម្លៃ",
        PACKAGE_ALL: "ទាំងអស់",
        PACKAGE_SPEC: "កញ្ចប់តម្លៃបញ្ចុះតម្លៃ",
        SELL_CHANEL: "ឆានែលលក់ដែលបានអនុវត្ត",
        CHANEL_ALL: "អនុវត្តលើឆានែលលក់ទាំងអស់",
        CHANEL_SPEC: "អនុវត្តលើឆានែលលក់បន្តិច",
        CODE_MAX_LENGTH: "ត្រូវមានច្រើនជាង 2 តួអក្សរ",
        SPECIAL_DESC: "តម្លៃសម្រាប់ថ្ងៃជាក់លាក់",
        NOT_EMPTY: "មិនអាចទទេបានទេ",
        ERROR_DUPLICATE_DAY: "ថ្ងៃដែលបានជ្រើសរើសមានការប្រហែលគ្នា។ សូមពិនិត្យម្ដងទៀត",
        TAX_DEFAULT: "លំនាំដើម",
        UPDATE_IMAGE_SUCCESS: "បង្ហោះរូបភាពជោគជ័យ",
        UPDATE_IMAGE_FAIL: "បង្ហោះរូបភាពបរាជ័យ",
        CANCEL: "បោះបង់",
        NOTHUMB: "រូបភាពមិនអាចទទេបានទេ",
        IMAGE_TOO_LARGE: "រូបភាពមិនអាចធំជាង 8MB",
        BINDING_PRICE: "រួមបញ្ចូលក្នុងតម្លៃបន្ទប់",
        MAXQUATITY: "ចំនួនសេវាកម្មអតិបរមា",
        UNLIMIT: "អត្រាអនុលោម",
        LIMIT: "កំណត់",
        ONE_TIME: "ម្តងតែមួយ",
        CONFIRM_ACTIVE_SERVICE: "តើអ្នកប្រាកដឬទេ?",
        BENEFIT: "អត្ថប្រយោជន៍ និង ប្រយោជន៍",
        MANDATORY_ADD_ON: "បន្ថែមដែលត្រូវបានបំពាក់",
        MANDATORY_ADD_ON_INFO: "បើបានជ្រើសរើសសេវាកម្មនេះ នឹងត្រូវបានអនុវត្តដោយស្វ័យប្រវត្តិពេលធ្វើការកក់",
    },
    IMAGE_NOT_EXIST: "មិនមានរូបភាពទេ",
    IMAGE_SERVICE: "រូបភាព",

    _ROOM_SALE: {
        ROOM_TYPE: {
            ROOM_TYPE: "ប្រភេទបន្ទប់",
            ROOM_CODE: "កូដបន្ទប់",
            MAX_PERSON: "អតិបរមាអ្នកទស្សនាដែលអាចស្នាក់នៅ",
            MAX_ADULT: "អតិបរមាអ្នកពេញវ័យ",
            MAX_CHILD: "អតិបរមាក្មេង",
            MAX_KID: "អតិបរមាក្មេងបោល",
            ROOM_PARENT_TYPE: "បន្ទប់មេ",
            ERROR_ROOM_CODE: "កូដបន្ទប់មិនអាចមានការកូដទេឬទទេបានទេ",
            ERROR_ROOM_PARENT: "បន្ទប់ដែលអ្នកជ្រើសរើសបានត្រូវបានកំណត់ជាបន្ទប់មេសម្រាប់បន្ទប់បច្ចុប្បន្ន"
        },
        EXPAND: "បង្ហាញបន្ថែម",
        UNEXPAND: "បង្ហាញតិចជាង",
        SELL_CHANNEL: "ឆានែល",
        SELL_MARKET: "ទីផ្សារ",
        SELL_CHANNEL_ALL: "ឆានែលទាំងអស់",
        SELL_CHANNEL_SPEC: "ឆានែលខ្លះ",
        SELL_MARKET_ALL: "ទីផ្សារទាំងអស់",
        SELL_MARKET_SPEC: "ទីផ្សារខ្លះ",
        LABEL_SEARCH_CODE_NAME: "កូដ/ប្រភេទបន្ទប់",
        ENTER_HOTEL_NAME_OR_CODE: "បញ្ចូលកូដ/ប្រភេទបន្ទប់"
    },
    _SALE_PACKAGE: {
        SALE_PACKAGE: "ផែនការតម្លៃ",
        ADD_NEW: "បន្ថែមផែនការតម្លៃថ្មី",
        ENTER_SALE_PACKAGE_NAME_OR_CODE: "បញ្ចូលកូដ/ផែនការតម្លៃ",
        RATE_CATEGORY: "ប្រភេទតម្លៃ",
        RATE_CATEGORY_ADD_NEW: "បន្ថែមប្រភេទតម្លៃថ្មី",
        ROOM_CATEGORY: "ប្រភេទបន្ទប់",
        ROOM_CATEGORY_ADD_NEW: "បន្ថែមប្រភេទបន្ទប់ថ្មី"
    },
    ADD_NEW_ROOM: "បន្ថែមបន្ទប់ថ្មី",
    ROOMS_PER_PAGE: "បន្ទប់ក្នុងមួយទំព័រ",
    NOT_EMPTY: "សូមបញ្ចូលតម្លៃ",
    _SERVICE_PACKAGE: {
        AGE_MAX_CHILD: "អតិបរមាក្មេង",
        AGE_MAX_BABY: "អតិបរមាក្មេងបោល",
        DAY_APPLY_IN_WEEK: "ថ្ងៃក្នុងសប្តាហ៍",
        PAYMENT_POLICY: "គោលការណ៍ការទូទាត់",
        CANCEL_POLICY: "គោលការណ៍បោះបង់",
        APPLY_OBJECT: "ភាគី",
        APPLY_CARD: "ប្រភេទកាត",
        PACKAGE_CODE: "កូដផែនការតម្លៃ",
        ADD_PAYMENT_POLICY: "បន្ថែមគោលការណ៍ការទូទាត់",
        ADD_CANCEL_POLICY: "បន្ថែមគោលការណ៍បោះបង់",
        SALE_PACKAGE_CODE: "កូដផែនការតម្លៃ",
        ERROR_SALE_PACKAGE_CODE: "កូដផែនការតម្លៃមិនអាចមានការកូដទេឬទទេបានទេ"
    },
    PACKAGE_PER_PAGE: "ពក្សមុខក្នុងមួយទំព័រ",
    ADD_RANGE_DAYS_NOT_APPLY: "បន្ថែមថ្ងៃបិទមិនអនុញ្ញាត",
    NOT_APPLY_RANGE_DATE: "ថ្ងៃបិទមិនអនុញ្ញាត",
    ROOM_AVAILABLE: "ស្ថានភាពបន្ទប់",
    NO_ROOM_PARENT: "គ្មាន",
    ROOM_RATE: "តម្លៃបន្ទប់",
    ADD_SALE_PACKAGE: "បន្ថែមផែនការតម្លៃ",
    ADD_DATE_RANGE: "បន្ថែមខួបថ្ងៃ",
    CONFIRM_DELETE_SALE_PACKAGE_DATE_RANGE: "អះអាងការលុបខួបថ្ងៃនេះទេ?",
    SELECT_SALE_PACKAGE: "ជ្រើសរើសផែនការតម្លៃ",
    LIST_SALE_PACKAGE_EMPTY: "បញ្ជីផែនការតម្លៃទទេ",
    VIEW_TABLE: "មើលជាតារាង",
    VIEW_CALENDAR: "មើលជាលុយកាលីនដា",
    SELECT_ROOM_TO_VIEW: "សូមជ្រើសរើសបន្ទប់ដើម្បីមើល",
    SHOW_ROOM_AVAIL: "បង្ហាញចំនួនដែលមានសម្រាប់បរិច្ឆេទនេះ",
    ROOM_CONNECTED_OTA: "បន្ទប់មានការបញ្ជូន OTA",
    RESTRICTION_PACKAGE: "កញ្ចប់កំណត់",
    RESTRICTION: "ការកំណត់",
    ENTER_RESTRICTION_NAME_OR_CODE: "បញ្ចូលឈ្មោះឬកូដកំណត់",
    CONFIRM_DELETE_RESTRICTION: "អះអាងការលុបកញ្ចប់កំណត់",
    RESTRICTION_INFOMATION: "ព័ត៌មានកំណត់",
    CONFIG_RESTRICTION: "កំណត់ការកំណត់",
    DEFAULT: "លំនាំដើម",
    ROOMTYPE: "ប្រភេទបន្ទប់",
    ROOMPLAN: "ផែនការតម្លៃ",
    RESTRICTION_NAME: "ឈ្មោះកំណត់",
    ADD_NEW_RESTRICTION: "បន្ថែមការកំណត់ថ្មី",
    METADATA: "ជ្រើសរើសការអាប់ដេត",
    RESTRICTION_BULK_UPDATE: "បង្កើតការអាប់ដេតជាកម្មវិធីធំ",
    RESTRICTION_BULK_DELETE: "លុបចេញការកំណត់ជាកម្មវិធីធំ",
    ROOM_AVAIL: "ស្ថានភាពបន្ទប់",
    SELL_LIMIT: "កំណត់ការលក់",
    STOP_SELL_LIMIT: "បញ្ឈប់កំណត់ការលក់",
    PRICE: "តម្លៃ",
    MANAGE_SYNC_OTA: "ការគ្រប់គ្រងសមស្រប",
    MANAGE_ALIAS_OTA: "ezCms Vela",
    ALL_ROOM: "បន្ទប់ទាំងអស់",
    NOT_SELECT_SALE_PACKGE: "សូមជ្រើសរើសផែនការតម្លៃ",
    DATA_INPUT_INVALID: "ទិន្នន័យមិនត្រឹមត្រូវ",
    UPDATE: "អាប់ដេត",
    SELECT_ROOM_APPLY: "ប្រភេទបន្ទប់",
    SELECT_SALE_PACKAGE_APPLY: "ជ្រើសរើសផែនការតម្លៃ",
    SPECIAL_PRICE: "តម្លៃប្រចាំថ្ងៃ",
    ENTER_PRICE_AND_CHOSE_SALE_PACAKGE: "តម្លៃ, ផែនការតម្លៃទទេ",
    minStay: "ការស្នាក់នៅអប្បបរមា",
    maxStay: "ការស្នាក់នៅអតិបរមា",
    minStayArrival: "ការស្នាក់នៅអប្បបរមាក្នុងការមកដល់",
    maxStayArrival: "ការស្នាក់នៅអតិបរមាក្នុងការមកដល់",
    minBookingWindow: "បង្ហាញពីម៉ោងដែលអាចបញ្ជាទិញតិចតួច",
    maxBookingWindow: "បង្ហាញពីម៉ោងដែលអាចបញ្ជាទិញខ្ពស់",
    minBookingWindowByHour: "បង្ហាញម៉ោងបញ្ជាទិញអប្បបរមា",
    maxBookingWindowByHour: "បង្ហាញម៉ោងបញ្ជាទិញអតិបរមា",
    exactStay: "ស្នាក់នៅជាក់ស្តែង",
    exactStayArrival: "ស្នាក់នៅជាក់ស្តែងក្នុងការមកដល់",
    fromCheckout: "ចាប់ពីការបញ្ចប់ការស្នាក់នៅ",
    cutOfTime: "ពេលវេលាចុងក្រោយ",
    closedOnArrival: "បិទនៅពេលមកដល់",
    closedOnDeparture: "បិទនៅពេលចាកចេញ",
    closed: "បិទការលក់",
    belongTo: "ពាក់ព័ន្ធនឹង",
    appliedFor: "បានអនុវត្តសម្រាប់",
    CHANNEL_APPLY: "ឆានែល",
    CHANNEL_EMPTY: "ឆានែលទទេ",
    APPLY_FOR: "អនុវត្តសម្រាប់",
    priceExtraAdult: "តម្លៃបន្ថែមសម្រាប់អ្នកពេញវ័យ",
    priceExtraChild: "តម្លៃបន្ថែមសម្រាប់ក្មេង",
    priceExtraBaby: "តម្លៃបន្ថែមសម្រាប់ក្មេងបោល",
    DAY_SPECIAL: "តម្លៃប្រចាំថ្ងៃ",
    SUN_SHORT: "អាទិត្យ",
    MON_SHORT: "ចន្ទ",
    TUE_SHORT: "អង្គារ",
    WED_SHORT: "ពុធ",
    THU_SHORT: "ព្រហស្បតិ៍",
    FRI_SHORT: "សុក្រ",
    SAT_SHORT: "សៅរ៍",
    JAN_SHORT: "មករា",
    FEB_SHORT: "កុម្ភៈ",
    MAR_SHORT: "មីនា",
    APR_SHORT: "មេសា",
    MAY_SHORT: "ឧសភា",
    JUN_SHORT: "មិថុនា",
    JUL_SHORT: "កក្កដា",
    AUG_SHORT: "សីហា",
    SEP_SHORT: "កញ្ញា",
    OCT_SHORT: "តុលា",
    NOV_SHORT: "វិច្ឆិកា",
    DEC_SHORT: "ធ្នូ",
    NO_SELECT: "គ្មានការផ្លាស់ប្តូរ",
    OPEN: "បើក",
    CONFIRM_DELETE_SPECIAL_PRICE: "អះអាងការលុបតម្លៃប្រចាំថ្ងៃ",
    CONFIRM_DELETE_SPECIAL_PRICE_EXTRA_ADULT: "អះអាងការលុបតម្លៃបន្ថែមសម្រាប់អ្នកពេញវ័យ",
    CONFIRM_DELETE_SPECIAL_PRICE_EXTRA_CHILD: "អះអាងការលុបតម្លៃបន្ថែមសម្រាប់ក្មេង",
    CONFIRM_DELETE_SPECIAL_PRICE_EXTRA_BABY: "អះអាងការលុបតម្លៃបន្ថែមសម្រាប់ក្មេងបោល",
    REMOVE_SPECIAL_PRICE: "លុបតម្លៃប្រចាំថ្ងៃ",
    NO_DATA: "គ្មានទិន្នន័យ",
    CURRENCY_OTA: "រូបិយវត្ថុនៅលើឆានែល",
    ROOM_TYPE_ON_OTA: "ប្រភេទបន្ទប់នៅលើ OTA",
    SALE_PACKAGE_ON_OTA: "ផែនការតម្លៃនៅលើ OTA",
    NUMBER_OF_PERSON: "ចំនួនមនុស្ស",
    PACKAGE_TYPE: "ប្រភេទកញ្ចប់",
    RATES: "តម្លៃ",
    RATES_OSCILLATE: "បន្ថែម",
    REGULAR_PRICE: "តម្លៃធម្មតា",
    SYNCED: "បានសហប្រតិបត្តិការ",
    ROOM_CLOSED: "បិទបន្ទប់",
    NO_SALEPACKAGE_AVAIL: "ផែនការតម្លៃមិនមានស្រាប់",
    YES: "មាន",
    NO: "ទេ",
    BOOKING_CUSTOMER_NAME: "ឈ្មោះអតិថិជន",
    BOOKING_EMPTY: "គ្មានការកក់ណាមួយរកឃើញ",
    BOOKING_CHANNEL: "ឆានែល",
    BOOKING_HOTEL: "សណ្ឋាគារ",
    STT: "លេខ",
    BOOKING_IS_NOT_EXIST: "ការកក់មិនមាន",
    ADD_NEW_SALE_CHANNEL: "បន្ថែមឆានែលថ្មី",
    CONNECT: "ភ្ជាប់",
    SELECT_SALE_CHANNEL: "ជ្រើសរើសឆានែល",
    PHONE_INVALID: "ទូរស័ព្ទមិនត្រឹមត្រូវ",
    EMAIL_INVALID: "អ៊ីម៉ែលមិនត្រឹមត្រូវ",
    LOGIN_NOW: "ចូលប្រើឥឡូវនេះ!",
    POLICY_NAME: "ឈ្មោះគោលនយោបាយ",
    POLICY_DESCRIPTION: "ការពិពណ៌នាគោលនយោបាយ",
    DESCRIPTION: "ការពិពណ៌នា",
    APPLY_DAY: "អនុវត្ត",
    DEPOSIT_UNIT: "ឯកតា",
    APPLY_FOR_STAYING: "ដោយកាលបរិច្ឆេទស្នាក់នៅ",
    APPLY_FOR_BOOKING: "ដោយកាលបរិច្ឆេទការកក់",
    CHECKOUT_DATE: "កាលបរិច្ឆេទព្យួរប្រាក់",
    CHECKIN_DATE: "កាលបរិច្ឆេទចូលស្នាក់នៅ",
    BEFORE_CHECKIN_DATE: "មុនកាលបរិច្ឆេទចូលស្នាក់នៅ",
    BEFORE_CHECKOUT_DATE: "មុនកាលបរិច្ឆេទព្យួរប្រាក់",
    CANCEL_ROOM_IN_ROUND_X_DAY_BEFORE: "បោះបង់ការកក់នៅក្នុង x ថ្ងៃមុន",
    NIGHT_CAP: "0 យប់ | 1 យប់ | {count} យប់",
    CHANGE_PASSWORD_REQUEST_NO_LONGER_WORK: "សំណើប្ដូរពាក្យសម្ងាត់របស់អ្នកមិនដំណើរការទៀតទេ!",
    MAXROOM_1000: "ទំហំបន្ទប់អតិបរមាគឺ 1000",
    DATA_INPUT_MAX_100_PERCENT: "តម្លៃអតិបរមា 100",
    DATA_INPUT_MAX_10_NIGHT: "តម្លៃអតិបរមា 10 យប់",
    DUPLICATE_CODE: "កូដបណ្តោះអាសន្ន",
    CREATE: "បង្កើត",
    BULK_UPDATE: "បង្ហាប់បច្ចុប្បន្នភាព",
    SETUP_OTA: "កំណត់ OTA",
    AUTH: "ប្រើប្រាស់សណ្ឋាគារ",
    RECEIVE_BOOKING_FROM_OTA: "ទទួលការកក់ពី OTA",
    UPDATE_INVENTORY: "បច្ចុប្បន្នភាពសារព័ត៌មានពី PMS",
    RECEIVE_INVENTORY_UPDATE_FROM_PMS: "ទទួលការអាប់ដេតសារព័ត៌មានទៅ OTA",
    PUSH_BOOKING_NOTIFICATION_TO_PMS: "ផ្ញើការជូនដំណឹងកក់ទៅ PMS",
    HOTEL_INFO: "ព័ត៌មានសណ្ឋាគារ",
    HOTEL_IMAGE: "រូបភាពសណ្ឋាគារ",
    HOTEL_AREA: "តំបន់សណ្ឋាគារ",
    HOTEL_AMENITY: "សមត្ថភាពសណ្ឋាគារ",
    HOTEL_CANCELLATION_POLICY: "គោលការណ៍បោះបង់សណ្ឋាគារ",
    HOTEL_SETTING: "កំណត់សណ្ឋាគារ",
    HOTEL_PAYMENT_POLICY: "គោលការណ៍ការទូទាត់សណ្ឋាគារ",
    SETUP_AND_MAPPING_TO_OTA: "កំណត់និងផ្តល់ទីតាំងទៅ OTA",
    HOTEL_RATE_PLAN: "ផែនការតម្លៃសណ្ឋាគារ",
    HOTEL_RESTRICTION: "ការពារ​សណ្ឋាគារ",
    HOTEL_ROOM_TYPE: "ប្រភេទបន្ទប់សណ្ឋាគារ",
    HOTEL_ROOM_TYPE_AMENITY: "សមត្ថភាពប្រភេទបន្ទប់សណ្ឋាគារ",
    HOTEL_ROOM_TYPE_AVAILABILITY: "សមត្ថភាពប្រភេទបន្ទប់សណ្ឋាគារ",
    HOTEL_ROOM_RATE: "តម្លៃបន្ទប់សណ្ឋាគារ",
    HOTEL_ROOM_TYPE_STOP_SELL: "បន្ទប់សណ្ឋាគារបង្ហាញការលក់",
    HOTEL_ROOM_RATE_ADULT: "តម្លៃបន្ទប់សណ្ឋាគារអ្នកពេញវ័យ",
    HOTEL_ROOM_RATE_CHILD: "តម្លៃបន្ទប់សណ្ឋាគារក្មេង",
    HOTEL_ROOM_RATE_BABY: "តម្លៃបន្ទប់សណ្ឋាគារក្មេងបោល",
    HOTEL_ROOM_RATE_SPECIAL: "តម្លៃបន្ទប់សណ្ឋាគារពិសេស",
    STAFF_INFO: "ព័ត៌មានបុគ្គលិក",
    STAFF_PASSWORD: "ពាក្យសម្ងាត់បុគ្គលិក",
    STAFF_AVATAR: "រូបភាពបុគ្គលិក",
    STAFF_LOGIN: "ចូលប្រើបុគ្គលិក",
    HOTEL_REGISTER: "ចុះឈ្មោះសណ្ឋាគារ",
    CHANGE_STATUS: "ផ្លាស់ប្តូរភាពតស៊ូ",
    LOG_ACTION: "សកម្មភាព",
    LOG_FUNCTION: "មុខងារ",
    LOG_CONTENT: "កំណត់ត្រា",
    LOG_DATE_CREATE: "កាលបរិច្ឆេទបង្កើត",
    LOG_USERNAME: "ឈ្មោះអ្នកប្រើ",
    PRICE_ON_OTA: "តម្លៃនៅលើ OTA",
    PRICE_ON_DEFINED: "តម្លៃដែលបានកំណត់",
    STOP_SELL_TRIGGER: "ការបញ្ឈប់ការលក់",
    DOWNLOAD: "ទាញយក",
    CONFIRM_CHANGE_STATUS_SALE_PACKAGE: "ផែនការតម្លៃបានត្រូវបញ្ចូលទៅ OTA, តើអ្នកប្រាកដជា​ចង់ប្ដូរភាពតស៊ូ?",
    CONFIRM_CHANGE_STATUS_ROOMTYPE: "ប្រភេទបន្ទប់បានត្រូវបញ្ចូលទៅ OTA, តើអ្នកប្រាកដជា​ចង់ប្ដូរភាពតស៊ូ?",
    hotel_id: "ID សណ្ឋាគារ",
    property_id: "ID អចលនទ្រព្យ",
    HOTEL_ROOM_TYPE_IMAGES: "រូបភាពបន្ទប់",
    IMAGE_MANAGAMENT: "កម្រងរូបភាព",
    UNIT: "ឯកតា",
    NEARBY_TYPE: "ប្រភេទជិតខាង",
    DIALOG_CONFIRM_DESC: "ធ្វើការអាប់ដេតបានត្រឹមតែសម្រង់តាមការកំណត់របស់ផែនការតម្លៃ?",
    CANNOT_GET_INFO_FROM_OTA_1: "ការទំនាក់ទំនងជាមួយ OTA មិនមានការបញ្ជូន។",
    CANNOT_GET_INFO_FROM_OTA_2: "សូមទំនាក់ទំនងមកយើងតាមលេខទូរស័ព្ទ 1900 9013 ឬអ៊ីម៉ែលទៅ hotro@ezcloud.vn",
    ROOMTYPE_HAS_NO_RATEPLAN: "សូមបញ្ចូលការចូលរួមជាមុនរវាងប្រភេទបន្ទប់, ផែនការតម្លៃ និងឆានែល។",
    MAX_LENGTH_10: "ទិន្នន័យមានការកំណត់ 10 តួអក្សរ",
    UPDATE_BY: "អាប់ដេតដោយ",
    OTA_HAS_NO_RATEPLAN: "មិនមានផែនការតម្លៃសម្រាប់ OTA នេះទេ",
    PRICE_IS_REQUIRED: "តម្លៃទទេ",
    HOTEL_ROOM_IS_OVER_LIMIT: "បន្ទប់សណ្ឋាគារត្រូវបានលើសពីកំណត់",
    CONFIRM_DELETE_PROMOTION: "តើអ្នកប្រាកដជាចង់លុបការផ្សព្វផ្សាយទេ?",
    ADD_NEW_PROMOTION: "បន្ថែមការផ្សព្វផ្សាយថ្មី",
    ADD_NEW_SERVICE: "បន្ថែមសេវាកម្មថ្មី",
    PRICE_EXTRA: "តម្លៃបន្ថែម",
    PERSON_NUMBER: "ចំនួនមនុស្ស",
    DETAIL: "លម្អិត",
    PRICE_AND_PERSON_IS_REQUIRED: "តម្លៃ និងចំនួនមនុស្សត្រូវការបញ្ចូល",
    CHOOSE_LANG_PAYMENT: "ជ្រើសរើសភាសាសម្រាប់វិធីសាស្ត្រទូទាត់",
    ENTER_CONTENT_SHOW: "បញ្ចូលអ្វីដែលត្រូវបង្ហាញ",
    CONFIG_BE: "ម៉ាស៊ីនកក់",
    SAVE_SUCCESS: "រក្សាទុកជោគជ័យ",
    CONFIGURE_OUGING_EMAIL: "អ៊ីម៉ែលបានផ្ញើ",
    EMAIL_SEND: "អាសយដ្ឋានអ៊ីម៉ែល",
    EMAIL_NAME_SEND: "ឈ្មោះបង្ហាញ",
    SERVER_MAIL_ADDRESS: "សំណង់សេវាកម្ម SMTP",
    CONNECTOR: "កំពស់ SMTP",
    ENCRYPTION_TYPE: "ការតភ្ជាប់សុវត្ថិភាព",
    AUTHENTICATON_CONNECTION: "ការតភ្ជាប់សុវត្ថិភាព",
    EMAIL_TYPE: "ប្រភេទអ៊ីម៉ែល",
    TEST_EMAIL_SENT: "តេស្តអ៊ីម៉ែលចេញ",
    SENT_EMAIL_TEST: "ផ្ញើអ៊ីម៉ែលតេស្ត",
    EMAIL_SETTING_EXISTED: "អ៊ីម៉ែលមានរួចហើយ",
    ERROR_MAIL: "កំហុស",
    SUCCESS_MAIL: "អ៊ីម៉ែលបានផ្ញើដោយជោគជ័យ",
    UNIT_ROOM_PRICE: "តម្លៃបន្ទប់",
    FROM_CHECKOUT: "ចាប់ពីការចេញ",
    NON_REFUNDABLE: "មិនអាចបញ្ជូនប្រាក់ត្រឡប់",
    GUEST_NAME: "ឈ្មោះភ្ញៀវ",
    FROM_TIME: "ចាប់ពី",
    TO_TIME: "ទៅ",
    PROMOTION_CODE: "កូដផ្សព្វផ្សាយ",
    SORT: "រៀបចំ",
    HAS_CONNECTED: "បានភ្ជាប់",
    GUEST: "ភ្ញៀវ",
    COUPON_CODE: "កូដកាំប្រាក់",
    PAYMENT_REQUIRED_UPON_BOOKING: "ត្រូវការបង់ប្រាក់នៅពេលកក់",
    CONDITIONS: "លក្ខខណ្ឌ",
    HOW_MUCH_PAYMENT_IS_MADE_BY_THE_GUEST_ON_THE_DAY_OF_BOOKING: "តើភ្ញៀវបានបង់ប្រាក់ប៉ុន្មាននៅថ្ងៃកក់?",
    PERCENT_OF_TOTAL_ROOM_RATE: "% នៃតម្លៃបន្ទប់សរុប",
    WHEN_DOES_THE_CUSTOMER_MAKE_THE_PAYMENT_FOR_THE_REMAINING_AMOUNT: "តើភ្ញៀវធ្វើការទូទាត់ប្រាក់សម្រាប់ប្រាក់នៅសល់នៅពេលណា?",
    WHAT_THE_PAYMENT_POLICY_FOR_THE_BOOKING_PERIOD: "គោលការណ៍ការទូទាត់សម្រាប់រយៈពេលការកក់?",
    WHAT_DOES_PAYMENT_POLICY_APPLY: "គោលការណ៍ការទូទាត់អនុវត្តចំពោះរយៈពេលណា?",
    POLICY_SUMMARY: "សង្ខេបគោលការណ៍",
    PERCENT_BOOKING: "% កក់",
    WHEN_DOES_THE_CUSTOMER_MAKE_THE_PAYMENT: "តើភ្ញៀវធ្វើការទូទាត់ប្រាក់នៅពេលណា?",
    DATA_INPUT_MAX_24_HOUR: "ទិន្នន័យមិនអាចចាស់ជាង 24 ម៉ោងទេ",
    DAY: "ថ្ងៃ",
    HOUR: "ម៉ោង",
    HOW_MUCH_DOES_THE_CUSTOMER_MAKE_PAYMENT: "តើភ្ញៀវបានបង់ប្រាក់ប៉ុន្មាន?",
    ON_THE_DAY_OF_CHECK_IN: "នៅថ្ងៃចុះចូល",
    ON_THE_DAY_OF_CHECK_OUT: "នៅថ្ងៃចាកចេញ",
    PRICE_PER_NIGHT: "តម្លៃរាត្រី",
    ON_THE_DATE_OF_BOOKING: "នៅថ្ងៃកក់",
    UPDATE_PRICE_NOTE: "ទិន្នន័យតម្លៃ និងបរិមាណត្រូវបានប្ដូរ។ តម្លៃបន្ទប់មេដែលបានអាប់ដេតនឹងមានឥទ្ធិពលទៅលើតម្លៃបន្ទប់កូន",
    PROMOTION_TITLE: "ចំណងជើង",
    FREE_CANCELLATION_ALLOWED: "អនុញ្ញាតឱ្យលុបចោលដោយឥតគិតថ្លៃ",
    HOW_LONG_BEFORE_CHECK_IN_CAN_GUESTS_CANCEL_FOR_FREE: "តើមានពេលប៉ុន្មានមុនការចុះចូលដែលភ្ញៀវអាចលុបចោលដោយឥតគិតថ្លៃ?",
    DAY_BEFORE_CHECK_IN: "{day} ថ្ងៃមុនការចុះចូល",
    ACCORDING_TO_CUSTOM: "តាមបំណង",
    HOW_MUCH_DO_GUESTS_HAVE_TO_PAY_WHEN_THEY_CANCEL_A_RERVATION_DAYS_PRIOR_TO_ARRIVAL: "តើភ្ញៀវត្រូវបង់ប្រាក់ប៉ុន្មាន នៅពេលដែលពួកគេលុបការកក់នៅក្នុងរយៈពេល {day} ថ្ងៃមុនការមកដល់?",
    HOW_MUCH_DO_GUESTS_HAVE_TO_PAY_WHEN_CANCELING_A_RESERVATION: "តើភ្ញៀវត្រូវបង់ប្រាក់ប៉ុន្មាន នៅពេលដែលពួកគេលុបការកក់?",
    WHAT_THE_CANCEL_POLICY_FOR_THE_BOOKING_PERIOD: "គោលការណ៍ការលុបចោលអនុវត្តចំពោះរយៈពេលណា?",
    WHAT_DOES_CANCEL_POLICY_APPLY: "តើគោលការណ៍ការលុបចោលអនុវត្តពេលណា?",
    HOW_MUCH_WILL_THE_CUSTOMER_HAVE_TOT_PAY_IF_THE_GUEST_CANCELS_ON_THE_CHECKIN: "តើអតិថិជនត្រូវបង់ប្រាក់ប៉ុន្មាន ប្រសិនបើភ្ញៀវលុបការកក់នៅថ្ងៃចុះចូល?",
    UTC: "តំបន់ម៉ោង",
    ROOM_ARE_AVAILABLE_FROM_LESS_TO_MORE: "បន្ទប់មានស្រាប់ពីតិចទៅធំ",
    TIME_ZONE_HOTEL: "តំបន់ម៉ោងសណ្ឋាគារ",
    BED_TYPE_SETTING: "ការកំណត់ប្រភេទគ្រែ",
    ROOM_TYPE_SETTING: "ការកំណត់ប្រភេទបន្ទប់",
    OVER_MAX_GUEST: "ចំនួនភ្ញៀវអតិបរមានៅក្នុងប្រភេទបន្ទប់មិនស្គាល់",
    OVER_MAX_ADULTS: "ចំនួនមនុស្សពេញវ័យអតិបរមានៅក្នុងប្រភេទបន្ទប់មិនស្គាល់",
    OVER_MAX_CHILDREN: "ចំនួនក្មេងអតិបរមានៅក្នុងប្រភេទបន្ទប់មិនស្គាល់",
    OVER_MAX_BABY: "ចំនួនទារកអតិបរមានៅក្នុងប្រភេទបន្ទប់មិនស្គាល់",
    UNDER_MAX_ADULTS: "ចំនួនមនុស្សពេញវ័យអតិបរមានៅក្នុងកញ្ចប់លក់មិនស្គាល់",
    UNDER_MAX_CHILDREN: "ចំនួនក្មេងអតិបរមានៅក្នុងកញ្ចប់លក់មិនស្គាល់",
    UNDER_MAX_BABY: "ចំនួនទារកអតិបរមានៅក្នុងកញ្ចប់លក់មិនស្គាល់",
    UNDER_MAX_QUANTITY: "ចំនួនបន្ទប់សរុបមិនអាចធំជាងការតម្លើងអចិន្រ្តៃបាន",
    BOOKING_ENGINE: "ម៉ាស៊ីនកក់",
    TEXT_NOTIFY_EXPIRED: "គណនីរបស់អ្នកដែលភ្ជាប់ឆានែលការចែកចាយទៅឆានែល {channel} បានផុតកំណត់នៅលើ {date}។ ទិន្នន័យនឹងមិនត្រូវបានសមញ្ញាទៅឆានែល OTA ទេ សូមធ្វើការស្ដារឡើងវិញ",
    TEXT_NOTIFY_WILL_EXPIRE: "គណនីរបស់អ្នកដែលភ្ជាប់ឆានែលការចែកចាយទៅឆានែល {channel} នឹងផុតកំណត់នៅលើ {date}។ ទិន្នន័យនឹងមិនត្រូវបានសមញ្ញាទៅឆានែល OTA ទេ សូមធ្វើការស្ដារឡើងវិញ",
    ROOM_AND_PACKAGES_FOR_SALE_ON_GOOOGLE: "បន្ទប់ និងកញ្ចប់សម្រាប់លក់លើឆានែលហូតែល Google",
    HOTEL_LOG_roomTypeI18n: "ប្រភេទបន្ទប់",
    HOTEL_LOG_lang: "ភាសា",
    HOTEL_LOG_ratePlanI18n: "កញ្ចប់បន្ទប់",
    HOTEL_LOG_otaI18n: "OTA",
    BE_CONNECT_REQUIRED: "មិនទាន់ភ្ជាប់ម៉ាស៊ីនកក់ទេ",
    ACCESS_DENIED: "គ្មានការអនុញ្ញាតចូល",
    OTA_NOT_FOUND: "មិនបានរកឃើញ OTA",
    HOTEL_SYNC: "សណ្ឋាគារបានសមញ្ញា",
    PASSWORD_SENT_SUCCESS: "ពាក្យសម្ងាត់ត្រូវបានផ្ញើដោយជោគជ័យ",
    CAN_NOT_DELETE: "ប្រភេទបន្ទប់ / កញ្ចប់លក់បានភ្ជាប់ទៅ OTA",
    BOOKING_NOT_CANCEL: "មិនអាចលុបការកក់",
    HEADER_FOOTER_CONFIG: "គំរូ",
    MENU_EDIT: "ប្រភេទម៉ឺនុយ",
    MENU_NAME: "ឈ្មោះ",
    MENU_CONFIG: "ការបង្ហាញម៉ឺនុយ",
    WIDGETS_EDIT: "ប្រភេទវីដ്ജិត",
    ADD_NEW_WIDGETS: "បន្ថែមវីដជិតថ្មី",
    WIDGETS_NOT_YET_DISPLAYED: "វីដជិតមិនទាន់បង្ហាញទេ",
    PARAMETERS: "ការកំណត់ផ្សេងទៀត",
    LOGO_DISPLAYS: "URL រូបតំណាង",
    TOP_HEADER_BACKGROUND: "ខ្នាតខាងលើ - ពណ៌ផ្ទៃខាងក្រោម",
    HEADER_BACKGROUND: "ខ្នាត - ពណ៌ផ្ទៃខាងក្រោម",
    TEXT_HEADER_COLOR: "ខ្នាត - ពណ៌អត្ថបទ",
    TEXT_HEADER_COLOR_ACTIVE: "ពណ៌ចម្បង",
    FOOTER_BACKGROUND: "ផ្នែកខាងក្រោម - ពណ៌ផ្ទៃខាងក្រោម",
    TEXT_FOOTER_COLOR: "ផ្នែកខាងក្រោម - ពណ៌អត្ថបទ",
    BACKGROUND_COPYRIGHT: "ផ្នែកខាងក្រោម - ពណ៌ផ្ទៃខាងក្រោម",
    ADD_NEW_MENU: "បន្ថែមម៉ឺនុយថ្មី",
    CONTENT_WIDGETS: "មាតិកា",
    TITLE: "ចំណងជើង",
    REFERENCE_SAMPLE: "គំរូយោង",
    VI: "វៀតណាម",
    EN: "អង់គ្លេស",
    BIGGER_THAN_EQUAL: "ធំជាងស្មើ",
    AND_MORE: "និង {count} ជម្រើសផ្សេងទៀត",
    ALL_AGENT: "ភ្នាក់ងារទាំងអស់",
    GROUP_AGENT: "ភ្នាក់ងារក្រុម",
    SPECIFIC_AGENT: "ភ្នាក់ងារពិសេស",
    CHOOSE_NOT_APPLY_AGENT: "ជ្រើសភ្នាក់ងារដែលមិនអនុវត្តពრომូសិន",
    CHOOSE_APPLY_AGENT: "ជ្រើសភ្នាក់ងារដែលអនុវត្តព្រូមូសិន",
    LIST_NOT_APPLY_AGENT: "បញ្ជីភ្នាក់ងារដែលមិនអនុវត្តព្រូមូសិន",
    LIST_APPLY_AGENT: "បញ្ជីភ្នាក់ងារដែលអនុវត្តព្រូមូសិន",
    SEARCH_NAME_AGENT: "បញ្ចូលឈ្មោះឬកូដភ្នាក់ងារ",
    AGENT_TYPE: "ប្រភេទ",
    ENTERPRISE_AGENT: "ក្រុមហ៊ុនធ្វើដំណើរ",
    ENTERPRISE_TRADING: "ក្រុមហ៊ុនជួញដូរ",
    ENTERPRISE_API: "ក្រុមហ៊ុន API",
    LIST_AGENT: "បញ្ជីភ្នាក់ងារធ្វើដំណើរ",
    SUCCESS: "ជោគជ័យ",
    CONFIG_CONNECT: "កំណត់ការភ្ជាប់",
    NO_RECORDS: "គ្មានតំណត់ត្រាដែលអាចបង្ហាញបាន",
    QUANTITY: "បរិមាណ",
    ROOM_PRICE: "តម្លៃបន្ទប់",
    EXTRA_ADULT: "មនុស្សពេញវ័យបន្ថែម",
    EXTRA_CHILD: "ក្មេងបន្ថែម",
    HOTEL_PROMOTION: "ពრომូសិនសណ្ឋាគារ",
    GUEST_INFO: "ព័ត៌មានភ្ញៀវ",
    MAX_GUEST: "ចំនួនភ្ញៀវអតិបរមា",
    MAX: "អតិបរមា",
    BOOKING_INFO: "ព័ត៌មានទូទៅ",
    WRONG_DOMAIN: "ឈ្មោះដែនមិនត្រឹមត្រូវ",
    FILE_NULL: "បញ្ហាក្នុងការផ្ទុកឯកសារ",
    PLEASE_COMPLETE_THE_FIELDS_MARKED: "សូមបំពេញទាំងអស់នូវបញ្ជីវាលដែលត្រូវការបញ្ចូល",
    ADD_NEW_SOCIAL_NETWORK: "បន្ថែមបណ្តាញសង្គមថ្មី",
    PRIMARY_TEXT_COLOR: "ពណ៌អត្ថបទចម្បង",
    PRIMARY_BACKGROUND_COLOR: "ពណ៌ផ្ទៃខាងក្រោមចម្បង",
    TOP_HEADER_TEXT_COLOR: "ពណ៌អត្ថបទខ្នាតខាងលើ",
    TOP_HEADER_BACKGROUND_COLOR: "ពណ៌ផ្ទៃខាងក្រោមខ្នាតខាងលើ",
    HEADER_TEXT_COLOR: "ពណ៌អត្ថបទខ្នាត",
    HEADER_BACKGROUND_COLOR: "ពណ៌ផ្ទៃខាងក្រោមខ្នាត",
    FOOTER_TEXT_COLOR: "ពណ៌អត្ថបទផ្នែកខាងក្រោម",
    FOOTER_BACKGROUND_COLOR: "ពណ៌ផ្ទៃខាងក្រោមផ្នែកខាងក្រោម",
    BOTTOM_FOOTER_TEXT_COLOR: "ពណ៌អត្ថបទផ្នែកខាងក្រោមចុងក្រោយ",
    BOTTOM_FOOTER_BACKGROUND_COLOR: "ពណ៌ផ្ទៃខាងក្រោមចុងក្រោយ",
    BUTTON_TEXT_COLOR: "ពណ៌អត្ថបទប៊ូតុង",
    BUTTON_BACKGROUND_COLOR: "ពណ៌ផ្ទៃខាងក្រោបប៊ូតុង",
    BUTTON_TEXT_COLOR_2: "ពណ៌អត្ថបទប៊ូតុង 2",
    BUTTON_BACKGROUND_COLOR_2: "ពណ៌ផ្ទៃខាងក្រោបប៊ូតុង 2",
    CUSTOM: "កំណត់",
    URL: "តំណភ្ជាប់",
    OTA_IS_OUT_OF_TIME: "បណ្តាញ OTA មិនទាន់បានដំណើរការទេ",
    DATA_INPUT_MUST_BE_GREATER_THAN_0: "ទិន្នន័យដែលបញ្ចូលគួរតែធំជាង 0",
    HOTEL_EXTRA_RATE_UPDATE: "ធ្វើបច្ចុប្បន្នភាពអត្រាបន្ថែម",
    HOTEL_EXTRA_RATE_DELETE: "លុបអត្រាបន្ថែម",
    DATE_OF_STAY_DOES_NOT_APPLY: "កាលបរិច្ឆេទនៅមិនអាចប្រើបានទេ",
    DATE_OF_BOOKING_DOES_NOT_APPLY: "កាលបរិច្ឆេទដែលបានកំណត់មិនអាចប្រើបានទេ",
    BOOKING_CODE_OTA: "កូដការកក់ OTA",
    HOTEL_WAS_CONNECTED_WITH_OTA: "សណ្ឋាគារត្រូវបានភ្ជាប់ជាមួយបណ្តាញ OTA ហើយ",
    ROOM_TYPE_OTA: "ezCms Leo",
    CONNECTED: "បានភ្ជាប់",
    NOT_CONNECTED: "មិនបានភ្ជាប់",
    MISSING_ROOM_AND_PRICE: "បាត់បង់បន្ទប់ តម្លៃ និងកម្រិតដាក់កំហិត",
    CONNECTED_OTA: "ការផ្សព្វផ្សាយ OTA",
    SYNC_IN_PROGRESS: "កំពុងធ្វើការសមនភាព",
    CONNECTING: "កំពុងភ្ជាប់",
    ROOM_AND_PRICE_PACKAGES_HAVE_NOT_BEEN_DECLARED: "កញ្ចប់បន្ទប់និងតម្លៃមិនទាន់បានប្រកាសទេ",
    CONNECTION_FAILED: "ការភ្ជាប់បរាជ័យ",
    SU_CONNECTION: "បណ្តាញសម្រាប់ការលក់",
    SU_MAPPING: "កំណត់ផែនទី",
    CHANNEL_MANAGER_SYSTEM: "ប្រព័ន្ធការកក់មជ្ឈមណ្ឌល",
    ENTER_NAME_OR_CODE: "បញ្ចូលកូដឬឈ្មោះ",
    OTA_LOG: "កំណត់ត្រាសមនភាព",
    INVENTORY_LOG: "កំណត់ត្រាគ្រប់គ្រងស្តុក",
    ERROR_LOG: "កំណត់ត្រាបញ្ហា",
    SOURCE: "ប្រភព",
    UPDATE_TIME: "ពេលវេលាបច្ចុប្បន្នភាព",
    RATE: "អត្រា",
    STOP_SELL: "បញ្ឈប់ការលក់",
    MIN_STAY: "កាលបរិច្ឆេទស្នាក់នៅអប្បបរមា",
    MAX_STAY: "កាលបរិច្ឆេទស្នាក់នៅអតិបរមា",
    EXTRA_ADULT_RATE: "ការបញ្ចេញថ្លៃបន្ថែមសម្រាប់មនុស្សពេញវ័យ",
    EXTRA_CHILD_RATE: "ការបញ្ចេញថ្លៃបន្ថែមសម្រាប់ក្មេង",
    FULL_UPDATE: "ព័ត៌មានលម្អិត",
    UN_STOP_SELL: "លុបការបញ្ឈប់ការលក់",
    OPEN_RESERVATION: "បើកការកក់",
    OPEN_CHECKOUT: "បើកការបញ្ជាក់ការចេញ",
    ERROR_PHONE_NUMBER_LENGTH: "លេខទូរស័ព្ទគួរតែមានយ៉ាងហោចណាស់ 6 តួ និងបន្ទាប់ទៅ 10 តួ",
    ERROR_PHONE_NUMBER_STRING: "លេខទូរស័ព្ទមិនត្រូវមានអក្សរ និងលេខ 0 នៅដើមលេខទេ",
    FAILURE: "បរាជ័យ",
    ACTIVE_LOG: "កំណត់ត្រាការប្រតិបត្ដិ",
    WAITING: "កំពុងរង់ចាំ",
    ROOM_SALE_UPDATE: "បច្ចុប្បន្នភាពការលក់បន្ទប់",
    PRICE_EXTRA_SPECIAL: "តម្លៃបន្ថែមប្រចាំថ្ងៃ",
    BASE_PRICE_IS_MISSING: "មិនមានតម្លៃមូលដ្ឋានដែលបានប្រកាស",
    TOOLTIP_MASTER: "ជ្រើសមួយផលិតផល Master ដើម្បីប្រើជាឧទាហរណ៍សម្រាប់ការគណនាតម្លៃសម្រាប់បន្ទាត់ផ្សេងទៀត",
    RULE_CODE: "កូដរវាង 2-20 តួដែលមានតែអក្សរនិងចំនួនទេ",
    ROOM_DERIVE: "ចំលងបន្ទប់ - ចំលងពីបន្ទប់ប៉េង",
    DERIVE_OF_ROOM: "ចំលងពី",
    COPY_BY_FOMULAR: "ចម្លងតាមគម្រោង",
    PASTE: "បិទ",
    DATE_RANGE: "អំពីថ្ងៃ",
    CODE_IS_EXISTED: "កូដសេវាកម្មមានរួចហើយ",
    HOTEL_CHANGE_SUCCESS: "ការផ្លាស់ប្តូរសណ្ឋាគារជោគជ័យ",
    ROOM_CLASS: "ប្រភេទបន្ទប់",
    UPDATE_FOR: "បច្ចុប្បន្នភាពសម្រាប់ {date}",
    UPDATE_RATE_BY_RANGE: "បច្ចុប្បន្នភាពបញ្ចូលជាប្រាំ",
    BOOKER: "ឈ្មោះអ្នកកក់",
    SEARCH_BY_BOOKER: "ឈ្មោះភ្ញៀវ",
    CONTACT_US: "ទំនាក់ទំនងមកយើង",
    UPDATE_TO_STOP_SELLING_OPENING: "ធ្វើបច្ចុប្បន្នភាពដើម្បីបញ្ឈប់ការលក់/បើកការលក់",
    UPDATE_ROOM_AVAILABILITY_IN_STAGES: "បច្ចុប្បន្នភាពជាប្រាំ",
    UPDATE_SELLING_PRICES_IN_STAGES: "ធ្វើបច្ចុប្បន្នភាពអត្រាការលក់",
    UPDATE_STOP_SELL: "ធ្វើបច្ចុប្បន្នភាពការបញ្ឈប់ការលក់",
    UPDATE_SELL_LIMIT_BY_OTA: "ធ្វើបច្ចុប្បន្នភាពកំណត់លក់",
    UPDATE_SELL_LIMIT_FOR_NEW_OTA: "ធ្វើបច្ចុប្បន្នភាពកំណត់លក់",
    UPDATE_RESTRICTION_STOPSELL: "ធ្វើបច្ចុប្បន្នភាពការបញ្ឈប់ការលក់",
    UPDATE_STOP_SELL_BY_OTA: "ធ្វើបច្ចុប្បន្នភាពការបញ្ឈប់ការលក់",
    DELETE_SELL_LIMIT_BY_OTA: "លុបកំណត់លក់",
    DELETE_STOP_SELL_BY_OTA: "លុបការបញ្ឈប់ការលក់",
    OTHER_FUNCTION: "ផ្សេងៗ",
    VIEW_MOBILE_VERSION: "មើលនៅលើឧបករណ៍ទូរស័ព្ទចល័ត",
    VIEW_DESKTOP_VERSION: "មើលនៅលើកុំព្យូទ័រ",
    FILTER_RESULTS: "តម្រង",
    STOPSELL_UPDATE_SUCCESS: "ធ្វើបច្ចុប្បន្នភាពការបញ្ឈប់ការលក់ជោគជ័យ",
    REMOVE_STOPSELL_SUCCESS: "លុបការបញ្ឈប់ការលក់ជោគជ័យ",
    HOTEL: "សណ្ឋាគារ 0 | សណ្ឋាគារ 1 | សណ្ឋាគារ {count}",
    NIGHT_NUMBER: "បន្ទប់នៅ",
    CONFIRM_STOP_SELL: "ធ្វើបច្ចុប្បន្នភាពការបញ្ឈប់ការលក់",
    CONFIRM_REMOVE_STOP_SELL: "អនុវត្តការលុបការបញ្ឈប់ការលក់",
    APP: "កម្មវិធី",
    ENTER_THE_NAME_OF_THE_APP_WANT_TO_SEARCH_FOR: "បញ្ចូលឈ្មោះកម្មវិធីដែលអ្នកចង់ស្វែងរក",
    LABEL_NIGHT_BACKGROUND_COLOR: "ពណ៌ផ្ទាំងក្រោយបន្ទាប់ 1",
    LABEL_NIGHT_TEXT_COLOR: "ពណ៌អក្សរបន្ទាប់ 1",
    PACKAGE_TEXT_COLOR: "ពណ៌អក្សរកញ្ចប់កញ្ចប់",
    PROMOTION_BACKGROUND_COLOR: "ពណ៌ផ្ទាំងក្រោយទីពីរ",
    PROMOTION_TEXT_COLOR: "ពណ៌អក្សរទីពីរ",
    PRICE_TEXT_COLOR: "ពណ៌តម្លៃ 1",
    RANK_STAR_COLOR: "ពណ៌ផ្កាយ",
    TEXT_PRICE_2_COLOR: "ពណ៌ថ្លៃ 2",
    SUB_TEXT_3_COLOR: "ពណ៌អក្សរបន្ថែម 3",
    SUB_BACKGROUND_3_COLOR: "ពណ៌ផ្ទាំងក្រោយ 3",
    RE_SYNC: "បញ្ចូនការកក់ម្តងទៀត",
    CONFIRM_RE_SYNC: "បញ្ជាក់ការបញ្ចូនម្តងទៀត",
    HOTEL_REPORT_BOOKING: "បញ្ចូនការកក់ម្តងទៀត",
    UPDATE_INTERVAL_IS_NOT_MORE_THAN_ONE_YEAR: "ការបច្ចុប្បន្នភាពត្រូវមិនលើស ១ ឆ្នាំ",
    ACCOUNT_IS_NOT_CONNECTED_TO_GDS: "គណនីមិនបានភ្ជាប់ទៅ ezCms GDS",
    DISCONNECT: "ផ្ដាច់ការភ្ជាប់",
    CONFIRM_DISCONNECT_OTA: "តើអ្នកប្រាកដជាចង់ផ្ដាច់ការភ្ជាប់ឬ?",
    CONFIRM_CONNECT_OTA: "តើអ្នកប្រាកដជាចង់ភ្ជាប់ឡើងវិញ?",
    GDS_OTA: "ezCms GDS",
    ROOM_DUPLICATE: "កូដបន្ទប់មិនអាចចំលងបានទេ",
    ROOM_PLAN_DUPLICATE: "កូដអត្រាមិនអាចចំលងបានទេ",
    YOU_DONT_HAVE_ANY_HOTELS_YET: "មិនមានសណ្ឋាគារណាមួយទេ។",
    TEXT_GDS_INFOMATION: "GDS គឺជាបណ្តាញការកក់គ្រប់គ្រងកុំព្យូទ័រពិភពលោកដែលមានអ្នកកក់ជាង 450,000 តំណាងកម្សាន្តប្រើដើម្បីកក់បន្ទប់សណ្ឋាគារ។",
    ROOM_TYPE_ON_CMS: "ប្រភេទបន្ទប់លើ ezCrs",
    ROOM_TYPE_ON_SABRE: "ប្រភេទបន្ទប់លើបណ្តាញលក់",
    ROOM_PLAN_ON_CMS: "គម្រោងអត្រាលើ ezCrs",
    ROOM_PLAN_ON_SABRE: "គម្រោងអត្រាលើបណ្តាញលក់",
    CHAIN_CODE: "កូដខ្សែសង្វាក់សណ្ឋាគារ",
    CHAIN_TYPE: "ប្រភេទខ្សែសង្វាក់សណ្ឋាគារ",
    ITEMS_SHOWING: "ធាតុបង្ហាញ",
    TA_NAME: "ឈ្មោះតំណាង",
    TA_CODE: "កូតតំណាង",
    CHAIN_TRAVEL_AGENT_INFOMATION: "ព័ត៌មានតំណាង",
    ASSIGN_TA_TO_HOTEL: "ប្រកាន់តំណាងដល់សណ្ឋាគារ",
    ALLOW_OVERWRITING_INFOMATION_DOWN_TO_THE_HOTEL: "អនុញ្ញាតឱ្យប្រើប្រាស់ព័ត៌មានអត្រាដោយបញ្ចូលទៅកាន់សណ្ឋាគារ",
    FIRST_NAME: "ឈ្មោះដំបូង",
    LAST_NAME: "ឈ្មោះចុងក្រោយ",
    CHAIN_AGENT_LIST: "ក្រុមហ៊ុន និងតំណាង",
    ASSIGN_ROOM_TO_HOTEL: "ប្រកាន់បន្ទប់ទៅសណ្ឋាគារ",
    ASSIGN_RATE_PLAN_TO_HOTEL: "ប្រកាន់គម្រោងអត្រាទៅសណ្ឋាគារ",
    CHAIN: "ខ្សែសង្វាក់",
    UNASSIGN: "មិនបានប្រកាន់",
    ASSIGN: "បានប្រកាន់",
    CONFIRM_CHANGE_ACTIVE: "បញ្ជាក់ការផ្លាស់ប្តូរប្រភេទស្ថានភាពតំណាង",
    ENTERPRISE_CODE: "កូដអាជីវកម្ម",
    FIRST_NAME_REPRESENT: "ឈ្មោះចុងក្រោយតំណាង",
    LAST_NAME_REPRESENT: "ឈ្មោះតំណាង",
    ACCOUNT_HOLDER: "អ្នកកាន់កាប់គណនី",
    POSITION: "មុខតំណែង",
    HOTEL_LIST: "បញ្ជីសណ្ឋាគារ",
    CHAIN_CONFIG: "កំណត់រចនាសម្ព័ន្ធខ្សែសង្វាក់",
    ASSIGN_SERVICE_TO_HOTEL: "ប្រកាន់សេវាកម្មទៅសណ្ឋាគារ",
    ROOM_TYPE_CODE_HAS_SYNCED_TO_OTA: "ប្រភេទបន្ទប់សណ្ឋាគារបានត្រូវបានសម្រួល។ សូមពិនិត្យម្តងទៀត",
    ROOM_CODE_DUPLICATION_ROOM_CODE_IN_CHAIN: "កូដប្រភេទបន្ទប់ផ្ទៀងផ្ទាត់នឹងកូដប្រភេទបន្ទប់។ សូមពិនិត្យម្តងទៀត",
    ROOM_CODE_DUPLICATION: "កូដប្រភេទបន្ទប់មានរួចហើយ",
    CHAIN_ROOM_TYPE_IS_OVER_LIMIT: "ចំនួនបន្ទប់លើសចំនួនបន្ទប់សរុបនៅកម្រិតសណ្ឋាគារ",
    RATE_PLAN_CODE_DUPLICATION: "គម្រោងលក់មានរួចហើយ។ សូមពិនិត្យម្តងទៀត",
    SERVICE_NOT_EXIST: "សេវាកម្មមិនមាន",
    SERVICE_CODE_DUPLICATION: "កូដសេវាកម្មមានរួចហើយនៅក្នុងសណ្ឋាគារខ្សែសង្វាក់។ សូមពិនិត្យម្តងទៀត",
    TRAVEL_AGENT_ALREADY_EXIST: "ព័ត៌មានក្រុមហ៊ុន និងតំណាងមានរួចហើយ។ សូមពិនិត្យម្តងទៀត",
    HOTEL_NOT_USE_EQUAL_CURRENCY: "សណ្ឋាគារដែលបានប្រកាន់ប្រើប្រាស់រូបិយប័ណ្ណខុសគ្នា សូមពិនិត្យម្តងទៀត",
    AUTO_CANCEL: "អនុញ្ញាតឱ្យបោះបង់ដោយស្វ័យប្រវត្តិនៅពេលការកក់មិនត្រូវបានបញ្ជាក់",
    ACCOUNT_IS_NOT_CONNECTED_TO_SITEMINDER: "គណនីមិនបានភ្ជាប់ទៅ ezCms SiteMinder",
    ROOM_TYPE_MAP_UNMAP: "ប្រភេទបន្ទប់ដែលភ្ជាប់ឥឡូវនេះនឹងត្រូវបានផ្ដាច់បើមានការជ្រើសរើស និងរក្សាទុក។ សកម្មភាពនេះអាចបណ្តាលឲ្យមានការបាត់បង់ការភ្ជាប់, ការកក់លើស, ការមិនមានការកក់បានភ្ជាប់",
    OTA_HOTEL_CODE_ALREADY_EXITS: "កូដសណ្ឋាគារដែលអ្នកបានបញ្ចូលមានការភ្ជាប់រួចហើយ សូមពិនិត្យម្តងទៀត!",
    ADD_SERVICE_TO_ROOM_RATE: "បន្ថែមសេវាកម្មទៅក្នុងគម្រោងលក់",
    CONFIRM_DELETE_SERVICE_PACKAGE: "បញ្ជាក់ការលុបសេវាកម្មនេះចេញពីអត្រាបន្ទប់",
    PACKAGE_DEAL: "កញ្ចប់ជួញដូរ",
    PACKAGE_ITEM: "ធាតុកញ្ចប់",
    PRICE_ALLOCATION: "ការចែកចាយតម្លៃ",
    WEEKLY_PRICE: "តម្លៃប្រចាំសប្តាហ៍",
    DAILY_PRICE: "តម្លៃប្រចាំថ្ងៃ",
    RD_DAY: "{day}ថ្ងៃ",
    TOTAL_PACKAGE_VALUE: "តម្លៃសរុបនៃកញ្ចប់",
    LIST_EDIT_SUCCESS: "បច្ចុប្បន្នភាពជោគជ័យ",
    INFOMATION_OF_BANK_ACCOUNT: "ព័ត៌មានអំពីគណនីធនាគារ",
    CHILD_HAS_MORE_OTA_THAN_MASTER: "មិនអាចបង្កើតទំនាក់ទំនងបានទេ",
    ENTIRE_HOTEL: "កម្រិតសណ្ឋាគារ",
    ACCORDING_TO_EACH_ROOM_CLASS: "កម្រិតប្រភេទបន្ទប់",
    NUMBER_OF_ROOMS_AVAILABLE: "ចំនួនបន្ទប់ដែលមានស្រាប់",
    ROOM_OCCUPANCY: "ការរស់នៅក្នុងបន្ទប់",
    EDIT_DYNAMIC_PRICING: "បញ្ជាក់ព័ត៌មានម៉ូឌែលតម្លៃតាមលំនាំ",
    ADD_NEW_DYNAMIC_PRICING: "បន្ថែមម៉ូឌែលតម្លៃតាមលំនាំថ្មី",
    DYNAMIC_PRICING: "តម្លៃលំនាំ",
    CONFIRM_DELETE_DYNAMIC_PRICING: "បញ្ជាក់លុបម៉ូឌែលតម្លៃតាមលំនាំ",
    DYNAMIC_NAME: "ឈ្មោះម៉ូឌែលតម្លៃតាមលំនាំ",
    DYNAMIC_DESCRIPTION: "ពិពណ៌នាអំពីម៉ូឌែលតម្លៃតាមលំនាំ",
    CRITERIA: "លក្ខខណ្ឌ",
    PRICE_CALCULATION_FORMULA: "មុខងារជួសជុលតម្លៃ",
    TOTAL_NUMBER_OF_ROOMS_BY_ROOM_CLASS: "ចំនួនបន្ទប់សរុបដែលបានលក់តាមប្រភេទបន្ទប់ (ចំនួនបន្ទប់ដែលបានលក់ដោយបញ្ចូលការកក់ថ្ងៃប្រើ)",
    TOTAL_NUMBER_OF_ROOMS_BY_HOTEL: "ចំនួនបន្ទប់សរុបដែលបានលក់ដោយសណ្ឋាគារ (ចំនួនបន្ទប់ដែលបានលក់ដោយបញ្ចូលការកក់ថ្ងៃប្រើ)",
    TOTAL_NUMBER_OF_AVAILABLE_ROOMS_BY_ROOM_CLASS: "ចំនួនបន្ទប់ដែលមានស្រាប់តាមប្រភេទបន្ទប់",
    TOTAL_NUMBER_OF_AVAILABLE_ROOMS_BY_HOTEL: "ចំនួនបន្ទប់សណ្ឋាគារដែលមានស្រាប់",
    ROOM_CAPACCITY_FORMULA: "មុខងារជួសជុលកម្រិតបន្ទប់",
    FROM_TO_LESS: "ពី {val} ទៅតិចជាង",
    NO_PRIOTITY: "គ្មានអាទិភាព",
    PRIOTITY: "អាទិភាព",
    UN_SELECT_ALL: "លុប",
    SET_THE_PRICE_CYCLE: "ការលក់តាមលំនាំ",
    EVENT: "តាមព្រឹត្តិការណ៍",
    CALENDAR: "កាលវិភាគ (Coming soon)",
    DYNAMIC_RATE_METHOD: "វិធីតម្លៃលំនាំ",
    CONFIRM_DEACTIVE_DYNAMIC_RATE: "បញ្ជាក់បញ្ឈប់ការប្រើប្រាស់តម្លៃលំនាំ",
    RMS_MANAGEMENT: "ការគ្រប់គ្រងប្រាក់ចំណូល",
    DERIVED_ROOMTYPE: "ប្រភេទបន្ទប់ដែលបានបន្សល់",
    BASE: "ប្រភេទបន្ទប់មូលដ្ឋាន",
    UPDATE_FORMULAR: "បច្ចុប្បន្នភាពមុខងារ",
    FORMULAR: "មុខងារ",
    SET_UP_FORMULAR_BY_DATE_RANGE: "កំណត់រចនាសម្ព័ន្ធតាមប្រវែងថ្ងៃ",
    MASTER_RATE: "តម្លៃមេ",
    SET_UP_FORMULAR: "កំណត់រចនាសម្ព័ន្ធ",
    CONFIRM_DELETE_FORMULA: "បញ្ជាក់ការលុបរចនាសម្ព័ន្ធ",
    EDIT_PRICE: "កែប្រែតម្លៃ",
    FOR_EXAMPLE_SERVICE: "ការកក់ពីថ្ងៃទី ១ ខែតុលាដល់ថ្ងៃទី ១០ ខែតុលា (៩ យប់) <br> ជាមួយការកំណត់ប្តូរដូចខាងក្រោម: <br> <ul> <li> ចាប់ពីយប់ទី ១: ១ </li> <li> បញ្ចប់នៅយប់ទី: យប់ចុងក្រោយ </li> <li> ប្រើជាករយៈ: ២ (ថ្ងៃ) </li> <li> ចំនួនការកំណត់ឡើងវិញ: ៣ (ដង) </li></ul> សេវាកម្មអាចអនុវត្តបានពីថ្ងៃទី ១ ខែតុលា ដល់ថ្ងៃទី ១០ ខែតុលា <br> ពីព្រោះករយៈការប្រើប្រាស់គឺ ២ (២ ថ្ងៃ/ដង) សេវាកម្មអាចអនុវត្តបាននៅថ្ងៃទី ១, ៣/១០, ៥/១០, ៧/១០, ៩/១០ <br> ប៉ុន្តែពីព្រោះចំនួនការប្តូរនេះគឺ ៣ សេវាកម្មអាចអនុវត្តបានក្នុង ៣ ថ្ងៃគឺ ១/១០, ៣/១០, ៥/១០ <br> ជាមួយការកំណត់ខាងលើ សេវាកម្មនេះនឹងអនុវត្តនៅ <strong>១/១០, ៣/១០, ៥/១០</strong>",
    SCHEDULINGTYPE_1: "អនុវត្តនៅយប់ទីមួយនៃការស្នាក់នៅ",
    SCHEDULINGTYPE_2: "អនុវត្តនៅយប់ចុងក្រោយនៃការស្នាក់នៅ",
    SCHEDULINGTYPE_3: "យប់ X អនុវត្ត ១ ដង ចាប់ពីយប់ Y",
    SCHEDULINGTYPE_4: "អនុវត្តនៅយប់ទាំងអស់ក្រៅពីយប់ទីមួយ",
    SCHEDULINGTYPE_5: "អនុវត្តនៅយប់ទាំងអស់ក្រៅពីយប់ចុងក្រោយ",
    SCHEDULINGTYPE_6: "មិនអនុវត្តសម្រាប់យប់ទីមួយ និងយប់ចុងក្រោយ",
    SCHEDULINGTYPE_7: "អនុវត្តនៅយប់ (១៤ យប់)",
    SCHEDULINGTYPE_8: "អនុវត្តនៅយប់ X ដែលជាជម្រើស",
    SCHEDULINGTYPE_9: "បញ្ចូលជ្រើសរើស",
    SCHEDULINGTYPE_0: "យប់ទាំងអស់",
    EXAMPLE: "ឧទាហរណ៍",
    STARTING_FROMM_NIGHT: "ចាប់ពីយប់",
    ENDS_ON_NIGHT: "បញ្ចប់នៅយប់",
    USE_CYCLE: "ការប្រើប្រាស់ជាករយៈ",
    NUMBER_OF_REPETITION: "ចំនួនការប្តូរឡើងវិញ",
    NUMBER_OF_REPETITION_DETAIL: "ការប្រើប្រាស់ជាករយៈ (X យប់អនុវត្ត ១ ដង)",
    NIGHT_14_DESCRIPTION: "បើមានការកក់លើស ១៤ យប់ បន្ទាប់ពី ១៤ យប់សេវាកម្មនឹងត្រូវបានអនុវត្តម្តងទៀតតាមការប្រើប្រាស់ដែលបានជ្រើស",
    CODE_NOT_EMPTY: "កូដមិនអាចមានចម្លង ឬវាលសូន្យបានទេ",
    BEFORE_THE_LAST_NIGHT: "មុនយប់ចុងក្រោយ",
    LAST_NIGHT: "យប់ចុងក្រោយ",
    CONFIRM_UPDATE_PRICE_SERVICE_GREATER_THAN_TOTAL_PACKAGE: "តម្លៃចំណាយលើការចែកចាយត្រូវបានលើសតម្លៃសរុបនៃកញ្ចប់ តើអ្នកបញ្ជាក់ឲ្យធ្វើបច្ចុប្បន្នភាពទេ?",
    EDIT_ATTRIBUTION: "កែប្រែការចំណាត់ថ្នាក់",
    MIN_ROOM_RATE: "តម្លៃបន្ទប់អប្បបរមា",
    SETUP_FORMULA: "បច្ចុប្បន្នភាពរចនាសម្ព័ន្ធ",
    SETUP_FORMULA_BY_DATE_RANGE: "បច្ចុប្បន្នភាពរចនាសម្ព័ន្ធតាមប្រវែងថ្ងៃ",
    DELETE_FORMULA: "លុបរចនាសម្ព័ន្ធ",
    CAN_NOT_CREATE: "មិនអាចបង្កើតការលក់បន្ទប់បានទេ ពីព្រោះវាត្រូវបានអាស្រ័យលើការលក់បន្ទប់មាតិកា",
    HAVE_BEEN_CONNECTED_TO_OTA: "ប្រភេទបន្ទប់/កញ្ចប់បានភ្ជាប់ទៅ OTA",
    CAN_NOT_INACTIVE_OR_DELETE: "មិនអាចបច្ចុប្បន្នភាពបានទេ",
    ROOM_RATE_IS_CHILDREN: "ផលិតផលដែលកំពុងអាប់ដេតគឺជាផលិតផលដែលបានបន្សល់",
    TO_LESS: "ទៅតិចជាង",
    COMBO: "កញ្ចប់",
    TITLE_DESCRIPTION_DYNAMIC_CHANGE: "វិធីប្តូរតាមព្រឹត្តិការណ៍អនុញ្ញាតឲ្យសណ្ឋាគារកំណត់ការផ្លាស់ប្តូរ តម្លៃតាមលំនាំ/ កំណត់កំណត់តាមព្រឹត្តិការណ៍ ដែលទាក់ទងនឹងស្តុកដែលមានរួមបញ្ចូល៖",
    CHANGE_TYPE_1: "បច្ចុប្បន្នភាពស្តុកពី PMS",
    CHANGE_TYPE_2: "ការកក់បានបញ្ជូន / ទាញយកពីឆានែលអនឡាញ",
    CHANGE_TYPE_3: "បើក / បិទប្រភេទបន្ទប់",
    CHANGE_TYPE_4: "បង្កើត / កែប្រែរចនាសម្ព័ន្ធតម្លៃតាមលំនាំ",
    CHANGE_TYPE_5: "ប្ដូរតម្លៃបន្ទប់",
    CHANGE_TYPE_6: "បិទ / បើកបន្ទប់",
    SCHEDULE_DYNAMIC_PRICING: "ការកំណត់តម្លៃបន្ទប់តាមលំនាំ",
    HAVE_BEEN_CONNECTED_TO_DYNAMICPRICING: "មិនអាចលុបបានទេ ពីព្រោះផលិតផលបានកំណត់តម្លៃតាមលំនាំ",
    SERVICE_INCLUDES: "សេវាកម្មដែលរួមបញ្ចូល",
    CHAIN_INFO: "ព័ត៌មានទូទៅ - ខ្សែសង្វាក់",
    CHAIN_ROOM_TYPE: "ប្រភេទបន្ទប់ - ខ្សែសង្វាក់",
    CHAIN_RATE_PLAN: "គម្រោងការលក់បន្ទប់ - ខ្សែសង្វាក់",
    CHAIN_ROOM_TYPE_AMENITY: "សេវាកម្មបន្ទប់ - ខ្សែសង្វាក់",
    CHAIN_SERVICE: "សេវាកម្ម - ខ្សែសង្វាក់",
    CODE_NOT_VALIDATE: "កូដមិនត្រូវបានបញ្ជាក់",
    PAYMENT_CODE: "កូដសង្វាក់តប",
    PAYMENT_TYPE: "ប្រភេទប្រតិបត្ដិការទូទាត់",
    PAYMENT_STATUS: "ស្ថានភាពប្រតិបត្ដិការទូទាត់",
    PAYMENT: "ការទូទាត់",
    REFUND: "ការប្រាក់ត្រឡប់",
    CANCELLATION_REFUND: "ការប្រាក់ត្រឡប់សម្រាប់ការលុបចោល",
    CANCELLATION_FEE: "ថ្លៃលុបចោល",
    WAITING_PAYMENT: "រង់ចាំការទូទាត់",
    SUCCESS_PAYMENT: "ការទូទាត់ជោគជ័យ",
    FAILED: "បរាជ័យ",
    CHAIN_NOT_EXIST: "ខ្សែសង្វាក់មិនមាន",
    CHAIN_TRAVEL_AGENT: "ព័ត៌មានក្រុមហ៊ុននិងភ្នាក់ងារ - ខ្សែសង្វាក់",
    HOTEL_TRAVEL_AGENT: "ព័ត៌មានក្រុមហ៊ុននិងភ្នាក់ងារ",
    BE_MANAGEMENT: "ezBe",
    THE_SYSTEM_IS_LOADING: "ប្រព័ន្ធកំពុងផ្ទុក សូមរង់ចាំ",
    OTA_HOTEL_NOT_FOUND: "សណ្ឋាគារលើ OTA មិនបានរកឃើញ",
    ROOM_CLASS_MAPING: "ការភ្ជាប់ប្រភេទបន្ទប់",
    CONFIRM_SAVE: "អ្នកទើបតែបានផ្លាស់ប្តូរព័ត៌មានការភ្ជាប់។ សកម្មភាពនេះអាចនាំឲ្យមានការបាត់បង់ការភ្ជាប់ បោះបង់និងការកក់អស់ពីស្តុក",
    UNDO: "កំហុស",
    CONFIRM_UNDO: "ការផ្លាស់ប្តូរដែលអ្នកទើបតែបានធ្វើមិននឹងត្រូវបានរក្សាទុកទេ តើអ្នកប្រាកដជាចង់ធ្វើការត្រឡប់មកវិញដែរ?",
    DEFAULT_LANGUAGE: "ភាសាចម្បងដែលប្រើប្រាស់",
    RE_SYNC_CONNECT: "ធ្វើការបញ្ជាក់ម្តងទៀត",
    ez_FOLIO: "ezFolio",
    ez_CLOUDHOTEL: "ezCloudHotel",
    ADVANCE_SEARCH: "ស្វែងរកជំហានជ្រៅ",
    PRICE_OR_OTA_IS_REQUIRED: "តម្លៃលក់ ឬឆានែលលក់មិនអាចទទេ",
    UPDATE_BY_ROOM_TYPE: "បច្ចុប្បន្នភាពតាមប្រភេទបន្ទប់",
    UPDATE_BY_SALE_PACKAGE: "បច្ចុប្បន្នភាពតាមគម្រោងការលក់បន្ទប់",
    UPDATE_BY_SALE_CHANNEL: "បច្ចុប្បន្នភាពតាមឆានែល OTA",
    BULK_DELETE: "លុបជាច្រើន",
    CONFIRM_UPDATE_OVERWRITE: "បញ្ជាក់ការបច្ចុប្បន្នភាពលើការបង្ហោះតម្លៃ និងចំនួនមនុស្សដែលរួមបញ្ចូលនៅក្នុងតម្លៃសម្រាប់ឆានែលលក់ដែលបានជ្រើសគ្រប់រួម",
    ONLY_UPDATE_PRICE: "តម្លៃត្រូវបានជំនួសតែមួយ",
    DAILY_MASTER_RATE: "តម្លៃប្រចាំថ្ងៃសមាស",
    NUMBER_NIGHT: "យប់",
    NUMBER_ROOM: "បន្ទប់",
    ROOM_CAP: "0 បន្ទប់ | 1 បន្ទប់ | {count} បន្ទប់",
    BOOKING_CAP: "0 កក់ | 1 កក់ | {count} កក់",
    CHECKIN_STATUS_RESERVED: "បានរក្សាទុក",
    CHECKIN_STATUS_CHECKIN: "ចុះបញ្ជីការស្នាក់នៅ",
    CHECKIN_STATUS_CHECKOUT: "ចេញពីសណ្ឋាគារ",
    CHECKIN_STATUS_NO_SHOW: "មិនមែនបង្ហាញ",
    CHECKIN_STATUS_ARRIVAL: "ការមកដល់",
    CHECKIN_STATUS_DUE_OUT: "កំពុងចេញ",
    CHECKIN_STATUS_CANCELLED: "បានលុបចោល",
    NAME_OF_GUEST_STAYING: "ភ្ញៀវស្នាក់នៅ",
    PRICE_EXTRA_DAILY: "តម្លៃបន្ថែមប្រចាំថ្ងៃ",
    CHANNEL: "0 ឆានែល | 1 ឆានែល | {count} ឆានែល",
    ASSIGN_RATE_TO_CATEGORY: "ចាត់តម្លៃទៅក្រុមហ៊ុន",
    _CATEGORY: {
        CODE: "កូដក្រុម",
        NAME: "ឈ្មោះក្រុម",
        DESCRIPTION: "ការពិពណ៌នា"
    },
    ASSIGN_HOTEL_TO_CATEGORY: "ចាត់ក្រុមហ៊ុនទៅសណ្ឋាគារ",
    CHAIN_REGIS_INFO: "ព័ត៌មានចុះបញ្ជីខ្សែសង្វាក់",
    CONFIRM_DELETE_RATE_CATEGORY: "ការបញ្ជាក់ដើម្បីលុបប្រភេទតម្លៃ",
    RATE_CATEGORY_ALREADY_EXIST: "ប្រភេទតម្លៃមានរួចហើយ",
    RATE_PLAN_DOES_NOT_EXIST: "គម្រោងតម្លៃមិនមាន",
    CANCEL_REASON: "ហេតុផលសម្រាប់ការលុបចោល",
    RATE_PMS: "តម្លៃលក់ PMS",
    ALL_PLAN: "គម្រោងតម្លៃទាំងអស់",
    ALL_RATE_CATEGORY: "ប្រភេទតម្លៃទាំងអស់",
    TO_PAGE: "បញ្ជីចាប់ពី 1 ដល់ {count}",
    ASSIGN_ROOM_TYPE: "ចាត់បន្ទប់",
    CONFIG_RATE_OTA: "ការកំណត់តម្លៃ OTA",
    CONFIG_RATE_PMS: "ការកំណត់តម្លៃ PMS",
    UPDATE_RATE_PMS: "បច្ចុប្បន្នភាពតម្លៃ",
    VIEW: "មើល",
    CONFIRM_DELETE_SALE_PACKAGE_DATE_RANGE_PMS: "តម្លៃសម្រាប់រយៈពេលដែលបានជ្រើសនឹងត្រូវបានលុបនៅក្នុងប្រភេទបន្ទប់និងគម្រោងការលក់ផ្សេងៗ។ <br>តើអ្នកប្រាកដជាចង់លុបតម្លៃដែលបានដាក់វគ្គនេះទេ?",
    WAITING_UPDATE: "ទិន្នន័យត្រូវបានកត់ត្រា ហើយកំពុងបន្តដំណើរការ",
    STATUS_ROOM_TYPE_ON_OTA: "ស្ថានភាពការភ្ជាប់នៅលើ OTA",
    BOOKING_LIST_GROUP: "កក់ក្រុម",
    _GROUP_STATUS: {
        HOLD: "រក្សាទុក",
        TENTATIVE: "អាស្រ័យ",
        CONFIRMED: "បានបញ្ជាក់",
        CANCELED: "បានលុបចោល",
        CHECKED_IN: "ចុះបញ្ជី",
        CHECKED_OUT: "ចេញ",
        CLOSE: "បានបិទ",
        NO_SHOW: "មិនបង្ហាញ"
    },
    _BOOKING_GROUP: {
        BOOKING_GROUP_NAME: "ឈ្មោះកក់ក្រុម",
        BOOKING_GROUP_CODE: "កូដកក់ក្រុម",
        GROUP_PROFILE_NAME: "ឈ្មោះប្រវត្តិពួកគ្រួសារក្រុម",
        GROUP_PROFILE_CODE: "កូដប្រវត្តិពួកគ្រួសារក្រុម",
        BOOKING_GROUP_START_DATE: "កាលបរិច្ឆេទចាប់ផ្តើម",
        BOOKING_GROUP_END_DATE: "កាលបរិច្ឆេទបញ្ចប់",
        BOOKING_GROUP_CREATE_DATE: "ពេលវេលាបង្កើត",
        STATUS: "ស្ថានភាពក្រុម",
    },
    ENTER_TEXT: "បញ្ចូល {text}",
    LIST_PROFILE_GROUP: "បញ្ជីកំណត់ត្រាក្រុម",
    PROFILE_GROUP: "ប្រវត្តិពួកគ្រួសារក្រុម",
    SEARCH_BY_PROFILE_NAME_AND_CODE: "ស្វែងរកតាមឈ្មោះប្រវត្តិពួកគ្រួសារឬកូដប្រវត្តិពួកគ្រួសារ អ៊ីមែល អាសយដ្ឋាន",
    BOOKINGS_GROUP: "ចំនួនកក់ក្រុម",
    PROFILE_NUMBER: "{count} កំណត់ត្រា",
    _GROUP: {
        CONFIRM_DELETE: "បញ្ជាក់ការលុបកំណត់ត្រាក្រុម",
        DETAIL: "ព័ត៌មានលម្អិតនៃប្រវត្តិពួកគ្រួសារ",
        INFO: "ព័ត៌មានប្រវត្តិពួកគ្រួសារ",
        INFO_MANAGE: "ព័ត៌មានការគ្រប់គ្រង",
        ASSIGN: "ចាត់តំណែងការបំរើ",
        GROUP_PROFILE_NAME: "ឈ្មោះប្រវត្តិពួកគ្រួសារ",
        GROUP_PROFILE_NAME_OTHER: "ឈ្មោះផ្សេងទៀត",
        COMPANY_NAME: "ឈ្មោះក្រុមហ៊ុន / ភ្នាក់ងារ",
        DESCRIPTION: "ការពិពណ៌នា",
        CONTACT_NAME: "ឈ្មោះនៃនាយកដ្ឋាន",
        PHONE_NUMBER: "លេខទូរស័ព្ទ",
        PHONE_NUMBER_OTHER: "លេខទូរស័ព្ទផ្សេងទៀត",
        MANAGE_NAME: "ឈ្មោះមេធាវីមុខរបរ",
        DETAIL_BOOKING: "ព័ត៌មានលម្អិតការកក់ក្រុម",
        GROUP_INFO: "ព័ត៌មានក្រុម",
        LEADER: "ដឹកនាំ",
        PMS_CCODE: "កូដ PMS",
        CUS_OF_DAYS: "ថ្ងៃកំណត់",
        CUT_OF_DATE: "កាលបរិច្ឆេទកាត់បន្ថយ",
        PAYMENT_INFO: "ព័ត៌មានបង់ប្រាក់",
        TOTAL: "ចំនួនប្រាក់សរុប",
        UPDATE_PROFILE: "បច្ចុប្បន្នភាពប្រវត្តិពួកគ្រួសារ",
        PAYMENT_METHOD: "វិធីបង់ប្រាក់",
        PAYMENT_METHOD_BOOKING_RETAIL: "វិធីបង់ប្រាក់បុគ្គល",
        BOOKING_GROUP_INFO: "ព័ត៌មានការកក់ក្រុម",
        LEADER_NOT_PAY: "មេក្រុមមិនបង់ប្រាក់",
        LEADER_PAY_ONE_PART: "មេក្រុមបង់ប្រាក់បន្តិច",
        LEADER_PAYS_ALL: "មេក្រុមបង់ប្រាក់សរុប",
        CHOOSE_PROFILE: "ជ្រើសប្រវត្តិពួកគ្រួសារជាប់",
        TITLE: "ចំណងជើង"
    },
    ROOM_OF_LEADER: "បន្ទប់មេក្រុម",
    NUMBER_OF_BOOKING: "ចំនួនការកក់",
    SUB_BOOKING_CODE: "កូដកក់រង",
    UPDATE_INFO_BOOKING_GROUP: "បច្ចុប្បន្នភាពព័ត៌មានកក់ក្រុម",
    ALLOW_OVERWRITING_INFOMATION_DOWN: "អនុញ្ញាតឲ្យប្តូរព័ត៌មាន",
    FILTER: "តម្រង",
    GROUP_PROFILE: "ប្រវត្តិពួកគ្រួសារក្រុម",
    BOOKING_GROUP_PROFILE: "ប្រវត្តិពួកគ្រួសារកក់ក្រុម",
    ASSIGN_HOTEL: "ចាត់បន្ទប់សណ្ឋាគារ",
    ASSIGN_ROOM_TO_CATEGORY: "ចាត់បន្ទប់ទៅប្រភេទ",
    UPDATE_ROOM_RATE_PMS: "កំណត់តម្លៃ PMS",
    UPDATE_ROOM_RATE_OTA: "កំណត់តម្លៃ OTA",
    BOOKING_UNMAP: "មិនភ្ជាប់ការកក់",
    CONFIRM_DELETE_ROOM_CATEGORY: "ការបញ្ជាក់ដើម្បីលុបប្រភេទបន្ទប់",
    CHAIN_ROOM_CATEGORY_ALREADY_EXIST: "ប្រភេទបន្ទប់ខ្សែសង្វាក់មានរួចហើយ",
    ROOM_CATEGORY_ALREADY_EXIST: "ប្រភេទបន្ទប់មានរួចហើយ",
    ASSIGN_OTA: "ការចាត់តំណែង OTA",
    NOTE_ASIGN_OTA: "ចំណាំ: ក channel ដែលការលក់នឹងត្រូវបានចាត់តំណែងដោយស្វ័យប្រវត្តិសម្រាប់ប្រភេទបន្ទប់ដែលបានជ្រើស ហើយត្រូវបានសម្របសម្រួលទៅសណ្ឋាគារដែលបានជាវក channel ដែលនេះ ប្រសិនបើអ្នកចុចរក្សាទុក",
    ACTION_TIME: "ពេលវេលាបច្ចុប្បន្នភាព",
    PROCESS_TIME: "ពេលវេលាកំណត់ប្រតិបត្ដិការ",
    IGNORE: "អធិប្បាយ",
    RESEND: "បញ្ជូនត្រឡប់",
    LIST_ACTION_PROCESS: "សកម្មភាពមិនបញ្ចប់",
    STATUS_PROCESSING: "កំពុងដំណើរការ",
    STATUS_FAILED: "បរាជ័យ",
    STATUS_DONE: "បានបញ្ចប់",
    UPDATE_RATE: "បច្ចុប្បន្នភាពតម្លៃ",
    UPDATE_RATE_SPECIAL: "អាប់ដេតតម្លៃប្រចាំថ្ងៃ",
    UPDATE_EXTRA_RATE: "អាប់ដេតតម្លៃបន្ថែម",
    UPDATE_EXTRA_SPECIAL_RATE: "អាប់ដេតតម្លៃបន្ថែមប្រចាំថ្ងៃ",
    UPDATE_AVAIL: "អាប់ដេតភាពអាចប្រើប្រាស់",
    UPDATE_RESTRICTION: "អាប់ដេតការកំណត់",
    PROCESS_CAP: "0 ប្រតិបត្ដិការទាំងអស់ | 1 ប្រតិបត្ដិការទាំងអស់ | {count} ប្រតិបត្ដិការទាំងអស់",
    CONFIRM_IGNORE: "ប្រតិបត្ដិការបរាជ័យនឹងមិនអាប់ដេតឡើងវិញទេ។ តើអ្នកប្រាកដជាចង់ជ្រើសយល់ព្រមឬ?",
    HOTEL_BOOKING_UNMAP_REPOST: "បញ្ចូនការកក់ម្ដងទៀត",
    UPDATE_RESTRICTION_MINSTAY: "អាប់ដេតការពិចារណាពេលចាប់ផ្តើម",
    UPDATE_RESTRICTION_MAXSTAY: "អាប់ដេតការពិចារណាពេលបញ្ចប់",
    UPDATE_RESTRICTION_MINSTAYARRIVAL: "អាប់ដេតពេលចាប់ផ្តើមការមកដល់",
    UPDATE_RESTRICTION_MAXSTAYARRIVAL: "អាប់ដេតពេលបញ្ចប់ការមកដល់",
    UPDATE_RESTRICTION_MINBOOKINGWINDOW: "អាប់ដេតប្រវែងពេលសមរម្យសម្រាប់ការកក់",
    UPDATE_RESTRICTION_MAXBOOKINGWINDOW: "អាប់ដេតប្រវែងពេលសុវត្ថិភាពសម្រាប់ការកក់",
    UPDATE_RESTRICTION_EXACTSTAY: "អាប់ដេតស្ថានភាពគ្រប់គ្រងការអាចចុះជាតិនៅបាន",
    UPDATE_RESTRICTION_EXACTSTAYARRIVAL: "អាប់ដេតស្ថានភាពបញ្ចប់ការអាចចុះក្នុងថ្ងៃកំណត់",
    UPDATE_RESTRICTION_CLOSEDONARRIVAL: "អាប់ដេតការអនុញ្ញាតឱ្យត្រូវការចូលក្រុមហ៊ុន",
    UPDATE_RESTRICTION_CLOSEDONDEPARTURE: "អាប់ដេតការអនុញ្ញាតឱ្យត្រូវការចូលក្រុមហ៊ុន",
    UPDATE_RESTRICTION_CLOSED: "បញ្ចប់ការលក់",
    DELETE_PRICE_SPECIAL: "លុតតម្លៃប្រចាំថ្ងៃ",
    DELETE_EXTRA_RATE: "លុតសំណើបន្ថែម",
    DELETE_EXTRA_SPECIAL_RATE: "លុតសំណើតម្លៃបន្ថែមប្រចាំថ្ងៃ",
    HOTEL_DASHBOARD_IGNORE_TASK: "មិនប្រើប្រាស់",
    HOTEL_DASHBOARD_REUPDATE_TASK: "បង្ហាញជាលើកទៀត",
    CHAIN_ROOM_UPDATE_QUANTITY: "អាប់ដេតចំនួនបន្ទប់",
    ROOM_UPDATE_QUANTITY: "អាប់ដេតចំនួនបន្ទប់",
    CHAIN_ROOM_CATEGORY: "ប្រភេទបន្ទប់ - ចេន",
    HOTEL_ROOM_CATEGORY: "ប្រភេទបន្ទប់",
    HOTEL_RATE_CATEGORY: "ប្រភេទតម្លៃបន្ទប់",
    CHAIN_RATE_CATEGORY: "ប្រភេទតម្លៃ - ចេន",
    ERROR_CAUSE: "មូលហេតុនៃកំហុស",
    INVENTORY_NOT_SYNC: "បន្ទប់ទំនេរមិនត្រូវបានសម្រួល",
    UNKNOWN_ERROR: "កំហុសមិនអាចកំណត់បាន",
    BY_RATE: "តាមតម្លៃថេរ",
    BY_FORMULA: "តាមសមាសធាតុ",
    CONFIG_TYPE: "ប្រភេទកំណត់",
    FOMULA_FROM_TO: "សមាសធាតុសម្រាប់គណនាតម្លៃពីថ្ងៃច័ន្ទដល់ថ្ងៃអាទិត្យ",
    CONFIRM_DEACTIVE_DYNAMIC_RESTRICTION: "ការពិនិត្យការរក្សាទុកការបដិសេធការបង្កើតការកំណត់រូបភាព",
    EDIT_DYNAMIC_RESTRICTION: "បង្ហាញអំពីការរចនាភាពបត់បែន",
    ADD_NEW_DYNAMIC_RESTRICTION: "បន្ថែមការកំណត់ការបង្ហោះថ្មី",
    DYNAMIC_RESTRICTION: "កំណត់ការបង្ហោះបត់បែន",
    CONFIRM_DELETE_DYNAMIC_RESTRICTION: "ការពិនិត្យការលុបតម្លៃបាត្តមការបង្ហោះ",
    DYNAMIC_RESTRICTION_NAME: "ឈ្មោះការកំណត់បន្ថែម",
    DYNAMIC_RESTRICTION_DESCRIPTION: "ការពិពណ៌នាផលិតផល",
    RESTRICTION_CALCULATION_FORMULA: "ការបង្ហាញវេទិកានៃការផ្គូរផ្គង",
    NO_CHANGE: "មិនមានការផ្លាស់ប្ដូរ",
    ADULT_CAP: "0 ពេញវ័យ | 1 ពេញវ័យ | {count} ពេញវ័យ",
    CHILD_CAP: "0 កុមារ | 1 កុមារ | {count} កុមារ",
    BABY_CAP: "0 បត់ | 1 បត់ | {count} បត់",
    USE_MODEL: "កំណត់ជា​ម៉ូដែល",
    ADD_RANGE: "បន្ថែមទំហំ",
    MODEL_DESCRIPTION_RESTRICTION: "តម្លៃ/សមាសធាតុតម្លៃ/ជួរផលិតផល/កំណត់នឹងត្រូវបានបញ្ជូនទៅប្រភេទបន្ទប់ និងកញ្ចប់លក់ខាងក្រោមប្រសិនបើបានជ្រើសរើស។",
    MODEL_DESCRIPTION_PRICE: "តម្លៃ/សមាសធាតុតម្លៃ/ជួរផលិតផល/កំណត់នឹងត្រូវបានបញ្ជូនទៅប្រភេទបន្ទប់ និងកញ្ចប់លក់ខាងក្រោមប្រសិនបើបានជ្រើសរើស។",
    NOTE_ROOM_RATE: "B: តម្លៃបន្ទប់សម្រាប់ប្រភេទបន្ទប់ដែលពាក់ព័ន្ធ។ តម្លៃបន្ទប់ត្រូវបានបង្ហាញ និងអាប់ដេតនៅក្នុងផ្ទាំងលក់បន្ទប់។ នៅពេលបង្កើតតម្លៃបន្ទប់ថ្មី វានឹងយកតម្លៃបន្ទប់ដោយដើមពីតម្លៃបន្ទប់ក្នុងប្រភេទបន្ទប់។",
    DYNAMIC_SALE: "ការលក់បន្ទប់បត់បែន",
    NOTE_MODEL_PRICE: "អ្នកប្រើប្រាស់អាចកែប្រែប្រភេទបន្ទប់ដែលត្រូវបានចម្លងពីគំរូ",
    ACCOUNT_UPDATE: "គណនីដែលបានអាប់ដេត",
    ITEMS_PER_PAGE: "ជួរទំព័រដោយមួយទំព័រ",
    UPDATE_RATE_SPECIAL_FROM_CHAIN: "អាប់ដេតតម្លៃពីចេន",
    EQUIVALENT_TO_ROOM_NIGHT: "សម្រង់តម្លៃជាមួយបន្ទប់រយៈពេលយប់",
    CREATED_BY_ACCOUNT: "បង្កើតដោយគណនី",
    IS_LEGACY_ROOM_CLASS: "មិនអាចលុបបានព្រោះប្រភេទបន្ទប់ និងផែនការតម្លៃត្រូវបានផ្អែកលើគេ",
    ASSIGN_RATE_CATEGORY: "ចាត់តំណែងប្រភេទតម្លៃ",
    ASSIGN_ROOM_CATEGORY: "ចាត់តំណែងប្រភេទបន្ទប់",
    CUSTOMER_PHONE: "លេខទូរស័ព្ទរបស់អតិថិជន",
    CUSTOMER_MAIL: "អ៊ីមែលបញ្ជាទិញរបស់អតិថិជន",
    DU_DESCRIPTION_OF_ROOM_TYPE: "ការកក់បន្ទប់ប្រភេទថ្ងៃប្រើ (ការកក់ដែលថ្ងៃមកដល់ = ថ្ងៃចាកចេញ)",
    DU_DESCRIPTION_OF_HOTEL: "ការកក់បន្ទប់ថ្ងៃប្រើសណ្ឋាគារ (ការកក់ដែលថ្ងៃមកដល់ = ថ្ងៃចាកចេញ)",
    OVERVIEW: "មើលទូទៅ",
    INDEX_P: "អត្រាការចូលរួម (P)",
    INDEX_P_ROOM: "សមត្ថភាពតាមប្រភេទបន្ទប់",
    INDEX_P_HOTEL: "អត្រាការចូលរួមតាមសណ្ឋាគារ",
    INDEX_A: "ចំនួនបន្ទប់ដែលបានលក់ (រួមបញ្ចូលការកក់ថ្ងៃប្រើ) (A)",
    INDEX_B: "ចំនួនបន្ទប់ដែលអាចលក់បាន (B)",
    INDEX_DU: "ចំនួនបន្ទប់ដែលបានលក់ (ថ្ងៃប្រើ) (DU)",
    INDEX_INV: "បន្ទប់ដែលអាចប្រើបាន",
    BY_ROOM: "តាមប្រភេទបន្ទប់",
    BY_HOTEL: "តាមសណ្ឋាគារ",
    DYNAMIC_NAME_HAS_EXIST: "ឈ្មោះបត់បែនមានរួចហើយ",
    ROOM_SALE_WITH_ROOM_TYPE: "មើលតាមប្រភេទបន្ទប់",
    ROOM_SALE_WITH_OTA: "មើលតាមបណ្តាញ OTA",
    ROOM_FUND: "ការផ្ដល់ចំនួនបន្ទប់",
    NODATA_2: "សូមបញ្ចូលចំនួនចន្លោះជាង 2 តួអក្សរ",
    CHOOSE_MARKET_SEGMENT: "ជ្រើសភាគទីផ្សារ",
    MARKET_SEGMENT: "ភាគទីផ្សារ",
    TRAVEL_AGENT_SPEC: "ភ្នាក់ងារដែលពិសេស",
    SEGMENT_SPEC: "ភាគទីផ្សារពិសេស",
    SHOW_CARD_PAYMENT_INFO: "បង្ហាញព័ត៌មានកាតបង់ប្រាក់",
    ENTER_TO_SEARCH_MORE: "បញ្ចូលដើម្បីស្វែងរកបន្ថែម",
    EMAIL_ACCESSTOKEN: "អ៊ីមែលដើម្បីទទួលកូដចូលប្រើព័ត៌មានកាត",
    TEXT_NOTIFY_EXPIRED_GROUP_OTA: "មុខងារ {channel} មិនមានសកម្មនៅលើ {date}",
    TEXT_NOTIFY_WILL_EXPIRE_GROUP_OTA: "មុខងារ {channel} នឹងផុតកំណត់នៅលើ {date}",
    PLEASE_RENEW: ". សូមទំនាក់ទំនងតាមអ៊ីមែល <u>hotro@ezcloud.vn</u> ឬលេខទូរស័ព្ទ <u>1900 9013</u> សម្រាប់ការជួយជូនបន្ទាន់។",
    NOTIFY_OFF_MODULE: "មុខងារនៃការលក់បន្ទប់តាមប្រភេទបន្ទប់នឹងបញ្ឈប់ការដំណើរការនៅក្នុងពេលខាងមុខ។ សូមផ្ញើមតិយោបល់ទាំងអស់ទៅកាន់ប្រអប់អ៊ីមែល <b>hotro@ezcloud.vn</b>",
    NEW_MESSAGE: "សារ​ថ្មី",
    PAXONE: "តម្លៃសម្រាប់ 1 នាក់",
    PAXTOW: "តម្លៃសម្រាប់ 2 នាក់",
    PAXEXTRA: "តម្លៃបន្ថែមសម្រាប់នាក់បន្ថែម",
    MAP_PRODUCT: "ចាត់តំណែងផលិតផល",
    UPDATE_RESTRICTION_BY_RATE_PLAN: "អាប់ដេតការកំណត់",
    CREATE_RESTRICTION: "បង្កើតការកំណត់",
    DELETE_ROOM_RATE: "លុបតម្លៃបន្ទប់",
    UPDATE_SPECIAL_RATE: "អាប់ដេតតម្លៃប្រចាំថ្ងៃ",
    HERE: "ទីនេះ",
    ACCESS_TOKEN_EMAIL_IS_NOT_EMPTY: "សូមបន្ថែមអ៊ីមែលដើម្បីទទួលព័ត៌មានកាត",
    ADD_PROGRAM: "បន្ថែមកម្មវិធី",
    TYPE_APPLY_PROMOTION: "ប្រព័ន្ធបញ្ចុះតម្លៃ",
    PROMOTION_CHARCE_COUPON: "ការផ្តល់ជូន បញ្ចុះតម្លៃកូដ",
    PROMOTION_CHARGE: "ការផ្តល់ជូនមានសកម្ម",
    COUPON_APPLY: "កូដបញ្ចុះតម្លៃមានសកម្ម",
    EZ_PROMOTION_NOT_SUPPORTED_PROMOTION_TYPE: "ប្រព័ន្ធ ezPromotion មិនគាំទ្រប្រភេទបញ្ចុះតម្លៃនេះទេ",
    ERROR_EZ_PROMOTION: "មិនអាចភ្ជាប់ទៅប្រព័ន្ធ ezPromoion បានទេ",
    CANCEL_PROMOTION_ERROR: "បញ្ហាការលុបបញ្ចុះតម្លៃ",
    CONFIRM_PROMOTION_ERROR: "បញ្ហាការបញ្ជាក់បញ្ចុះតម្លៃ",
    RELOAD: "បន្ទាន់សម័យ",
    WARNING: "ការព្រមាន",
    TXT_WARNING_OVER: "ដើម្បីធានាការប្រើប្រាស់ប្រព័ន្ធបានសម្រួល គួរតែបំពានច្រើនជាង 50 បន្ទាត់ក្នុងមួយប្រតិបត្តិការណ៍។ សូមអរគុណ!",
    CONFIRM_DELETE_DATA_ENTERED: "អ្នកបានធ្វើការផ្លាស់ប្តូរលើផលិតផលមេ។ តើអ្នកចង់លុបទិន្នន័យតម្លៃដែលអ្នកបានបញ្ចូលទេ?",
    ROOM_STATUS_1: "បានកក់",
    ROOM_STATUS_2: "បានចូលនៅ",
    ROOM_STATUS_3: "បានចេញ",
    ROOM_STATUS_4: "មិនមក",
    ROOM_STATUS_5: "បានបោះបង់",
    BOOKING_HISTORY: "ប្រវត្តិការកក់",
    BOOKING_STATUS_OTA: "ស្ថានភាពការកក់ពី OTA",
    BOOKING_OTA_STATUS_0: "ការកក់ថ្មី",
    BOOKING_OTA_STATUS_1: "ការកក់បានកែប្រែ",
    BOOKING_OTA_STATUS_2: "ការកក់បានបោះបង់",
    BOOKING_OTA_STATUS_3: "ការកក់បានបញ្ជូន",
    COPY_RATE: "ចម្លងផែនការតម្លៃ",
    SALE_PACKAGE_CODE_NEW: "កូដផែនការតម្លៃថ្មី",
    SELLING_PACKAGE_NEW: "ឈ្មោះផែនការតម្លៃថ្មី",
    DUPLICATE: "ចម្លង",
    SALE_PACKAGE_CODE_OLD: "កូដផែនការតម្លៃចាស់",
    FAST_UPDATE: "បន្ទាន់សម័យលឿន",
    AUTO_CANCEL_PAYMENT_FAIL: "អនុញ្ញាតឲ្យបោះបង់ដោយស្វ័យប្រវត្តិប្រសិនបើការទូទាត់បោះបង់ការកក់ជួបបញ្ហា, បន្ទាប់ពី",
    EZPAYREF: "កូដយោង",
    TOOLTIP_AUTO_CANCEL_PAYMENT_FAIL: "ប្រសិនបើមុខងារនេះមានសកម្ម, បន្ទាប់ពីការកក់នៅក្នុងស្ថានភាពការទូទាត់បោះបង់រយៈពេលម៉ោងដែលកំណត់, ezCrs នឹងបោះបង់ការកក់ទាំងនោះដោយស្វ័យប្រវត្តិ។ ពេលវេលាដំណើរការដែលកំណត់នៅក្នុងការកំណត់ដំបូងគឺ 30 នាទី។ ប្រសិនបើទុកវាដោយទទេ, តម្លៃដែលត្រូវបានអនុវត្តគឺ 0 នាទី។<br>កំណត់: ពេលវេលាបោះបង់អាចយឺតជាសាកល្បងបន្តិចផ្អែកលើការតភ្ជាប់។",
    TOOLTIP_AUTO_CANCEL: "សម្រាប់ការកក់ដែលតម្រូវឲ្យមានការទូទាត់មុនកាលបរិច្ឆេទជាក់លាក់, នៅពេលដែលទទួលបានការទូទាត់/ដំណាក់កាលដោយអតិថិជននៅក្នុងរបាយការណ៍ ezCrs ដែលមិនអាចចុះបញ្ជីបានដូចជា​ទឹកប្រាក់ឬបញ្ជូនធនាគារ, សណ្ឋាគារត្រូវការបញ្ជាក់ការកក់នោះ។ ប្រសិនបើមុខងារនេះមានសកម្ម, ezCrs នឹងបោះបង់ការកក់ដែលមិនបានបញ្ជាក់សម្រាប់ថ្ងៃនោះដោយស្វ័យប្រវត្តិ។ កាលបរិច្ឆេទបោះបង់ស្វ័យប្រវត្តិនៃការកក់នឹងត្រូវបានកំណត់ក្នុងគោលការណ៍បង់ប្រាក់ និងអនុវត្តតាមគោលការណ៍តម្លៃមួយៗ។",
    CONFIG_BY: "កំណត់ដោយ",
    LIST_FORMULAR: "បញ្ជីសមាសធាតុតម្លៃ",
    ROOM_TYPE_BASE: "ប្រភេទបន្ទប់មូលដ្ឋាន",
    SALE_PACKAGE_BASE: "គោលនយោបាយតម្លៃមូលដ្ឋាន",
    SALE_CHANNEL_BASE: "បណ្តាញលក់មូលដ្ឋាន",
    ROOM_TYPE_DERIVED: "ប្រភេទបន្ទប់ចេញពី",
    SALE_PACKAGE_DERIVED: "ផែនការតម្លៃចេញពី",
    SALE_CHANNEL_DERIVED: "បណ្តាញលក់ចេញពី",
    HOTEL_LOG_derivationType: "ប្រភេទការទំនាក់ទំនង",
    HOTEL_LOG_formulaType: "ប្រភេទ",
    HOTEL_LOG_master: "មេ",
    HOTEL_LOG_children: "កូន",
    HOTEL_LOG_formula: "សមាសធាតុតម្លៃ",
    HOTEL_ROOM_TYPE_SPECIAL: "អាប់ដេតតម្លៃបន្ទប់",
    UPDATE_ROOM_TYPE: "អាប់ដេតប្រភេទបន្ទប់",
    TOOLTIP_BASE_ROOM_TYPE: "ផលិតផលនៃប្រភេទបន្ទប់នៅក្នុងប្រភេទអនុវត្តដែលចែករំលែកផែនការតម្លៃ និងបណ្តាញលក់ដូចជាផលិតផលប្រភេទបន្ទប់ {value} នឹងត្រូវបានចេញពីយោងតាមសមាសធាតុតម្លៃ។",
    TOOLTIP_BASE_RATE_PLAN: "ផលិតផលនៃផែនការតម្លៃនៅក្នុងផែនការតម្លៃចេញពីដែលចែករំលែកប្រភេទបន្ទប់ និងបណ្តាញលក់ដូចជាផលិតផលផែនការតម្លៃ {value} នឹងត្រូវបានចេញពីយោងតាមសមាសធាតុតម្លៃ។",
    TOOLTIP_BASE_OTA: "ផលិតផលនៃបណ្តាញលក់នៅក្នុងបណ្តាញលក់ចេញពីដែលចែករំលែកផែនការតម្លៃ និងប្រភេទបន្ទប់ដូចជាផលិតផលបណ្តាញលក់ {value} នឹងត្រូវបានចេញពីយោងតាមសមាសធាតុតម្លៃ។",
    VALUE_AND_PERSON_IS_REQUIRED: "តម្លៃ និងចំនួនភ្ញៀវមិនអាចទទេបានទេ",
    PLS_CHOOSE_ONE_SELECT_BOX: "សូមជ្រើសប្រអប់ 'លុប' អោយបានយ៉ាងហោចណាស់មួយដើម្បីអាប់ដេត",
    NOTE_DERIVED: "សមាសធាតុតម្លៃថ្មីដែលចេញពីនឹងបំ覆សមាសធាតុតម្លៃពីមុនប្រសិនបើវាផ្គូផ្គងនៅក្នុងផលិតផលចេញពីឬមូលដ្ឋាន",
    ROOM_QUANTITY_PARENT_NOT_SAME: "ចំនួនប្រភេទបន្ទប់នៅក្នុងឪពុក និងកូនត្រូវតែស្មើគ្នាដើម្បីអាចបង្កើតបាន",
    IS_REDIRECTING: "កំពុងបញ្ជូនទៅ",
    MAP: "ផែនទី",
    SYNC_FROM_PRICELABS: "តំណត់ទិន្នន័យពី Pricelabs",
    HOTEL_EXTRA_SPECIAL_RATE_DELETE: "លុបតម្លៃបន្ថែមប្រចាំថ្ងៃ",
    HOTEL_EXTRA_SPECIAL_RATE_UPDATE: "អាប់ដេតតម្លៃបន្ថែមប្រចាំថ្ងៃ",
    SYNC_DATA_TO_OTA: "តំណត់ទិន្នន័យទៅ OTA",
    MODULE_EZ_PAYMENT_NOT_ACTIVE: "ម៉ូឌុល ezPayment មិនមានសកម្មភាព",
    NOT_DELETE_ROOM_TYPE_CODE_HAS_SYNCED_TO_OTA: "មិនអាចលុបប្រភេទបន្ទប់ដែលតភ្ជាប់ជាមួយ OTA បានទេ",
    ENABLE_SYNC_NOT_UPDATED: `ប្រភេទបន្ទប់នេះកំពុងតភ្ជាប់ជាមួយ OTA។ សូមអនុវត្តជំហានខាងក្រោមដើម្បីអាចប្ដូរចំនួនភ្ញៀវក្នុងប្រភេទបន្ទប់បានដោយការផ្លាស់ប្តូរអាចមានផលប៉ះពាល់ទៅការតភ្ជាប់។<br><br>\
        <span class=\"font-weight-bold\">ជំហាន 1:</span> ចូលទៅកាន់ការគ្រប់គ្រងការតភ្ជាប់ => ជ្រើស ezCms vela+ => ជ្រើសផ្ទាំងការតភ្ជាប់ OTA និងដកប្រភេទបន្ទប់ដែលអ្នកចង់ប្ដូរនៅពីរៀបរាប់ប្រភេទបន្ទប់ទាំងអស់ដែលតភ្ជាប់ទៅ OTA។<br>\
        <span class=\"font-weight-bold\">ជំហាន 2:</span> ជ្រើសផ្ទាំងបណ្តាញ និងបន្តដកប្រភេទបន្ទប់ដែលអ្នកចង់ប្ដូរ។<br>\
        <span class=\"font-weight-bold\">ជំហាន 3:</span> ប្ដូរចំនួនភ្ញៀវ និងតភ្ជាប់បណ្តាញ OTA ម្ដងទៀត។<br><br>\
        <span class=\"font-weight-bold\">កំណត់សំគាល់:</span> សូមអនុវត្តជំហានក្នុងលំដាប់ត្រឹមត្រូវដើម្បីជៀសវាងកំហុសក្នុងការតភ្ជាប់ដែលអាចធ្វើឲ្យមានការបាត់បង់ចំណូល។<br>\
        សូមរកព័ត៌មានលម្អិតនៅ <a href=\"https://help.ezcms.vn/tich-hop-he-thong-ezcms-vela/\" target=\"_blank\"><u>ទីនេះ</u></a>`,
    ENABLE_SYNC_NOT_CREATED: `កូដប្រភេទបន្ទប់មានស្រាប់នៅកម្រិតសណ្ឋាគារ, មិនអាចប្ដូរបានទេដោយសារតែការតភ្ជាប់ជាមួយ OTA។ \
        សូមប្ដូរគូដប្រភេទបន្ទប់ឬកំណត់ចំនួនភ្ញៀវនៅក្នុងខ្សែឬនៅសណ្ឋាគារសម្រាប់ប្រភេទបន្ទប់នេះ។`,
    UNDERSELL_LIMIT_TITLE: "កំណត់សীমតាមបញ្ជីសម្រាប់បណ្ដាញដើម្បីគ្រប់គ្រងការលក់បន្ទប់។ ពេលចំនួនបន្ទប់ដែលមានស្រាប់នៅលើបណ្ដាញនោះសំរាប់ជំនាន់នេះឬតិចជាងស័ក្តិគន្លងនេះ, ការបិទលក់នឹងត្រូវបានចាប់ផ្តើម។",
    SELL_LIMIT_TITLE: "កំណត់ស limite តម្លៃបន្ទប់សម្រាប់ក្រុមបណ្ដាញដើម្បីគ្រប់គ្រងការលក់បន្ទប់ និងប្រើប្រាស់ប្រាក់ចំណេញ។",
    ROOM_FOR_SALE: "បន្ទប់សម្រាប់លក់",
    NO_CHANNEL_GROUP: "សូមជ្រើសក្រុមបណ្ដាញដើម្បីអាប់ដេត",
    DATA_BLANK: "ទិន្នន័យដែលបញ្ចូលមិនអាចទទេបានទេ",
    ROOM_QUANTITY_PARENT_NOT_SAME: "ចំនួនប្រភេទបន្ទប់នៅក្នុងឪពុក និងកូនត្រូវតែស្មើគ្នាដើម្បីអាចបង្កើតបាន",
    VALUE_MUST_BE_LESS_THAN_24H: "តម្លៃត្រូវតែតិចជាង 24 ម៉ោង",
    N_O: "លេខលំដាប់",
    MASTER_ROOM_TYPE: "ប្រភេទបន្ទប់មេ",
    MASTER_RATE_PLAN: "ផែនការតម្លៃមេ",
    MASTER_CHANNEL: "បណ្តាញមេ",
    DERIVED_ROOM_TYPE: "ប្រភេទបន្ទប់ចេញពី",
    DERIVED_RATE_PLAN: "ផែនការតម្លៃចេញពី",
    DERIVED_CHANNEL: "បណ្តាញលក់ចេញពី",
    MASTER_PRODUCT: "ផលិតផលមេ",
    FORMULAR_LIST: "បញ្ជីសមាសធាតុតម្លៃ",
    DERIVED_PRODUCT: "ផលិតផលចេញពី",
    PRICE_FORMULA: "សមាសធាតុតម្លៃ",
    SELECT_TYPE: "ជ្រើសប្រភេទ",
    SHOW_MORE_FOMULA: "បង្ហាញសមាសធាតុបន្ថែម",
    SELECT_TYPE_RESTRICTION: "ជ្រើសប្រភេទកំណត់ទាំងអស់",
    SETUP_FORMULAR_LIST: "កំណត់បញ្ជីសមាសធាតុ",
    APPLY_DATE: "កាលបរិច្ឆេទអនុវត្ត",
    LIST_FROM: "បញ្ជីពី",
    TO: "ទៅ",
    IN: "ក្នុង",
    NO_TYPE_SELECTED: "សូមជ្រើសអត្រាឬប្រភេទកំណត់ទាំងអស់ដើម្បីបង្កើតសមាសធាតុ",
    ROOM_TYPE_NOT_MATCH: "មិនមានសមាសធាតុដែលអាចបង្កើតបានទេ ពីព្រោះផែនការតម្លៃឬបណ្តាញមិនត្រូវគ្នារវាងផលិតផលមេ និងផលិតផលចេញពី។ សូមពិនិត្យមើលឬបង្កើតផលិតផលដែលត្រូវនឹងគ្នា។",
    SALE_PACKAGE_NOT_MATCH: "មិនមានសមាសធាតុដែលអាចបង្កើតបានទេ ពីព្រោះប្រភេទបន្ទប់ឬបណ្តាញមិនត្រូវគ្នារវាងផលិតផលមេ និងផលិតផលចេញពី។ សូមពិនិត្យមើលឬបង្កើតផលិតផលដែលត្រូវនឹងគ្នា។",
    SALE_CHANNEL_NOT_MATCH: "មិនមានសមាសធាតុដែលអាចបង្កើតបានទេ ពីព្រោះផែនការតម្លៃឬប្រភេទបន្ទប់មិនត្រូវគ្នារវាងផលិតផលមេ និងផលិតផលចេញពី។ សូមពិនិត្យមើលឬបង្កើតផលិតផលដែលត្រូវនឹងគ្នា។",
    CUSTOM_NOT_MATCH: "សមាសធាតុមិនត្រូវបានបង្កើតដោយសារតែផលិតផលមេ និងកូនមិនសមរម្យទាំងអស់ក្នុងការបញ្ជាក់ប្រភេទបន្ទប់, ផែនការតម្លៃឬបណ្តាញ។",
    CHANGE: "ប្ដូរ",
    CURRENT_FORMULA: "សមាសធាតុបច្ចុប្បន្ន",
    NEW_FORMULA: "សមាសធាតុដែលបានបង្កើត",
    MODIFIED_FORMULA: "សមាសធាតុដែលបានកែប្រែ",
    DELETED_FORMULA: "សមាសធាតុដែលបានលុប",
    DERIVED: "ចេញពី",
    LIST_FORMULAR_UPDATE: "សមាសធាតុដែលបានអាប់ដេត",
    BEFORE: "មុន",
    AFTER: "បន្ទាប់",
    ROOM_RATE_DERIVATIONS_NOT_FOUND: "មិនមានការចេញពីតម្លៃបន្ទប់ទេ",
    UPDATE_RESTRICTION_MINBOOKINGWINDOWBYHOUR: "អាប់ដេតប្រព័ន្ធបញ្ជាក់ម៉ោងចាប់ផ្តើមបញ្ជីការកក់",
    UPDATE_RESTRICTION_MAXBOOKINGWINDOWBYHOUR: "អាប់ដេតប្រព័ន្ធបញ្ជាក់ម៉ោងចាប់ផ្តើមបញ្ជីការកក់",
    UPDATE_RESTRICTION_SALEINVENTORY: "អាប់ដេតបន្ទប់សម្រាប់លក់",
    UPDATE_RESTRICTION_SELLLIMIT: "អាប់ដេតដែនកំណត់លក់",
    NUMBER_OF_DAYS: "ចំនួនថ្ងៃ",
    NUMBER_OF_HOURS: "ចំនួនម៉ោង",
    REMOVE_DAYLY_RATE: "លុបតម្លៃប្រចាំថ្ងៃ",
    ALLOW_CHECKIN: "អនុញ្ញាតឲ្យចុះឈ្មោះ",
    ALLOW_CHECKOUT: "អនុញ្ញាតឲ្យចេញ",
    QUICK_UPDATE: "អាប់ដេតប្រភេទ",
    BASE_PRICE_REQUIRED: "សូមអាប់ដេតតម្លៃប្រចាំសប្តាហ៍ជាមុន",
    CALENDAR_ROOM: "ទិដ្ឋភាពប្រតិទិន",
    DATA_BLANK: "ទិន្នន័យមិនអាចទទេបានទេ",
    WARNING_EMAIL: "អ៊ីមែល",
    SAFE_PRICE_RANGE: {
        PROTECTION_RATE: "អត្រារការពារ",
        PROTECTION_RATE_TOOLTIP: "អត្រារការពារជាប្រភេទតម្លៃដែលមិនអាចរក្សាទុកបាន ប្រសិនបើទិន្នន័យបញ្ចូលនៅក្នុងការលក់បន្ទប់តិចជាងតម្លៃអតិផរណាត្រូវបានកំណត់ឬខ្ពស់ជាងអត្រាខ្ពស់ដែលបានកំណត់",
        MINIMUM_RATE: "អត្រាប្រកាន់ខ្ពស់បំផុត",
        MAXIMUM_RATE: "អត្រាខ្ពស់បំផុត",
        MINIMUM_RATE_INVALID: "អត្រាប្រកាន់ខ្ពស់មិនអាចខ្ពស់ជាងអត្រាខ្ពស់បំផុត",
        MAXIMUM_RATE_INVALID: "អត្រាខ្ពស់បំផុតមិនអាចតិចជាងអត្រាប្រកាន់ខ្ពស់បំផុត",
        PROTECTION_RATE_INPUT_INVALID: "តម្លៃបញ្ចូលមិនអាចតិចជាង {priceMin} ឬខ្ពស់ជាង {priceMax}",
        MINIMUM_RATE_INPUT_INVALID: "តម្លៃបញ្ចូលមិនអាចតិចជាង {priceMin}",
        MAXIMUM_RATE_INPUT_INVALID: "តម្លៃបញ្ចូលមិនអាចខ្ពស់ជាង {priceMax}"
    },
    PRICE_OUT_OF_BOUND: "តម្លៃបញ្ចូលបានលើសពីអត្រារការពារ",
    ROOM_TYPE_ON_SABRE_DUPLICATE: "ប្រភេទបន្ទប់នៅលើបណ្តាញលក់មិនអាចបញ្ចូលបានពីរប្រភេទ",
    ROOM_PLAN_ON_SABRE_DUPLICATE: "ផែនការតម្លៃនៅលើបណ្តាញលក់មិនអាចបញ្ចូលបានពីរប្រភេទ",
    PRICE_UPDATE_OUT_OF_BOUND: "តម្លៃបច្ចុប្បន្នលើសពីអត្រារការពារ",
    INCLUDED_TAX: "ផ្តល់ចំណូលរំលស់",
    ACTIVATE: "ដំណើរការជាថ្មី",
    NO_RANK: "គ្មានជាប់ជម្រើស",
    ONE_STAR: "1 ផ្កាយ",
    TWO_STAR: "2 ផ្កាយ",
    THREE_STAR: "3 ផ្កាយ",
    FOUR_STAR: "4 ផ្កាយ",
    FIVE_STAR: "5 ផ្កាយ",
    EXAMPLE_INFO: `<p><i><u><span>ឧទាហរណ៍:</span></u></i></p>\
    <p>សណ្ឋាគារប្រើប្រាស់រូបិយវត្ថុ: <span>VND</span></p>\
    <p>បន្ទប់ Deluxe មានតម្លៃបានបញ្ជាក់: <span>900.000</span></p>\
    <p>អត្រា: <span>0.00005</span></p>\
    <p>ភាពខុសតម្លៃ: <span>0.5</span></p>\
    <p>ដូច្នេះតម្លៃបន្ទប់ Deluxe នៅលើបណ្ដាញ OTA បន្ទាប់ពីការតភ្ជាប់នឹងបង្ហាញជា:<span>(900.000 x 0.5) + 0.5 = 50 $</span></p>`,
    FREE_SALE_ALLOTMENT: "ការបំបែកលក់ដោយកំណត់ថ្ងៃចាប់ផ្តើម",
    ACTIVITY_LOG: "0 ប្រតិបត្តិការ | 1 ប្រតិបត្តិការ | {count} ប្រតិបត្តិការ",
    TIPS: "ចំណាំ",
    _CONFIGURATION: {
        MENU: "ម៉ឺនុយ",
        WIDGET: "វិចេត",
        THEME: "ប្រធានបទ",
        SCRIPT: "ស្គ្រីប",

        MENU_HEADER: "ក្បាលម៉ឺនុយ",
        MENU_FOOTER: "ខាងក្រោមម៉ឺនុយ",

        LOGO: "ឡូហ្គូ",
        HEADER: "ក្បាលទំព័រ",
        BE_CONTENT: "ខ្លឹមសារទីផ្សារ",
        FOOTER: "ផ្នែកខាងក្រោម",
        FOOTER_BOTTOM: "ផ្នែកខាងក្រោមក្រោម",
        FOOTER_RIGHT: "ផ្នែកខាងស្ដាំ",
        WIDGET_FOOTER_RIGHT: "វិចេត ផ្នែកខាងស្ដាំ",
        WIDGET_FOOTER_BOTTOM: "វិចេត ផ្នែកខាងក្រោម",

        WIDGET_SOCIAL_MEDIA_ICON: "វិចេត: អ៊ិកុន បណ្តាញសង្គម",
        WIDGET_HTML_TEXT: "វិចេត: ទ tek HTML",
        SCRIPT_WILL_ADD_BODY: "ស្គ្រីបនឹងត្រូវបោះពុម្ភនៅក្នុង <body>",
        SCRIPT_WILL_ADD_HEAD: "ស្គ្រីបនឹងត្រូវបោះពុម្ភនៅក្នុង <head>",
        TEMPLATE: "គំរូ",
        BODY: "រាងកាយ",
        BE_SUPPORT: `<p class="fs-14"><b>វិធីទី ១៖ ផ្សារភ្ជាប់ដោយប្រើសំណុំបែបបទដែលត្រៀមរួចរួម</b></p>
        <p>លក្ខណៈពិសេសនេះអនុញ្ញាតឱ្យអ្នកបញ្ចូលម៉ាស៊ីនបញ្ជីការកក់ជាមួយវេបសាយរបស់អ្នក ដោយចង្អុលបង្ហាញទម្រង់កក់ពីម៉ាស៊ីនបញ្ជីការកក់នៅលើវេបសាយរបស់អ្នក។</p>
        <img src="/script-BE.png">
        <br>
        <p><b>ជំហាន ១:</b> ចម្លងកូដ HTML ខាងក្រោម ហើយដាក់នៅទីតាំងដែលអ្នកចង់បង្ហាញទម្រង់កក់នៅលើគេហទំព័ររបស់អ្នក។</p>
        <div>
            <i>&lt;div class="booking-form"&gt;&lt;/div&gt;</i>
        </div>
        <div class="mt-3">
            <p><b>ជំហាន ២:</b> ចម្លងស្ដ្រីប៊ីតខាងក្រោម ហើយដាក់នៅក្នុងផ្នែកផ្ទុក (footer) របស់គេហទំព័រ (មុនធាតុបិទ body) ។</p>
            <p>១. ប្រសិនបើគេហទំព័ររបស់អ្នកមិនមាន jquery មុននោះទេ :</p>
            <i> &emsp;&lt;script src="https://apps.oneinventory.com/plugins/ezbe-chain-jquery-5s.js"&gt;&lt;/script&gt; <br>
            &emsp;&lt;script&gt;<br>
            &emsp;&emsp;create_booking_form('XXXXXX', '.booking-form', 'vi', 'VND', 'horizontal', '#ffffff', '#fc5b62');<br>
            &emsp;&lt;/script&gt;<br></i>
        </div>
        <div class="mt-3">
            <p>២. ប្រសិនបើគេហទំព័ររបស់អ្នកមាន jquery ឈ្មោះ (ករណីមានការបណ្តេញការប្រកួតគ្នា) :</p>
            <i>&emsp;&lt;script src="https://apps.oneinventory.com/plugins/ezbe-chain-5s.js"&gt;&lt;/script&gt; <br>
            &emsp;&lt;script&gt; <br>
            &emsp;&emsp;create_booking_form('XXXXXX', '.booking-form', 'vi', 'VND', 'horizontal', '#ffffff', '#fc5b62'); <br>
            &emsp;&lt;/script&gt; <br></i>
        </div>
        <br>
        <p><b>ជំហាន ៣:</b> ប្ដូរប្រភេទនៃប៉ារ៉ាម៉ែត្រ ក្នុងមុខងារ <b>create_booking_form</b> ដើម្បីត្រូវនឹងគេហទំព័ររបស់អ្នក មុនពេលរក្សាទុក។</p>
        <p class="mb-1"><b>ក្នុងនោះ៖</b></p>
        <div class="ml-3">
            <p class="mb-1"><i>XXXXXX</i> : គោលការណ៍កូដសណ្ឋាគាររបស់អ្នក (ត្រូវការប្រើ) ។</p>
            <p class="mb-1"><i>.booking-form</i> : ម្ចាស់ id (#) ឬ class (.) របស់ធាតុ HTML ដែលបានប្រកាសនៅក្នុងជំហានទី ១ (ត្រូវការប្រើ) ។</p>
            <p class="mb-1"><i>vi</i> : លេខកូដភាសាសម្រាប់បង្ហាញ (ជ្រើសរើស)។ ការគាំទ្រលេខកូដ ២៖</p>
                <p class="mb-1 ml-5"><i>vi</i> : ភាសាភូមិ</p>
                <p class="mb-1 ml-5"><i>en</i> : ភាសាអង់គ្លេស</p>
            <p class="mb-1"><i>VND</i> : កូដឯកតារូបិយវត្ថុដែលបង្ហាញនៅក្នុងម៉ាស៊ីនបញ្ជាក់ការកក់ តាមស្តង់ដាកូដរូបិយវត្ថុអន្តរជាតិ (អាចជ្រើសរើសបាន)។</p>
            <p class="mb-1"><i>horizontal</i>: រចនាប័ទ្មបង្ហាញទម្រង់ (អាចកែប្រែបាន)។ គាំទ្ររចនាប័ទ្ម ២៖</p>
            <p class="mb-1 ml-5"><i>horizontal</i>: បង្ហាញជារចនាប័ទ្មផ្នែកខាងលើ</p>
            <p class="mb-1 ml-5"><i>vertical</i>: បង្ហាញជារចនាប័ទ្មផ្នែកក្បាល</p>  
            <p class="mb-1"><i>#ffffff</i> : លេខកូដពណ៌សម្រាប់អត្ថបទប៊ូតុងស្វែងរកបន្ទប់ (ជ្រើសរើស) ។</p>
            <p class="mb-1"><i>#fc5b62</i> : លេខកូដពណ៌ខាងក្រោយប៊ូតុងស្វែងរកបន្ទប់ (ជ្រើសរើស) ។</p>
        </div>
        <hr>
        <p class="fs-14"><b>វិធីសាស្ត្រ ២: ការបញ្ចូលប្រើតំណភ្ជាប់ URL</b></p>
        <p>ប្រើ URL ដើម្បីភ្ជាប់ទៅនឹងប៊ូតុង ឬអត្ថបទភ្ជាប់។ ប្រើ URL ខាងក្រោម៖</p>
        <div>
            <i>https://booking.ezcms.vn/hotel/BeDetailHotel?hotel_code=XXXXXX&check_in=2020-11-30&check_out=2020-12-01&num_of_rooms=1&num_of_adults=2&num_of_children=0&promo_code=&rate_code=&room_code=&lang=vi&amp;currency=VND</i>
        </div>
        <br>
        <p class="mb-1"><b>ក្នុងនោះ៖</b></p>
        <div class="ml-3">
            <p class="mb-1"><i>hotel_code</i>: លេខកូដសណ្ឋាគារ (ត្រូវការប្រើ)</p>
            <p class="mb-1"><i>check_in</i>: ថ្ងៃបញ្ជូនមក (ទ្រង់ទ្រាយ YYYY-MM-DD) (ជ្រើសរើស)</p>
            <p class="mb-1"><i>check_out</i>: ថ្ងៃចាកចេញ (ទ្រង់ទ្រាយ YYYY-MM-DD) (ជ្រើសរើស)</p>
            <p class="mb-1"><i>num_of_rooms</i>: ចំនួនបន្ទប់ (ជ្រើសរើស)</p>
            <p class="mb-1"><i>num_of_adults</i>: ចំនួនមនុស្សធំ (ជ្រើសរើស)</p>
            <p class="mb-1"><i>num_of_children</i>: ចំនួនកុមារ (ជ្រើសរើស)</p>
            <p class="mb-1"><i>room_code</i>: លេខកូដបន្ទប់ (ជ្រើសរើស)</p>
            <p class="mb-1"><i>rate_code</i>: លេខកូដយ៉ាងម៉ាក (ជ្រើសរើស)</p>
            <p class="mb-1"><i>promo_code</i>: លេខកូដផ្សព្វផ្សាយ (ជ្រើសរើស)</p>
            <p class="mb-1"><i>lang</i> : លេខកូដភាសាសម្រាប់បង្ហាញ (ជ្រើសរើស)</p>
            <p class="mb-1"><i>currency</i> : លេខកូដសញ្ញាហិរញ្ញវត្ថុ ដែលបង្ហាញ (ជ្រើសរើស)</p>
        </div>
        <hr>
        <p class="fs-14"><b>វិធីទី ៣៖ រួមបញ្ចូលដោយផ្ទាល់ទៅក្នុងគេហទំព័ររបស់សណ្ឋាគារ</b></p>
        <p>មុខងារនេះអនុញ្ញាតឲ្យអ្នករួមបញ្ចូល Booking Engine ជាមួយគេហទំព័រ។ ជាក់លាក់គឺបង្ហាញបញ្ជីបន្ទប់ពី Booking Engine លើគេហទំព័រសណ្ឋាគារ។</p>
        <p class="mb-3">
            <b>ជំហានទី ១៖</b> ចម្លង đoạn HTML ឧទាហរណ៍ខាងក្រោម ហើយដាក់វានៅទីតាំងដែលអ្នកចង់បង្ហាញបែបបទកក់បន្ទប់លើគេហទំព័រ។<br/>
            <i>&lt;div class="booking-form"&gt;&lt;/div&gt;</i>
        </p>
        <p class="mb-3">
            <b>ជំហានទី ២៖</b> ចម្លង đoạn script ឧទាហរណ៍ខាងក្រោម ហើយដាក់វានៅផ្នែកបាតគេហទំព័រ (មុន tag បិទ body)។<br/>
            <i> &emsp;&lt;script src="https://app.oneinventory.com/booking-engine/plugins/ezbe-embed.js"&gt;&lt;/script&gt; <br>
                &emsp;&lt;script&gt;<br>
                &emsp;&emsp;window.initBookingForm({<br>
                &emsp;&emsp;&emsp; hotel: [{ hotelName: 'Hotel A', hotelCode: 'KSA' }],<br> 
                &emsp;&emsp;&emsp; target: '.booking-form',<br>
                &emsp;&emsp;&emsp; path: '/room-list',<br>
                &emsp;&emsp;&emsp; lang: 'km',<br>
                &emsp;&emsp;&emsp; background: '#ffffff',<br>
                &emsp;&emsp;&emsp; buttonBackground: '#ff0000',<br>
                &emsp;&emsp;&emsp; buttonTextColor: 'white',<br>
                &emsp;&emsp;&emsp; textColor: '#333333'<br>
                &emsp;&emsp; });<br>
                &emsp;&lt;/script&gt;<br>
            </i>
        </p>
        <p class="mb-0">
            <b>ជំហានទី ៣៖</b> ប្តូរតម្លៃ參數នៅក្នុង <b>window.initBookingForm</b> ឲ្យសមស្របនឹងគេហទំព័រសណ្ឋាគារមុនពេលរក្សាទុក។
        </p>
        <div class="ml-3">
            <p class="mb-0"><b>ពិពណ៌នា៖</b></p>
            <p class="mb-1">
                - <i>hotel</i>៖ ជាបញ្ជីសណ្ឋាគារ។ អាចមាន ១ ឬច្រើន។ សណ្ឋាគរនីមួយត្រូវកំណត់ជាអOBJECT មួយ។ (ចាំបាច់)<br/>
                <span style="padding-left: 12px;"><i>hotelName</i> ៖ ឈ្មោះសណ្ឋាគារ។</span><br/>
                <span style="padding-left: 12px;"><i>hotelCode</i> ៖ កូដសណ្ឋាគារ។</span><br/>
            </p>
            <p class="mb-1">
                - <i>target</i> ៖ គឺជា ID (#) ឬ class (.) របស់ thẻ HTML ដែលបានកំណត់នៅជំហានទី ១ (ចាំបាច់)។
            </p>
            <p class="mb-1">
                - <i>path</i> ៖ ជាផ្លូវទៅកាន់ទំព័រដែលបង្ហាញបញ្ជីបន្ទប់។ ប្រសិនបើមិនកំណត់នឹងទៅគេហទំព័រដើម <code>https://booking.ezcms.vn</code> (ជ្រើសរើស)។
            </p>
            <p class="mb-1">
                - <i>lang</i> ៖ ភាសាដែលបង្ហាញនៅលើបែបបទ និងបញ្ជីបន្ទប់។ ប្រសិនបើមិនកំណត់នឹង默認ជា ភាសាវៀតណាម (ជ្រើសរើស)។<br/>
                <span style="padding-left: 12px;"><b>គាំទ្រ ៧ ភាសា៖</b></span><br/>
                <span style="padding-left: 12px;"><i>vi</i> ៖ វៀតណាម</span><br/>
                <span style="padding-left: 12px;"><i>en</i> ៖ អង់គ្លេស</span><br/>
                <span style="padding-left: 12px;"><i>ja</i> ៖ ជប៉ុន</span><br/>
                <span style="padding-left: 12px;"><i>ko</i> ៖ កូរ៉េ</span><br/>
                <span style="padding-left: 12px;"><i>lo</i> ៖ ឡាវ</span><br/>
                <span style="padding-left: 12px;"><i>km</i> ៖ ខ្មែរ</span><br/>
                <span style="padding-left: 12px;"><i>zh</i> ៖ ចិន</span><br/>
                <span style="padding-left: 12px;"><b>ចំណាំ ៖</b> ប្រសិនបើគេហទំព័រមិនបានកំណត់ភាសាដែលបានជ្រើសនៅទីនេះទេ នឹងបង្ហាញជាភាសាអង់គ្លេសជំនួស។</span>
            </p>   
            <p class="mb-1">
                - <i>background</i> ៖ ពណ៌ផ្ទៃបែបបទ។ 默認 ៖ #eee (ជ្រើសរើស)។
            </p>
            <p class="mb-1">
                - <i>buttonTextColor</i> ៖ ពណ៌អក្សរនៅលើប៊ូតុង "ស្វែងរកបន្ទប់"។ 默認 ៖ #fff (ជ្រើសរើស)។
            </p>
            <p class="mb-1">
                - <i>buttonBackground</i> ៖ ពណ៌ផ្ទៃប៊ូតុង "ស្វែងរកបន្ទប់"។ 默認 ៖ ក្រហម (ជ្រើសរើស)។
            </p>
            <p class="mb-1">
                - <i>textColor</i> ៖ ពណ៌អក្សរនៅក្នុងបែបបទ។ 默認ជា browser (ជ្រើសរើស)។
            </p>  
        </div>
        <p class="mt-3 mb-0">
            <b>ជំហានទី ៤៖</b> នៅលើទំព័រដែលបង្ហាញបញ្ជីបន្ទប់របស់សណ្ឋាគារ (បានកំណត់នៅ path នៅជំហានទី ៣)
        </p>
        <p class="mb-0">
            ចម្លង đoạn HTML ខាងក្រោម ហើយដាក់វានៅទីតាំងដែលអ្នកចង់បង្ហាញបញ្ជីបន្ទប់។<br/>
            <i>&lt;div id="room-list"&gt;&lt;/div&gt;</i>
        </p>
        <p class="mb-3">
            ចម្លង đoạn script ខាងក្រោម ហើយដាក់វានៅផ្នែកបាតគេហទំព័រ (មុន body)។<br/>
            <i> &emsp;&lt;script src="https://app.oneinventory.com/booking-engine/plugins/ezbe-embed.js"&gt;&lt;/script&gt; <br>
                &emsp;&lt;script&gt;<br>
                &emsp;&emsp;window.initBookingEngine({<br>
                &emsp;&emsp;&emsp; target: '#room-list',<br>
                &emsp;&emsp;&emsp; scrollToTop: true,<br>
                &emsp;&emsp;&emsp; marginTop: 0<br>
                &emsp;&emsp;});<br>
                &emsp;&lt;/script&gt;<br>
            </i>
        </p>
        <p class="mb-0">
            <b>ជំហានទី ៥៖</b> ប្ដូរតម្លៃ參數នៅក្នុង <b>window.initBookingEngine</b> មុនពេលរក្សាទុក។
        </p>
        <div class="ml-3">
            <p class="mb-0"><b>ពិពណ៌នា៖</b></p>
            <p class="mb-1">
                - <i>target</i> ៖ ID (#) ឬ class (.) របស់ thẻ HTML នៅជំហានទី ៤ (ចាំបាច់)។
            </p>
            <p class="mb-1">
                - <i>scrollToTop</i> ៖ បង្ហាញរូបតំណាង scroll-up បើ scroll ចុះក្រោម 500px។ ចុចវាដើម្បីឡើងដល់ខាងលើ។ 默認៖ false (ជ្រើសរើស)។
            </p>
            <p class="mb-1">
                - <i>marginTop</i> ៖ បង្កើតចន្លោះពីផ្នែកខាងលើ។ គោលបំណងគឺដើម្បីចៀសវាងមិនឲ្យមាតិកាត្រូវបានគ្របដោយធាតុថេរនៅខាងលើ ដូចជាក្បាលទំព័រថេរនៅលើគេហទំព័រ (ជាជម្រើស)។
            </p>
        </div>
        <p style="margin-top: 10px;"><b>ចូលមើលទំព័រឧទាហរណ៍ </b><a href="https://app.oneinventory.com/booking-engine" target="_blank">នៅទីនេះ</a></p>`,
    },
    CONFIRM_TRANET_CONNECT: `{roomConfirm} លើសចំនួនអតិបរមា 18 នាក់។ ប្រសិនបើអ្នកចុចផែនទី អាចមានកំហុស <span class="font-weight-bold">បរាជ័យក្នុងការចងផែនទី</span>។ សូមពិនិត្យម្តងទៀត។`,
    _PROMOTION: {
        MEALS: {
            BREAKFAST: "អាហារពេលព្រឹក",
            LUNCH: "អាហារពេលថ្ងៃត្រង់",
            DINNER: "អាហារពេលល្ងាច",
        },
        PROMOTION_TYPE_LIST: {
            EVERY_NIGHT: "រៀងរាល់យប់",
            TOTAL_BOOKING: "តម្លៃការកក់សរុប",
            ORDER_BEFORE: "បញ្ជាទិញមុនថ្ងៃចូលស្នាក់ x ថ្ងៃ",
            ORDER_WITHIN: "បញ្ជាទិញក្នុងរយៈពេល x ថ្ងៃមុនថ្ងៃចូលស្នាក់",
            FREE_QUANTITY: "បញ្ជាទិញចំនួន x ដល់បានឥតគិតថ្លៃ y",
            FREE_ON_TOTAL_VALUE: "បញ្ជាទិញចំនួន x ដល់បានឥតគិតថ្លៃ y ពីតម្លៃសរុប",
        },
        DISCOUNT_LIST: {
            DISCOUNT: "បញ្ចុះតម្លៃ",
            SURCHARGE: "ថ្លៃបន្ថែម",
        },
        TARGET_APPLY_LIST: {
            BY_AGENT_LEVEL: "តាមកម្រិតភ្នាក់ងារ",
            BY_AGENT: "តាមភ្នាក់ងារ",
        },
        LEVEL_TARGET_APPLY: {
            LEVEL_1: "កម្រិត 1",
            LEVEL_2: "កម្រិត 2",
            LEVEL_3: "កម្រិត 3",
            LEVEL_4: "កម្រិត 4",
            LEVEL_5: "កម្រិត 5",
        }
    },
    UTM_CODE: "កូដ UTM",
    ZOOM: "ហ្ស៊ុំ",
    NOTIFICATIONS: "ការជូនដំណឹង",
    AGENTS_CONTRACT: "កិច្ចសន្យាតំណាងការកក់បន្ទប់",
    BELONG_AGENT: "ជារបស់តំណាង",
    HOTEL_LOG_coupon: "កូដបញ្ចុះតម្លៃ",
    ACCOUNT_IS_NOT_CONNECTED_TO_TRAVELOKA: "គណនីមិនបានភ្ជាប់ជាមួយ ezCms Traveloka ទេ",
    SUN: "អាទិត្យ",
    MON: "ច័ន្ទ",
    TUE: "អង្គារ",
    WED: "ពុធ",
    THU: "ព្រហស្បតិ៍",
    FRI: "សុក្រ",
    SAT: "សៅរ៍",
    UNDER_MAX_GUEST: "ចំនួនភ្ញៀវលើសពីចំនួនអតិបរមាដែលបានកំណត់ក្នុងគោលនយោបាយតម្លៃ",
    SAVE_RESULTS_WHEN_MAKING_CHANGES: "រក្សាទុកលទ្ធផលបន្ទាប់ពីធ្វើការផ្លាស់ប្តូរ",
    $vuetify: {
        badge: 'ផ្លាកសញ្ញា',
        close: 'បិទ',
        dataIterator: {
            noResultsText: 'រកមិនឃើញទិន្នន័យដែលផ្គូផ្គង',
            loadingText: 'កំពុងផ្ទុកទិន្នន័យ...'
        },
        dataTable: {
            itemsPerPageText: 'ជួរដេកក្នុងមួយទំព័រ៖',
            ariaLabel: {
                sortDescending: 'តម្រៀបចុះក្រោម។',
                sortAscending: 'តម្រៀបឡើងលើ។',
                sortNone: 'មិនបានតម្រៀប។',
                activateNone: 'ចុចដើម្បីលុបការតម្រៀប។',
                activateDescending: 'ចុចដើម្បីតម្រៀបចុះក្រោម។',
                activateAscending: 'ចុចដើម្បីតម្រៀបឡើងលើ។'
            },
            sortBy: 'តម្រៀបតាម'
        },
        dataFooter: {
            itemsPerPageText: 'ធាតុក្នុងមួយទំព័រ៖',
            itemsPerPageAll: 'ទាំងអស់',
            nextPage: 'ទំព័របន្ទាប់',
            prevPage: 'ទំព័រមុន',
            firstPage: 'ទំព័រដំបូង',
            lastPage: 'ទំព័រចុងក្រោយ',
            pageText: '{0}-{1} នៃ {2}'
        },
        datePicker: {
            itemsSelected: 'បានជ្រើសរើស {0}',
            nextMonthAriaLabel: 'ខែបន្ទាប់',
            nextYearAriaLabel: 'ឆ្នាំបន្ទាប់',
            prevMonthAriaLabel: 'ខែមុន',
            prevYearAriaLabel: 'ឆ្នាំមុន'
        },
        noDataText: 'គ្មានទិន្នន័យ',
        carousel: {
            prev: 'រូបភាពមុន',
            next: 'រូបភាពបន្ទាប់',
            ariaLabel: {
                delimiter: 'ស្លាយទី {0} នៃ {1}'
            }
        },
        calendar: {
            moreEvents: '{0} បន្ថែមទៀត'
        },
        input: {
            clear: 'សម្អាត {0}',
            prependAction: 'សកម្មភាពជាមុន {0}',
            appendAction: 'សកម្មភាពបន្ថែម {0}'
        },
        fileInput: {
            counter: '{0} ឯកសារ',
            counterSize: '{0} ឯកសារ (សរុប {1})'
        },
        timePicker: {
            am: 'ព្រឹក',
            pm: 'ល្ងាច'
        },
        pagination: {
            ariaLabel: {
                wrapper: 'ការរុករកទំព័រ',
                next: 'ទំព័របន្ទាប់',
                previous: 'ទំព័រមុន',
                page: 'ទៅកាន់ទំព័រ {0}',
                currentPage: 'ទំព័របច្ចុប្បន្ន, ទំព័រ {0}'
            }
        },
        rating: {
            ariaLabel: {
                icon: 'ការវាយតម្លៃ {0} នៃ {1}'
            }
        },
        loading: 'កំពុងផ្ទុក...'
    },
    DAYS_OF_WEEK: {
        SUN: "អា",
        MON: "ច",
        TUE: "អ",
        WED: "ព",
        THU: "ព្រ",
        FRI: "សុ",
        SAT: "សៅ",
    },
    URL_INVALID: "URL មិនត្រឹមត្រូវទេ",
    SELECT_ROOM_TYPE: "ជ្រើសប្រភេទបន្ទប់",
    OTA_CONNECTION_ERROR: "កំហុសការតភ្ជាប់ OTA",
    ROOM_RATE_TYPE: "ប្រភេទបន្ទប់ {room} គោលនយោបាយតម្លៃ {rate}",
    NOT_MATCH_GUEST_COUNT: "ចំនួនអ្នកស្នាក់នៅរវាង ezCrs និង Traveloka មិនដូចគ្នា",
    STAFF_MANAGEMENT: "ការគ្រប់គ្រងបុគ្គលិក",
    FUNCTION_MANAGEMENT: "ការគ្រប់គ្រងមុខងារ",
    SETUP_RATE_TYPE: "បញ្ជាក់ប្រភេទអត្រាបញ្ជូនពីឆានែលទៅកាន់ CM",
    INCLUDE_COMMISSION: "រួមបញ្ចូលកម្រៃជើងសារ",
    EXCLUDE_COMMISSION: "មិនរួមបញ្ចូលកម្រៃជើងសារ",
    UNDEFINED_COMMISSION: "មិនបានកំណត់",
    EXTRA_DATA_TO_OTA: "កំណត់ប្រភេទតម្លៃដែលផ្ញើពីឆានែលទៅ CM។",
    ROOM_TYPE_SYNCED: "ប្រភេទបន្ទប់នេះត្រូវបានភ្ជាប់ជាមួយ OTA សូមពិនិត្យម្តងទៀត។",
    MANDATORY_LANGUAGE_REQUIRED: "ត្រូវតែជ្រើសរើសភាសាខ្មែរនិងភាសាអង់គ្លេស។",
    TOOLTIP_TOGGLE_LANGUAGE: "នៅពេលផ្លាស់ប្តូរភាសាបង្ហាញ សូមធ្វើបច្ចុប្បន្នភាពវាលភាសាច្រើនផងដែរ ឧទាហរណ៍៖ ឈ្មោះប្រភេទបន្ទប់ ឈ្មោះគោលការណ៍ ល។",
    TOOLTIP_INCLUDE_COMMISSION: `
        <span class="font-weight-bold fs-13">-ការកំណត់៖ មិនរួមបញ្ចូលកម្រៃជើងសារ</span> – ប្រសិនបើឆានែលជាអ្នកទទួលការទូទាត់ ហើយប្រព័ន្ធមានទិន្នន័យគ្រប់គ្រាន់ ezCrs នឹងគណនាតម្លៃបន្ទប់ឡើងវិញ។<br/>
        <span class="font-weight-bold fs-13">-ការកំណត់៖ រួមបញ្ចូលកម្រៃជើងសារ</span> – ezCrs នឹងរក្សាតម្លៃបន្ទប់ដូចដែលឆានែលបានផ្ញើមក។<br/>
        <span class="font-weight-bold fs-13">-ការកំណត់៖ មិនបានកំណត់</span> – ប្រើនៅពេលប្រព័ន្ធមិនអាចកំណត់បានថាតម្លៃដែលឆានែលផ្ញើមកមានបញ្ចូលកម្រៃជើងសាររួចហើយឬនៅ។
        ក្នុងករណីនេះ វាល <span class="font-weight-bold fs-13">រួមបញ្ចូលកម្រៃជើងសារ</span> និង <span class="font-weight-bold fs-13">មិនរួមបញ្ចូលកម្រៃជើងសារ</span> ទាំងពីរ នឹងត្រូវបានបង្ហាញជា <span class="font-weight-bold fs-13">មិនបានកំណត់</span>។`,
    TOOLTIP_INCLUDE_COMMISSION_AGODA: `
        <span class="font-weight-bold fs-13">-ការកំណត់៖ រួមបញ្ចូលកម្រៃជើងសារ</span> – ប្រសិនបើប្រព័ន្ធមានទិន្នន័យគ្រប់គ្រាន់ ezCrs នឹងគណនាតម្លៃបន្ទប់សម្រាប់ការកក់ឡើងវិញ។<br/>
        <span class="font-weight-bold fs-13">-ការកំណត់៖ មិនរួមបញ្ចូលកម្រៃជើងសារ</span> – ezCrs នឹងរក្សាតម្លៃបន្ទប់ដូចដែលឆានែលបានផ្ញើមក។<br/>
        <span class="font-weight-bold fs-13">-ការកំណត់៖ មិនបានកំណត់</span> – ប្រើនៅពេលប្រព័ន្ធមិនអាចកំណត់បានថាតម្លៃដែលឆានែលផ្ញើមកមានបញ្ចូលកម្រៃជើងសាររួចហើយឬនៅ។ ក្នុងករណីនេះ
        វាល <span class="font-weight-bold fs-13">រួមបញ្ចូលកម្រៃជើងសារ</span> និង <span class="font-weight-bold fs-13">មិនរួមបញ្ចូលកម្រៃជើងសារ</span> ទាំងពីរ នឹងត្រូវបានបង្ហាញជា <span class="font-weight-bold fs-13">មិនបានកំណត់</span>។`,
    INPUT_INVALID: "លើសចំនួនអតិបរមា",
    GOOGLE_NOTE: "<strong>ចំណាំ៖</strong> យោងតាមបទប្បញ្ញត្តិថ្មីបំផុតរបស់ Google សណ្ឋាគារដែលប្រើ Google Hotel ត្រូវតែធ្វើបច្ចុប្បន្នភាពទិន្នន័យ <strong>ពន្ធ និងថ្លៃសេវា</strong>។ ដើម្បីធានាបាននូវសុពលភាពនៃប្រព័ន្ធ និងបញ្ចៀសការកើតមានកំហុស ប្រព័ន្ធត្រូវតែមាន <strong>ពន្ធ ឬថ្លៃសេវា​យ៉ាងហោចណាស់​មួយ ដែលមានតម្លៃធំជាង 0</strong>។",
    INVOICE_REQUEST: "សំណើវិក្កយបត្រ",
    COMPANY_NAME_OR_BOOKER: "ឈ្មោះក្រុមហ៊ុន/អ្នកកក់",
    HIDE_INFORMATION: "(លាក់ព័ត៌មាន)",
    SHOW_INFORMATION: "(បង្ហាញព័ត៌មាន)",
    MODULE_EZ_PROMOTION_NOT_ACTIVE: "ម៉ូឌុលផ្សព្វផ្សាយពាណិជ្ជកម្មមិនកំពុងដំណើរការ",
    INCLUDE_COMMISSION_RATE: "រួមបញ្ចូលកម្រៃជើងសារ",
    EXCLUDE_COMMISSION_RATE: "មិនរួមបញ្ចូលកម្រៃជើងសារ",
    COMMISSION_RATE_NOTE: "ចំណាំ៖ ទិន្នន័យកម្រៃជើងសាររួមបញ្ចូល និងមិនរួមបញ្ចូលគឺសម្រាប់ជាឯកសារយោងតែប៉ុណ្ណោះ",
    SETUP_RATE_TYPE_NOTE: "សេចក្ដីជូនដំណឹង៖ការកែប្រែការកំណត់ “បញ្ជាក់ប្រភេទអត្រាបញ្ជូនពីឆានែលទៅកាន់ CM” អាចអនុវត្តបាន តែប៉ុណ្ណោះ នៅពេលប្រព័ន្ធមានយ៉ាងហោចណាស់បន្ទប់ប្រភេទ ១ (01) ដែលបានភ្ជាប់ជោគជ័យទៅកាន់ Channel ដែលពាក់ព័ន្ធ។",
}